document.addEventListener('turbolinks:load', function () {
  const ERROR_MSG = 'エラー！　処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;
  // ! 本番と開発環境で異なるため注意!!
  // const S3_MEDIA_URL = 'https://d33l209u0sdjqk.cloudfront.net'; // 開発
  // const S3_MEDIA_URL = 'https://media.platta.jp'; // 本番

  // const S3_MEDIA_URL = 'https://platta-dev.s3.ap-northeast-1.amazonaws.com'; // 開発
  // const S3_MEDIA_URL = 'https://platta-pro.s3.ap-northeast-1.amazonaws.com'; // 本番

  const S3_MEDIA_URL = $('#pl_s3_media_domain').val();

  const DOMAIN = $('#pl_domain').val();

  // ハッシュタグ検索の初期の画面でフィルターをかける処理
  let current_url = window.location.href;

  //*********************************************************************
  // 初期処理系
  //*********************************************************************
  //############################################################
  // フォーカス
  //############################################################
  if (location.pathname == '/new' || location.pathname == '/login' || location.pathname == '/') {
    $("input[type='text']:visible").eq(0).focus();
  }

  //############################################################
  // エンター押下
  //############################################################
  $(document).keypress(function (e) {
    if (e.keyCode == 13 && e.target.nodeName !== 'TEXTAREA') {
      $('.enter').click();
      return false;
    }
  });

  //############################################################
  // フラッシュメッセージフェードアウト
  //############################################################
  setTimeout(function() {
    $('#flash-message').fadeOut('slow');
  }, 3000);

  //############################################################
  // スペーストリム
  //############################################################
  $('input,textarea').on('blur', function () {
    $('input,textarea').each(function (i, e) {
      $(e).val($.trim($(e).val()));
    });
    $("input[type='text']").trigger('keyup');
    $("input[type='email']").trigger('keyup');
    $('textarea').trigger('keyup');
  });

  //############################################################
  // ベースレイアウトの切り替え
  //############################################################
  $('.to_chat_bot').on('click', function () {
    $.ajax({
      url: DOMAIN + '/change_chat_bot_layout',
      type: 'GET',
      data: {},
      dataType: 'json',
    }).done(function (data) {
      location.href = '/';
    });
  });

  $('.to_smm').on('click', function () {
    $.ajax({
      url: DOMAIN + '/change_smm_layout',
      type: 'GET',
      data: {},
      dataType: 'json',
    }).done(function (data) {
      location.href = '/';
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // ガイドフロー
  //-----------------------------------------------------------------------------------------------------------------
  //############################################################
  // ガイドフロー 次のページフォームを表示
  //############################################################
  $('.next_page').on('click', function () {
    let next_page = $(this).data('page');
    let this_action = $(this).data('action');
    $('#page-' + next_page).fadeIn(360);
    $('#next_action_select-wrapper_' + (next_page * 1 - 1) + '_' + this_action).slideUp(500);
    $('html, body').animate(
      {
        scrollTop: $(window).scrollTop() + 260,
      },
      500,
      'swing'
    );
  });
  //############################################################
  // ガイドフロー 次のアクションフォームを表示
  //############################################################
  $('.next_action').on('click', function () {
    let this_page = $(this).data('page');
    let next_action = $(this).data('action');
    $('#action-' + this_page + '-' + next_action).fadeIn(360);
    $('#next_action_select_wrapper_' + this_page + '_' + (next_action * 1 - 1)).slideUp(500);
    $('html, body').animate(
      {
        scrollTop: $(window).scrollTop() + 260,
      },
      500,
      'swing'
    );
  });
  //############################################################
  // ガイドフロー登録
  //############################################################
  $('#create_guide').on('click', function () {
    let pages = [];
    let actions = {};
    for (let i = 1; i <= 10; i++) {
      let urls = [];
      if ($('#page_' + i).is(':visible')) {
        if ($('#url_' + i).val() != '') {
          urls.push($('#url_' + i).val());
          pages.push(urls);
        } else {
          break;
        }
      } else {
        break;
      }
      for (let j = 1; j <= 10; j++) {
        let guide_no = i + '-' + j;
        if ($('#action_' + guide_no).is(':visible') && $('#obj_' + guide_no).val() != '') {
          actions[guide_no] = {};
          actions[guide_no]['obj'] = $('#obj_' + guide_no).val();
          actions[guide_no]['message'] = $('#message_' + guide_no).val();
        } else {
          break;
        }
      }
    }

    if (!confirm('この内容でガイドフローを作成しますか？')) {
      return;
    }
    $('#create_guide').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/create_guide',
      type: 'POST',
      data: {
        name: $('#name').val(),
        pages: pages,
        actions: actions,
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 0) {
          alert('OK');
        }
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('#create_guide').css('pointer-events', 'auto');
      });
  });

  //############################################################
  // ガイドフロー 一覧表示
  //############################################################
  $('.delete').on('click', function () {
    if (!confirm(`フロー${$(this).data('num')}を削除しますか？`)) {
      return;
    }
    $('.delete').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/delete_flow',
      type: 'POST',
      data: {
        id: $(this).data('val'),
      },
      dataType: 'json',
    })
      .done(function () {
        alert('OK');
        $('.delete').css('pointer-events', 'auto');
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('.delete').css('pointer-events', 'auto');
      });
  });

  //############################################################
  // ガイドフローの管理　トップページのグラフ選択
  //############################################################
  $('.flow_cv').on('click', function () {
    $(this).css('background-color', '#ffffd5');
    $('.flow_start').css('background-color', 'white');
    $('.next_click').css('background-color', 'white');
    $('.show_action').css('background-color', 'white');
    $('.flow_cv_chart').css('display', 'block');
    $('.flow_start_chart').css('display', 'none');
    $('.next_click_chart').css('display', 'none');
    $('.show_action_chart').css('display', 'none');
  });
  $('.flow_start').on('click', function () {
    $('.flow_cv').css('background-color', 'white');
    $(this).css('background-color', '#ffffd5');
    $('.next_click').css('background-color', 'white');
    $('.show_action').css('background-color', 'white');
    $('.flow_cv_chart').css('display', 'none');
    $('.flow_start_chart').css('display', 'block');
    $('.next_click_chart').css('display', 'none');
    $('.show_action_chart').css('display', 'none');
  });
  $('.next_click').on('click', function () {
    $('.flow_cv').css('background-color', 'white');
    $('.flow_start').css('background-color', 'white');
    $(this).css('background-color', '#ffffd5');
    $('.show_action').css('background-color', 'white');
    $('.flow_cv_chart').css('display', 'none');
    $('.flow_start_chart').css('display', 'none');
    $('.next_click_chart').css('display', 'block');
    $('.show_action_chart').css('display', 'none');
  });
  $('.show_action').on('click', function () {
    $('.flow_cv').css('background-color', 'white');
    $('.flow_start').css('background-color', 'white');
    $('.next_click').css('background-color', 'white');
    $(this).css('background-color', '#ffffd5');
    $('.flow_cv_chart').css('display', 'none');
    $('.flow_start_chart').css('display', 'none');
    $('.next_click_chart').css('display', 'none');
    $('.show_action_chart').css('display', 'block');
  });

  //-----------------------------------------------------------------------------------------------------------------
  // 管理者ログイン
  //-----------------------------------------------------------------------------------------------------------------
  //############################################################
  // admin_login
  //############################################################
  $('.admin_login_button').on('click', function () {
    $('.admin_login_button').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/application/admin_login',
      type: 'POST',
      data: {
        id: $(this).data('val'),
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 1) {
          location.href = '/';
        }
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('#login').css('pointer-events', 'auto');
      });
  });

  $('#admin_report_ym').on('change', function () {
    let href = '/admin_report';
    href += `?ym=${$('#admin_report_ym').val()}`;
    location.href = href;
  });

  $('#admin_create_account').on('click', function () {
    let login_name = $('#create_login_name').val();
    let company_name = $('#create_company_name').val();

    let service_flag;
    let is_smm_checkbox = $('.platta_smm_checkbox').is(':checked');
    let is_ai_checkbox = $('.edit_ai_checkbox').is(':checked');

    if (is_smm_checkbox && is_ai_checkbox) {
      // SMMとレコメンド
      service_flag = 4;
    } else if (is_smm_checkbox) {
      // SMMのみ
      service_flag = 1;
    } else if (is_ai_checkbox) {
      // レコメンドのみ
      service_flag = 3;
    } else {
      // 利用なし
      service_flag = 0;
    }

    // 空の入力フィールドのバリデーション
    if (!login_name || !company_name) {
      alert('すべてのフィールドを入力してください');
      return;
    }

    $.ajax({
      url: DOMAIN + '/application/admin_create_account',
      type: 'POST',
      data: {
        login_name: login_name,
        company_name: company_name,
        service_flag: service_flag,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        $('#platta_customer_login_id').val(data.login_name);
        $('#platta_customer_dir_key').val(data.dir_key);
        $('#platta_customer_login_password').val(data.password);

        $('#normal_tag').val('<script type="text/javascript" src="https://front.platta.jp/tag/' + data.account.login_name + '.js"></script>');
        $('#cv_tag').val('<script type="text/javascript" src="https://front.platta.jp/cv_tag/' + data.account.login_name + '.js"></script>');
        $('#create_tab_modal').css('display', 'block');
        $('#create_tab_modal_container').css('display', 'block');

        $('#create_tab_modal, #create_tab_modal_close').on('click', function () {
          location.reload();
        });

        $('#create_tab_modal_reload_button').on('click', function () {
          location.reload();
        });
      }
    });
  });

  $('#admin_pv_select').on('change', function () {
    let ym = $('#admin_pv_select option:selected').val();
    let href = '/admin_pv_report';
    href += `?year_month=${ym}`;
    location.href = href;
  });

  $('.admin_customer_list_name').on('click', function () {
    let account_id = $(this).data('id');
    let login_name = $(this).data('login_name');
    let company_name = $(this).data('company_name');
    let service_flag = $(this).data('service_flag');

    $('.edit_smm_checkbox').prop('checked', false);
    $('.edit_cx_checkbox').prop('checked', false);
    $('.edit_ai_checkbox').prop('checked', false);

    $('#edit_login_name').val(login_name);
    $('#edit_company_name').val(company_name);

    $('#edit_account_id').val(account_id);

    if (service_flag == 4 || service_flag == 999) {
      $('.edit_smm_checkbox').prop('checked', true);
      $('.edit_ai_checkbox').prop('checked', true);
    } else if (service_flag == 1) {
      $('.edit_smm_checkbox').prop('checked', true);
    } else if (service_flag == 3) {
      $('.edit_ai_checkbox').prop('checked', true);
    }
  });

  $('#admin_edit_account').on('click', function () {
    let account_id = $('#edit_account_id').val();
    let company_name = $('#edit_company_name').val();

    let service_flag;
    let is_smm_checkbox = $('.edit_smm_checkbox').is(':checked');
    let is_ai_checkbox = $('.edit_ai_checkbox').is(':checked');

    if (is_smm_checkbox && is_ai_checkbox) {
      // SMMとCXとレコメンド
      service_flag = 4;
    } else if (is_smm_checkbox) {
      // SMMのみ
      service_flag = 1;
    } else if (is_ai_checkbox) {
      // レコメンドのみ
      service_flag = 3;
    } else {
      // 利用なし
      service_flag = 0;
    }

    // 空の入力フィールドのバリデーション
    if (!company_name) {
      alert('すべてのフィールドを入力してください');
      return;
    }

    $.ajax({
      url: DOMAIN + '/application/admin_edit_account',
      type: 'POST',
      data: {
        account_id: account_id,
        company_name: company_name,
        service_flag: service_flag,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  $('.parent_checkbox').on('change', function () {
    let recommend_item_id = $(this).data('id');
    let account_id = $('.admin_associate_container').data('ac');

    if ($(this).is(':checked')) {
      // このチェックボックス以外のすべてのチェックボックスを無効にする
      $('.parent_checkbox').not(this).prop('disabled', true);

      let el = `<div class="admin_child_associate_item_container hidden sticky top-0 h-[82vh] overflow-auto w-auto max-w-600px mb-10">
                  <div class="bg-white p-2 dark:bg-gray-900">
                    <table class="admin_child_associate_item table table-zebra text-gray-600 auto mx-auto">
                      <tr>
                        <th class="whitespace-nowrap py-1 px-2 bg-base-200 dark:bg-dark_base">子選択</th>
                        <th class="whitespace-nowrap py-1 px-2 bg-base-200 dark:bg-dark_base">画像</th>
                        <th class="whitespace-nowrap py-1 px-2 bg-base-200 dark:bg-dark_base">商品名</th>
                      </tr>
                    </table>
                  </div>
                </div>`;

      $('.admin_associate_container').append(el);

      $.ajax({
        url: '/application/get_child_item_list',
        type: 'GET',
        data: {
          account_id: account_id,
          recommend_item_id: recommend_item_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == 0) {
          $.each(data.parent_items, function (index, parent_item) {
            let isChecked = data.child_items.some((child_item) => child_item.related_item_id === parent_item.id);
            $('.admin_child_associate_item').append(
              `<tr>
                <td class="whitespace-nowrap py-1 px-2 text-center"><input type="checkbox" class="child_checkbox checkbox checkbox-xs" data-id="${parent_item.id}" ${isChecked ? 'checked' : ''}/></td>
                <td class="whitespace-nowrap py-1 px-2 "><img class="h-50px w-50px" src="${parent_item.image_url}" alt="""></td>
                <td class="whitespace-nowrap py-1 px-2 ">
                  <div class="tooltip" data-tip="${parent_item.title}">
                    <a href="${parent_item.item_url}" target="_blank" class="underline">${truncateText(parent_item.title, 15)}</a>
                  </div>
                </td>
              </tr>`
            );
          });

          $('.admin_child_associate_item_container').removeClass('hidden');
          $('.admin_child_associate_item_container').addClass('block');
        }
      });

      function truncateText(text, maxLength) {
        if (text.length > maxLength) {
          return text.substring(0, maxLength) + '...';
        } else {
          return text;
        }
      }
    } else {
      // チェックボックスの選択が解除された場合、すべてのチェックボックスを再度有効にする
      $('.parent_checkbox').prop('disabled', false);
      $('.admin_child_associate_item_container').removeClass('block');
      $('.admin_child_associate_item_container').remove('.admin_child_associate_item_container');
    }
  });

  $(document).on('change', '.child_checkbox', function () {
    let child_id = $(this).data('id');
    let parent_checkbox = $('.parent_checkbox:checked');
    let parent_id = parent_checkbox.data('id');
    let account_id = $('.admin_associate_container').data('ac');

    let parent_relate_box = parent_checkbox.closest('td').siblings('.parent_relate_box');

    if ($(this).is(':checked')) {
      console.log('Child ID: ' + child_id + ', Parent ID: ' + parent_id);

      $.ajax({
        url: '/application/related_child_item',
        type: 'POST',
        data: {
          account_id: account_id,
          child_id: child_id,
          parent_id: parent_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == 0) {
          // parent_relate_boxのテキストを「連携中」に設定
          parent_relate_box.text('連携中');
        }
      });
    } else {
      // チェックボックスが外された時の処理
      console.log('Unchecked - Child ID: ' + child_id + ', Parent ID: ' + parent_id);

      // ここにチェックが外された時の処理を記述
      // 必要に応じてAJAXリクエストを送信する

      $.ajax({
        url: '/application/unrelated_child_item',
        type: 'POST',
        data: {
          account_id: account_id,
          child_id: child_id,
          parent_id: parent_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == 0) {
          if ($('.child_checkbox:checked').length === 0) {
            // parent_relate_boxのテキストを空白に設定
            parent_relate_box.text('');
          }
        }
      });
    }
  });

  $('.consumable_checkbox').on('change', function () {
    let recommend_item_id = $(this).data('id');
    let account_id = $('.admin_associate_container').data('ac');

    let consumable_flag = $(this).is(':checked') ? 1 : 0;

    console.log(consumable_flag);

    $.ajax({
      url: '/application/change_consumable_flag',
      type: 'POST',
      data: {
        account_id: account_id,
        recommend_item_id: recommend_item_id,
        consumable_flag: consumable_flag,
      },
      dataType: 'json',
    }).done(function (data) {});
  });

  $('.gender_target_flag').on('change', function () {
    let recommend_item_id = $(this).data('id');
    let account_id = $('.admin_associate_container').data('ac');

    let gender_target_flag = $(this).find('option:selected').val();

    console.log(gender_target_flag);

    $.ajax({
      url: '/application/change_gender_target_flag',
      type: 'POST',
      data: {
        account_id: account_id,
        recommend_item_id: recommend_item_id,
        gender_target_flag: gender_target_flag,
      },
      dataType: 'json',
    }).done(function (data) {});
  });

  // FB連携解除ボタン
  if ($('.clear-fb-token').length) {
    $('.clear-fb-token').on('click', function () {
      let acId = $(this).attr('data-val');
      let acName = $(this).attr('data-ac-name');
      if (!confirm(acId + '. ' + acName + ' のFaceBook連携情報を削除しますか？')) {
        return;
      }
      setTimeout(function () {
        $(this).css('pointer-events', 'none');
      }, 0);
      $.ajax({
        url: '/m/clear_fb_token',
        type: 'POST',
        data: {
          account_id: acId,
        },
        dataType: 'json',
      })
        .done(function (data) {
          if (data['ret'] == 0) {
            alert('FaceBook連携情報を削除しました。');
            location.reload();
          } else {
            alert(data['message']);
          }
        })
        .fail(function () {
          alert('FaceBook連携情報の削除に失敗しました。');
        })
        .always(function () {
          $(this).css('pointer-events', 'auto');
        });
    });
    $('.clear-fb-token').on('mouseenter', function () {
      $(this).css('background-color', 'red');
      $(this).text('連携解除');
    });
    $('.clear-fb-token').on('mouseleave', function () {
      $(this).css('background-color', '#1e40af');
      $(this).text('FB連携済');
    });
  }

  //-----------------------------------------------------------------------------------------------------------------
  // アカウント管理
  //-----------------------------------------------------------------------------------------------------------------

  //############################################################
  // account_edit / settings / facebook_connect タブで1つの項目にまとめる
  // タブの切替
  //############################################################
  $(function () {
    $('.sb_account__tab').on('click', function () {
      $('.sb_account__tab').removeClass('active');
      // $('.sb_account__panel').removeClass('active');
      $('.sb_account__panel').addClass('hidden');
      $('.sb_account__tab').children('.sb_account__tab_text').removeClass('border-b border-gray-500 dark:border-gray-700');
      $(this).children('.sb_account__tab_text').addClass('border-b border-gray-500 dark:border-gray-700');
      $(this).addClass('active');
      var index = $('.sb_account__tab').index(this);
      $('.sb_account__panel').eq(index).removeClass('hidden');
    });
  });

  // アカウント設定ページにいるときはクリックできないようにする
  if (current_url === DOMAIN + '/account_edit') {
    $('.to_account_edit').css('pointer-events', 'none');
  }

  $('.to_account_edit').on('click', function () {
    location.href = DOMAIN + '/account_edit';
  });

  //############################################################
  // アカウント更新リクエスト
  //############################################################
  $('#update_account').on('click', function () {
    // validation
    if ($('#company_name').val() == '') {
      alert('会社名を入力してください');
      return;
    }
    if ($('#person_name').val() == '') {
      alert('担当者名を入力してください');
      return;
    }
    if ($('#division').val() == '') {
      alert('担当者部署を入力してください');
      return;
    }
    if ($('#mail').val() == '') {
      alert('メールアドレスを入力してください');
      return;
    }
    if ($('#tel').val() == '') {
      alert('電話番号を入力してください');
      return;
    }
    if ($('#post').val() == '') {
      alert('会社郵便番号を入力してください');
      return;
    }
    if ($('#address').val() == '') {
      alert('会社住所を入力してください');
      return;
    }
    if ($('#mail').length && $('#mail').val() != '' && !$('#mail').val().match(MAIL_PATTERN)) {
      alert('メールアドレスを正しく入力してください');
      return false;
    }

    if (!confirm('アカウント情報を更新しますか？')) {
      return;
    }

    $('#update_account').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/update_account',
      type: 'POST',
      data: {
        company_name: $('#company_name').val(),
        person_name: $('#person_name').val(),
        division: $('#division').val(),
        mail: $('#mail').val(),
        tel: $('#tel').val(),
        post: $('#post').val(),
        address: $('#address').val(),
        insta_business_id: $('#insta_business_id').val(),
        insta_access_token: $('#insta_access_token').val(),
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 0) {
          alert('アカウント情報が正常に更新されました');
          $('#update_account').css('pointer-events', 'auto');
        } else {
          alert(ERROR_MSG);
          $('#update_account').css('pointer-events', 'auto');
        }
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('#login').css('pointer-events', 'auto');
      });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // ログイン
  //-----------------------------------------------------------------------------------------------------------------
  //############################################################
  // ログイン
  //############################################################
  $('#login').on('click', function () {
    $('#login').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/application/create_session',
      type: 'POST',
      data: {
        login_id: $('#login_id').val(),
        password: $('#password').val(),
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 1) {
          location.href = '/';
        } else if (data.ret == 2) {
          location.href = '/admin';
        } else {
          alert('ログインIDまたはパスワードが違います');
          $('#login').css('pointer-events', 'auto');
        }
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('#login').css('pointer-events', 'auto');
      });
  });

  // パスワードを入力時にEnterを押下するとログインボタンを押下したときと同じ処理を走らせる
  $('#password').keypress(function (e) {
    if (e.keyCode == 13) {
      $('#login').click();
      return false;
    }
  });

  //############################################################
  // ログアウト
  //############################################################
  $('#logout').on('click', function () {
    if (!confirm('管理画面からログアウトしますか？')) {
      return;
    }
    location.href = '/logout';
  });

  //-----------------------------------------------------------------------------------------------------------------
  // パスワード再設定
  //-----------------------------------------------------------------------------------------------------------------
  //############################################################
  // パスワード再設定確認 新しいパスワードと確認用
  //############################################################

  $('#password_reset').on('click', function () {
    // validation
    if ($('#now_password').val() == '') {
      alert('現在のパスワードを入力してください');
      return;
    }
    if ($('#new_password').val() == '') {
      alert('新しいパスワードを入力してください');
      return;
    }
    if ($('#confirm_new_password').val() == '') {
      alert('確認用パスワードを入力してください');
      return;
    }

    // パスワード再設定確認 新しいパスワードと確認用
    if ($('#new_password').val() != $('#confirm_new_password').val()) {
      $('#password_error_message').css('display', 'block').text('パスワードと確認用パスワードが一致していません');
      setTimeout(function () {
        $('#password_error_message').fadeOut(300);
      }, 5000);
      return;
    }
    // 現在のパスワードチェック
    $('#password_reset').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/password_reset',
      type: 'POST',
      data: {
        now_password: $('#now_password').val(),
        new_password: $('#new_password').val(),
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 0) {
          alert('パスワードが変更されました。');
          $('#password_reset').css('pointer-events', 'auto');
        } else if (data.ret == 1) {
          alert('現在のパスワードが正しくありません。');
          $('#password_reset').css('pointer-events', 'auto');
        }
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('#password_reset').css('pointer-events', 'auto');
      });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // セッティンググループ
  //-----------------------------------------------------------------------------------------------------------------
  //############################################################
  // チェックボックス 一つだけ選択
  //############################################################
  $(function () {
    $('.check').on('click', function () {
      if ($(this).prop('checked')) {
        // 一旦全てをクリアして再チェックする
        $('.check').prop('checked', false);
        $(this).prop('checked', true);
      }
    });
  });
  //############################################################
  // カラーピッカー表示 「次へボタンの色」
  //############################################################
  $('#next_color').on('change', function (e) {
    let next_color = $('.next_color_value')[0];
    next_color.value = e.target.value;
  });
  //############################################################
  // カラーピッカー表示 「ガイド終了ボタンの色」
  //############################################################
  $('#cv_color').on('change', function (e) {
    let cv_color_value = $('.cv_color_value')[0];
    cv_color_value.value = e.target.value;
  });

  //############################################################
  // セッティンググループ画面切り替え
  //############################################################
  $('#setting_groups').on('change', function () {
    let href = DOMAIN + '/setting_groups';
    if ($(this).val() == 'new') {
      href += `?new=1`;
    } else {
      href += '?id=' + $(this).val();
    }
    location.href = href;
  });

  //############################################################
  // セッティンググループ更新リクエスト
  //############################################################
  $('#update_setting_groups').on('click', function () {
    // validation
    if ($('#name').val() == '') {
      alert('セッティンググループの名前を入力してください');
      return;
    }
    if ($('#fadein_speed').val() == '') {
      alert('ライトアップの表示スピードを入力してください');
      return;
    }
    if ($('#background_opacity').val() == '') {
      alert('グレイアウトの透明度を入力してください');
      return;
    }
    if ($('.next_color_value').val() == '') {
      alert('次へボタンの色を入力してください');
      return;
    }
    if ($('.cv_color_value').val() == '') {
      alert('ガイド終了ボタンの色を入力してください');
      return;
    }

    if (!confirm('セキュリティグループ情報を更新しますか？')) {
      return;
    }

    let back_button = 0;
    if ($('#back_button').prop('checked')) {
      back_button = 1;
    }

    $('#update_setting_groups').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/update_setting_groups',
      type: 'POST',
      data: {
        id: $(this).data('id'),
        name: $('#name').val(),
        fadein_speed: $('#fadein_speed').val(),
        background_opacity: $('#background_opacity').val(),
        next_color: $('.next_color_value').val(),
        trigger: $('#trigger').val(),
        back_button: back_button,
        cv_color: $('.cv_color_value').val(),
        none_element_case: $('#none_element_case').val(),
        new_flow_case: $('#new_flow_case').val(),
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 0) {
          alert('セキュリティグループ情報が正常に更新されました');
          $('#update_setting_groups').css('pointer-events', 'auto');
        } else {
          alert(ERROR_MSG);
          $('#update_setting_groups').css('pointer-events', 'auto');
        }
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('#login').css('pointer-events', 'auto');
      });
  });

  //############################################################
  // セッティンググループ新規登録リクエスト
  //############################################################
  $('#create_setting_groups').on('click', function () {
    if ($('.name_check_error').text() == '既に同じセッティンググループ名が使われています。') {
      alert('既に同じセッティンググループ名が使われています。');
      $('.name_check_error').text('');
      $('#name').val('');
      return;
    }
    if ($('#name').val() == '') {
      alert('セッティンググループの名前を入力してください');
      return;
    }
    if ($('#fadein_speed').val() == '') {
      alert('ライトアップの表示スピードを入力してください');
      return;
    }
    if ($('#background_opacity').val() == '') {
      alert('グレイアウトの透明度を入力してください');
      return;
    }
    if ($('.next_color_value').val() == '') {
      alert('次へボタンの色を入力してください');
      return;
    }
    if ($('.cv_color_value').val() == '') {
      alert('ガイド終了ボタンの色を入力してください');
      return;
    }

    if (!confirm('セキュリティグループ情報を新規登録しますか？')) {
      return;
    }

    let back_button = 0;
    if ($('#back_button').prop('checked')) {
      back_button = 1;
    }

    $('#create_setting_groups').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/create_setting_groups',
      type: 'POST',
      data: {
        name: $('#name').val(),
        fadein_speed: $('#fadein_speed').val(),
        background_opacity: $('#background_opacity').val(),
        next_color: $('.next_color_value').val(),
        trigger: $('#trigger').val(),
        back_button: back_button,
        cv_color: $('.cv_color_value').val(),
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == 0) {
          alert('セキュリティグループ情報が正常に新規登録されました');
          $('#new_setting_groups').css('pointer-events', 'auto');
          location.href = DOMAIN + '/setting_groups?id=' + data.id;
        } else {
          alert(ERROR_MSG);
          $('#new_setting_groups').css('pointer-events', 'auto');
        }
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('#login').css('pointer-events', 'auto');
      });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // レポート
  //-----------------------------------------------------------------------------------------------------------------

  $(function () {
    if (location.search.indexOf('device=2') != -1) {
      $('.all').css({
        'background-color': 'rgb(255, 255, 136)',
        color: '#ababab',
      });
      $('.pc').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
      $('.phone').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
    }
    if (location.search.indexOf('device=0') != -1) {
      $('.all').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
      $('.pc').css({
        'background-color': 'rgb(255, 255, 136)',
        color: '#ababab',
      });
      $('.phone').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
    }
    if (location.search.indexOf('device=1') != -1) {
      $('.all').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
      $('.pc').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
      $('.phone').css({
        'background-color': 'rgb(255, 255, 136)',
        color: '#ababab',
      });
    }
    if (location.search.indexOf('month=') == -1 && location.search.indexOf('device=2') == -1) {
      $('.all').css({
        'background-color': 'rgb(255, 255, 136)',
        color: '#ababab',
      });
      $('.pc').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
      $('.phone').css({
        'background-color': '',
        color: '#ababab',
        display: 'block',
      });
    }
  });

  //############################################################
  // ガイドフローのセレクトボックス
  //############################################################
  $('.flow_select').on('change', function () {
    let flow_selected = $(this).val();
    let month_selected = $('.month_select').val();
    let href = DOMAIN + '/report_index';
    if (flow_selected == 'all') {
      href += `?flow_id=all&month=${month_selected}&device=2`;
    } else {
      href += `?flow_id=${flow_selected}&month=${month_selected}&device=2`;
    }
    location.href = href;
  });

  //############################################################
  // 月選択のセレクトボックス
  //############################################################
  $('.month_select').on('change', function () {
    let flow_selected = $('.flow_select').val();
    let month_selected = $(this).val();
    let href = DOMAIN + '/report_index';
    if ($(this).val() == 'all') {
      href += `?flow_id=all&month=${$('.month_select').val()}&device=2`;
    } else {
      href += `?flow_id=${flow_selected}&month=${month_selected}&device=2`;
    }
    location.href = href;
  });

  //############################################################
  // レポート 月毎, 日毎, デバイス毎 グラフ切り替え
  //############################################################

  // ガイドフロー一覧から遷移する時
  $('.report_button').on('click', function () {
    let flow_selected = $(this).data('val');
    let href = DOMAIN + '/report_index';
    href += `?flow_id=${flow_selected}&device=2`;
    location.href = href;
  });

  if (document.URL.match('/report_index')) {
    let flow_selected = $('.flow_select option:selected').val();
    let month_selected = $('.month_select option:selected').val();
    // デバイスボタン選択した時
    $('.device .all').on('mouseup', function () {
      if (location.search.indexOf('date_type=24') == -1) {
        let href = DOMAIN + '/report_index';
        href += `?flow_id=${flow_selected}&month=${month_selected}&device=2`;
        location.href = href;
      }
      if (location.search.indexOf('date_type=24') != -1) {
        let href = DOMAIN + '/report_index';
        href += `?flow_id=${flow_selected}&month=${month_selected}&device=2`;
        location.href = href;
      }
    });
    $('.device .pc').on('mouseup', function () {
      if (location.search.indexOf('date_type=24') == -1) {
        let href = DOMAIN + '/report_index';
        href += `?flow_id=${flow_selected}&month=${month_selected}&device=0`;
        location.href = href;
      }
      if (location.search.indexOf('date_type=24') != -1) {
        let href = DOMAIN + '/report_index';
        href += `?flow_id=${flow_selected}&month=${month_selected}&device=0`;
        location.href = href;
      }
    });
    $('.device .phone').on('mouseup', function () {
      if (location.search.indexOf('date_type=24') == -1) {
        let href = DOMAIN + '/report_index';
        href += `?flow_id=${flow_selected}&month=${month_selected}&device=1`;
        location.href = href;
      }
      if (location.search.indexOf('date_type=24') != -1) {
        let href = DOMAIN + '/report_index';
        href += `?flow_id=${flow_selected}&month=${month_selected}&device=1`;
        location.href = href;
      }
    });
  }

  //############################################################
  // 共通：写真をドラッグ＆ドロップ
  //############################################################
  $(document).on('dragover drop', function (e) {
    e.preventDefault();
  });
  var target = $('.preview_area');
  target.on('drop', function (e) {
    $('.text').fadeOut(0);
    $('.preview_icon').fadeOut(0);
    $("[name='upfile']").prop('files', e.originalEvent.dataTransfer.files);
    var reader = new FileReader();
    reader.onload = function (e) {
      target.attr('src', e.target.result);
    };
    reader.readAsDataURL(e.originalEvent.dataTransfer.files[0]);
    $('.preview_area').fadeIn(0);
    $('#delete_image').fadeIn(300);
    // カウンセラーの場合
    $('#delete_flg').val('0');
  });

  //############################################################
  // 写真選択 クリックアクション
  //############################################################
  $('.preview').on('click', function (e) {
    $('#upfile').click();
  });
  $('#upfile').on('change', function () {
    var files = $(this)[0].files;
    $('.text').fadeOut(0);
    $('.preview_icon').fadeOut(0);
    $("[name='upfile']").prop('files', files);
    var reader = new FileReader();
    reader.onload = function (e) {
      target.attr('src', e.target.result);
    };
    reader.readAsDataURL(files[0]);
    $('.preview_area').fadeIn(0);
    $('#delete_image').fadeIn(300);
    // カウンセラーの場合
    $('#delete_flg').val('0');
  });

  //############################################################
  // 写真をアップロード
  //############################################################
  $('#upload_image').on('click', function () {
    let files = document.getElementById('upfile').files;
    let oFile = files[0];

    if (oFile == undefined) {
      alert('写真をドラッグ＆ドロップしてください');
      return;
    }

    let m_file_name = oFile.name;
    let reader = new FileReader();
    reader.readAsDataURL(oFile);

    if (2097152 < oFile.size) {
      alert('アップロードできません　\n※ アップロードできる画像の最大サイズは2MBです\n  ファイルサイズを変更して、再度画像をセットしてください');
      return;
    }

    if (!confirm('写真をアップロードしますか？')) {
      return;
    }
    $('#upload_image').css('pointer-events', 'none');

    if (oFile != undefined) {
      // 写真あり
      m_file_name = oFile.name;

      if (2097152 < oFile.size) {
        alert('登録できませんでした　\n※ アップロードできる写真の最大サイズは2MBです\n  ファイルサイズを変更して、再度写真をセットしてください');
        $('#upload_image').css('pointer-events', 'auto');
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(oFile);
      reader.onload = function () {
        // データURLスキームを取得
        let data_url_scheme = reader.result;
        let file_name = encodeURIComponent(m_file_name);
        $.ajax({
          url: DOMAIN + '/m/upload_image',
          type: 'POST',
          data: {
            image: data_url_scheme,
            name: $('#name').val(),
            file_name: file_name,
          },
          dataType: 'json',
        })
          .done(function (data) {
            if (data.ret == 0) {
              location.href = '/images';
            } else if (data.ret == 1) {
              alert('アップロードできませんでした\n登録可能な拡張子は[jpg][jpeg][png]のみとなります');
              $('#upload_image').css('pointer-events', 'auto');
            } else if (data.ret == 2) {
              alert('アップロードできませんでした　\n※ アップロードできる画像の最大サイズは2MBです\n  ファイルサイズを変更して、再度画像をセットしてください');
              $('#upload_image').css('pointer-events', 'auto');
            }
          })
          .fail(function () {
            alert(ERROR_MSG);
            $('#upload_image').css('pointer-events', 'auto');
          });
      };
    }
  });

  //############################################################
  // 写真を削除
  //############################################################
  $('.delete_image').on('click', function () {
    if (!confirm('画像を削除しますか？')) {
      return;
    }
    $('.delete_image').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/m/delete_image',
      type: 'POST',
      data: {
        image_id: $(this).data('val'),
      },
      dataType: 'json',
    })
      .done(function (data) {
        location.href = '/m/images';
      })
      .fail(function () {
        alert(ERROR_MSG);
        $('.delete_image').css('pointer-events', 'auto');
      });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // タグ設定
  //-----------------------------------------------------------------------------------------------------------------
  $('.to_tag_setting').on('click', function () {
    let href = '/tag_setting';
    location.href = href;
  });

  // タググループの追加
  $('#tag_group_set').on('click', function () {
    let tag_group_input_val = $('#tag_group_input').val();
    if (!tag_group_input_val) {
      alert('ハッシュタググループ名を入力してください。');
      return;
    }
    $('#tag_group_set').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/i/create_tag_group',
      type: 'POST',
      data: {
        name: tag_group_input_val,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('タググループを作成しました。');
      location.href = '/tag_setting?tgg_id=' + data.tgg_id;
    });
  });

  // ハッシュタグ登録時に最近と人気の投稿を取得する処理で、
  // 続けて登録されるとサーバーが止まるため、連続で登録できないようにインターバルを設定する
  function hash_tag_register_interval() {
    let now = new Date();
    let opt = { timeZone: 'Asia/Tokyo' };
    let datetime = now.toLocaleString('ja-JP', opt);
    let registeredTime;
    let waitTime;

    if (!localStorage.getItem('platta_tag_registered_time')) {
      localStorage.setItem('platta_tag_registered_time', JSON.stringify(datetime));
    } else {
      const platta_tag_registered_time_str = localStorage.getItem('platta_tag_registered_time');
      console.log('platta_tag_registered_time_str :>> ', platta_tag_registered_time_str);
      registeredTime = new Date(JSON.parse(platta_tag_registered_time_str));

      // 5分追加 (300000ミリ秒)
      const waitUntil = new Date(registeredTime);
      waitUntil.setTime(registeredTime.getTime() + 300000);

      // Format wait time
      waitTime = waitUntil.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' });
    }

    // 5分以上、経過していない場合、処理を中断する
    if (localStorage.getItem('platta_tag_registered_time') && now - registeredTime < 300000) {
      // if (now - registeredTime < 1) {
      alert(`現在、登録したハッシュタグの投稿を収集しております。${waitTime}以降になりましたら再度お試しください。`);
      location.reload();
      return true;
    } else {
      localStorage.setItem('platta_tag_registered_time', JSON.stringify(datetime));
      return false;
    }
  }

  // タグの登録
  $('#add_btn').on('click', function () {
    let text = $('#tag_input').val();

    if (text.length == 0) {
      alert('登録したいタグを入力してください。');
      $('#add_btn').css('pointer-events', 'auto');
      return;
    }

    if (hash_tag_register_interval() == true) {
      return;
    }

    $('#add_btn').css('pointer-events', 'none');

    $.ajax({
      url: DOMAIN + '/i/create_tags',
      type: 'POST',
      data: {
        tgg_id: $('.tag_group_select option:selected').val(),
        text: text,
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.hashtag_id > 0) {
          alert(
            `タグを登録しました。
          続けて登録したタグ名と合致した投稿を取得します。
          取得処理は継続するため本ページから離れても問題ありません。
          取得した投稿の反映には時間がかかる場合がございます。`.replace(/[ \t]/g, '')
          );
          $.ajax({
            url: '/execute_get_recent_and_popular_sns_posts',
            type: 'POST',
            data: {
              hashtag_id: data.hashtag_id,
            },
            dataType: 'json',
          })
            // ajaxの処理が長引くと自動でjsがエラーを返すため alert は出さない
            .done(function (data) {
              // console.log('たった今追加したハッシュタグの最近の投稿、人気の投稿を取得する');
            })
            // ajaxの処理が長引くと自動でjsがエラーを返すため alert は出さない
            // エラーが出てもrails側でプログラムの処理は中断されない
            .fail(function (jqXHR, textStatus, errorThrown) {
              console.log(jqXHR, textStatus, errorThrown);
            })
            .always(function () {
              // location.reload();
              location.href = '/tag_setting?tgg_id=' + data.tgg_id;
            });
          // setTimeoutを設定しないと 2回目の .done()の処理が走らないことがある
          setTimeout(() => {
            location.href = '/tag_setting?tgg_id=' + data.tgg_id;
          }, 500);
        } else if (data.hashtag_id == -100) {
          localStorage.removeItem('platta_tag_registered_time');
          // 追加 大文字も小文字もハッシュタグ名はインスタグラムは区別しない
          alert(
            `そのハッシュタグはすでに登録済みです。
          (ハッシュタグ名が大文字や小文字、ひらがなやカタカナも同様に扱われます。)`.replace(/[ \t]/g, '')
          );
          location.href = '/tag_setting?tgg_id=' + data.tgg_id;
        } else if (data.hashtag_id == -3) {
          localStorage.removeItem('platta_tag_registered_time');
          alert('連携時に登録されたトークンが有効ではありません。連携に失敗している可能性がございますので、お手数ですがサポートチームにお問い合わせください。');
          location.href = '/tag_setting?tgg_id=' + data.tgg_id;
        } else if (data.hashtag_id == -2) {
          localStorage.removeItem('platta_tag_registered_time');
          alert('連携時に登録されたインスタグラムIDが有効ではありません。連携に失敗している可能性がございますので、お手数ですがサポートチームにお問い合わせください。');
          location.href = '/tag_setting?tgg_id=' + data.tgg_id;
        } else if (data.hashtag_id == -1) {
          localStorage.removeItem('platta_tag_registered_time');
          alert('インスタグラム上で一致するハッシュタグが見つからないため登録できません。別のハッシュタグ名をお試しください。');
          location.href = '/tag_setting?tgg_id=' + data.tgg_id;
        } else if (data.hashtag_id == 0) {
          localStorage.removeItem('platta_tag_registered_time');
          alert(`1週間で保持、及び登録できるハッシュタグの限度数に達しました。

          ${data.future_restriction_lifted_data}以降に再度、お試しください。`);
          location.href = '/tag_setting?tgg_id=' + data.tgg_id;
          // 上記以外の全てのエラーをキャッチ
        } else {
          console.log('data :>> ', data);
          localStorage.removeItem('platta_tag_registered_time');
          alert('Error(HSS0001): 予期しないエラーが発生しました。時間を置いて再度お試しいただき、問題が継続するようでしたらお手数ですが、サポートチームにお問い合わせください。');
          location.reload();
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        localStorage.removeItem('platta_tag_registered_time');
        alert('Error(HSS0002): 予期しないエラーが発生しました。時間を置いて再度お試しいただき、問題が継続するようでしたらお手数ですが、サポートチームにお問い合わせください。');
        location.reload();
      });
  });

  $('.del_checkbox').on('change', function () {
    if ($('.del_checkbox:checked').length > 0) {
      $('.del_tag').removeClass('hidden');
    } else {
      $('.del_tag').addClass('hidden');
    }
  });

  // タグの論理削除
  $('.del_tag').on('click', function () {
    $('.del_tag').css('pointer-events', 'none');
    let checked_tags = [];
    checked_tags = $('.del_checkbox:checked')
      .map(function () {
        return $(this).data('tag_id');
      })
      .get();

    if (checked_tags.length == 0) {
      alert('削除したいタグにチェックを入れてください。');
      $('.del_tag').css('pointer-events', 'auto');
      return;
    }

    $.ajax({
      url: DOMAIN + '/i/del_tags',
      type: 'POST',
      data: {
        tgg_id: $('.tag_group_select option:selected').val(),
        tag_ids: checked_tags,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('タグを削除しました');
      location.href = '/tag_setting?tgg_id=' + data.tgg_id;
    });
  });

  // ハッシュタグ設定の説明
  // 検索条件の表示非表示 slideToggle
  $('.tag_setting_info__accordion_filter').click(function () {
    $(this)
      .next()
      .slideToggle(300, function () {
        $(this).toggleClass('open');
      });
    if ($(this).next().hasClass('open')) {
      $(this).text('ハッシュタグ設定の説明を表示する');
    } else {
      $(this).text('ハッシュタグ設定の説明を非表示する');
    }
  });

  // タググループの削除
  $('.delete_tag_group').on('click', function () {
    if (!confirm('選択中のタググループを本当に削除しますか？')) {
      return;
    }
    $('.delete_tag_group').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/i/delete_tag_group',
      type: 'POST',
      data: {
        tgg_id: $('.tag_group_d_select option:selected').val(),
      },
      dataType: 'json',
    }).done(function (data) {
      alert('タググループを削除しました。');
      location.href = '/tag_setting';
    });
  });

  // タググループ選択
  $('.tag_group_select').on('change', function () {
    tgg_id = $('.tag_group_select option:selected').val();
    $('.tag').remove();
    // alert(data.tags);
    location.href = '/tag_setting?tgg_id=' + tgg_id;
  });

  //-----------------------------------------------------------------------------------------------------------------
  // ハッシュタグ収集一覧
  //-----------------------------------------------------------------------------------------------------------------
  if (current_url.includes('/hashtag_list?')) {
    $('.to_hashtag_list').css('pointer-events', 'none');
  }

  $('.to_hashtag_list').on('click', function (event) {
    $('.to_hashtag_list').css('pointer-events', 'none');
    event.preventDefault();

    const { hashtagInitialDate, hashtagEndDate } = getDefaultHashtagDates();

    // ハッシュタググ収集一覧に関するlocalstrageをリセットする
    // ハッシュタググループIDは削除する（管理者側で別アカウントに切り替えた時にハッシュタググループIDがあるとタグが正しく読み込まれないため）
    localStorage.removeItem('hashtag_group');
    localStorage.removeItem('hashtag_list');
    localStorage.removeItem('excluded_words_list');
    localStorage.removeItem('ugc_urls_list');

    localStorage.setItem('hashtag_list_display_type', "all");
    localStorage.setItem('hashtag_initial_date', hashtagInitialDate);
    localStorage.setItem('hashtag_end_date', hashtagEndDate);
    localStorage.setItem('search_condition', "1");
    localStorage.setItem('per_page_num', "50");

    // サイドメニューから表示時は全てのタグで検索する（all_tag_check）
    location.href = generate_hashtag_list_url_params() + `&all_tag_check=1`;
  });

  $('.post_regist_publish_btn').on('click', function () {
    let show_hashtag = $(this).data('show_hashtag');
    let id = $(this).data('id');
    if (show_hashtag == '0') {
      $.ajax({
        url: '/show_hashtag_ok',
        type: 'POST',
        data: {
          id: id,
          show_hashtag: show_hashtag,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    } else if (show_hashtag == '1') {
      $.ajax({
        url: '/show_hashtag_no',
        type: 'POST',
        data: {
          id: id,
          show_hashtag: show_hashtag,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    }
  });
  $('.ugc_set_btn')
    .off()
    .on('click', function () {
      $('.modal_container').css('display', 'block');

      let sns_post_id = $(this).data('id');
      $('.modal_submit').attr('data-sns_post_id', sns_post_id);

      // UGCグループ連携 モーダル表示
      $('.modal_del,.modal_bg').on('click', function () {
        $('.modal_container').css('display', 'none');
      });

      if (!$('.modal_submit').hasClass('event-bound')) {
        $('.modal_submit').addClass('event-bound');
        $('.modal_submit')
          .off()
          .on('click', function () {
            let ugc_group_ids = [];
            $('input[name=ugc_groups]:checked').each(function () {
              ugc_group_ids.push($(this).val());
            });
            if (ugc_group_ids.length == 0) {
              alert('UGCグループを選択してください。');
              return;
            }
            $.ajax({
              url: '/ugc_group_id_set',
              type: 'POST',
              data: {
                sns_post_id: sns_post_id,
                ugc_group_ids: ugc_group_ids,
              },
              dataType: 'json',
            }).done(function (data) {
              if (data.ret == '0') {
                alert('UGCグループに連携しました。');
                location.reload();
              }
            });
          });
      }

      $('.modal_cancel_submit').on('click', function () {
        let ugc_group_id = $('.ugc_modal_select option:selected').val();
        let sns_post_id = $(this).data('id');
        $.ajax({
          url: '/ugc_group_id_delete',
          type: 'POST',
          data: {
            sns_post_id: sns_post_id,
            ugc_group_id: ugc_group_id,
          },
          dataType: 'json',
        }).done(function (data) {
          if (data.ret == '0') {
            location.reload();
          }
        });
      });
    });

  //-----------------------------------------------------------------------------------------------------------------
  // キャンペーン投稿
  //-----------------------------------------------------------------------------------------------------------------
  //############################################################
  // 予約投稿選択した時
  //############################################################
  $('input[name="post_type"]').change(function () {
    if ($(this).is(':checked')) {
      let value = $(this).val();
      if (value == '1') {
        $('.expected_date').css('display', 'block');
      } else if (value != '1') {
        $('.expected_date').css('display', 'none');
      }
    }
  });
  //############################################################
  // .textarea → phone
  //############################################################
  $('.post_content_textarea').ready(function () {
    let showChar = 40; // 表示する文字数
    // let ellipsestext = "..."; // 省略記号
    let moretext = '...続きを読む'; // 「続きを読む」リンクのテキスト
    let lesstext = '閉じる'; // 「閉じる」リンクのテキスト
    let moreClass = 'morelink'; // 「続きを読む」リンクのクラス名
    let lessClass = 'lesslink'; // 「閉じる」リンクのクラス名
    let max_text_length = 2200;

    $('.post_content_textarea').on('input', function () {
      let post_content = $('.post_content_textarea').val();
      let inputText = $(this).val();
      let outputText = '';
      let post_text_length = post_content.length;
      $('.now_cnt').text(post_text_length);
      if (post_text_length > 0 && max_text_length >= post_text_length) {
        //1文字以上かつ140文字以内の場合はボタンを有効化＆黒字
        $('.preview_submit, .preview_draft_save').prop('disabled', false);
        $('.max_text_length').removeClass('text_length_over');
      } else {
        //0文字または140文字を超える場合はボタンを無効化＆赤字
        $('.preview_submit, .preview_draft_save').prop('disabled', true);
        $('.max_text_length').addClass('text_length_over');
      }

      if (inputText.length > showChar) {
        let c = inputText.substr(0, showChar);

        outputText = `username ${c}<span class="${moreClass}">${moretext}</span>`;
      } else {
        outputText = 'username ' + inputText;
      }

      $('.post_display_content').html(outputText);

      // ２度と閉じない用
      if ($('#hidden_tmp_input').val() == '1') {
        $('.post_display_content').text('username ' + post_content);
      }

      $('.' + moreClass).css('cursor', 'pointer');
      $('.' + moreClass).on('click', function () {
        $('#hidden_tmp_input').val('1');
        $('.post_display_content').text('username ' + post_content);
      });
    });
    //リロード時に初期文字列が入っていた時の対策
    $('.post_content_textarea').trigger('input');
  });

  //############################################################
  // 写真選択 クリックアクション
  //############################################################
  $('.post_img_input').ready(function () {
    $('.post_img_input').on('click', function () {
      $('#post_img_reinput').click();
    });
    $('#post_img_reinput').on('change', function () {
      let $files = $(this).prop('files');
      let len = $files.length;
      for (var i = 0; i < len; i++) {
        let file = $files[i];
        let fr = new FileReader();

        fr.onload = function (e) {
          let data_url_scheme = fr.result;
          let file_name = encodeURIComponent(file.name);
          let src = e.target.result;
          let img = `<img class="preview_img" src="${src}" data-file_name="${file_name}" data-url_scheme="${data_url_scheme}" />`;
          let pre_img = `<div><img src="${src}" /></div>`;
          $('.preview_img_area').append(img);
          $('.post_display_img').append(pre_img);
        };
        fr.readAsDataURL(file);
      }
    });
  });

  //############################################################
  // プレビュー この内容で確定ボタン
  //############################################################
  $('.preview_submit').ready(function () {
    $('.preview_submit').on('click', function () {
      $('.preview_submit').css('pointer-events', 'none');
      $('.loadding').css('display', 'block');

      // 即時投稿0か予約投稿1かの値
      let post_type = $("input[name='post_type']:checked").val();

      // 予約投稿するかどうか次第
      let post_time = 'now';
      if (post_type == 1) {
        post_time = $("input[name='post_datetime']").val();
      }

      //　キャンペーンの応募条件
      let app_types = [];
      let following_type = 1;
      if ($('#follow_checkbox').is(':checked')) {
        following_type = 0;
      }
      app_types.push(following_type);
      let comment_type = 1;
      if ($('#comment_checkbox').is(':checked')) {
        comment_type = 0;
      }
      app_types.push(comment_type);
      let repost_type = 1;
      if ($('#repost_checkbox').is(':checked')) {
        repost_type = 0;
      }
      app_types.push(repost_type);

      // キャンペーン当選条件
      let win_types = [];

      let follower_type = 1;
      if ($('#follower_checkbox').is(':checked')) {
        follower_type = 0;
      }
      win_types.push(follower_type);
      let comment_count_type = 1;
      if ($('#comment_count_checkbox').is(':checked')) {
        comment_count_type = 0;
      }
      win_types.push(comment_count_type);

      // 投稿画像
      let image_datas = [];

      let i = 0;
      $('.preview_img').each(function () {
        let file_name = $(this).data('file_name');
        let url_scheme = $(this).data('url_scheme');

        image_datas.push([i, file_name, url_scheme]);
        i++;
      });

      if (image_datas.length == 0) {
        $('.loadding').css('display', 'none');
        alert('画像を選択してください。');
        return;
      }

      // 投稿内容 キャプション
      let caption = $('.post_content_textarea').val();
      if (caption.length <= 0) {
        $('.loadding').css('display', 'none');
        alert('キャプションを入力してください。');
        $('.preview_submit').css('pointer-events', 'auto');
        return;
      } else if (caption.length > 2200) {
        $('.loadding').css('display', 'none');
        alert('キャプションの最大文字数を超えています。2200文字未満に調整してください。');
        $('.preview_submit').css('pointer-events', 'auto');
        return;
      }

      let ic_id = $(this).data('ic_id');

      $.ajax({
        url: '/campaign_post',
        type: 'POST',
        data: {
          post_type: post_type,
          post_time: post_time,
          image_datas: image_datas,
          caption: caption,
          save_type: 0,
          ic_id: ic_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == 0) {
          alert(data.message);
          location.href = '/campaign_setting';
        } else {
          $('.loadding').css('display', 'none');
          alert(data.message);
          $('.preview_submit').css('pointer-events', 'auto');
        }
      });
    });
  });

  //############################################################
  // プレビュー 下書きに保存
  //############################################################
  $('.preview_draft_save').ready(function () {
    $('.preview_draft_save').on('click', function () {
      // 即時投稿0か予約投稿1かの値
      let post_type = $("input[name='post_type']:checked").val();

      // 予約投稿するかどうか次第
      let post_time = 'now';
      if (post_type == 1) {
        post_time = $("input[name='post_datetime']").val();
      }

      //　キャンペーンの応募条件
      let app_types = [];
      let following_type = 1;
      if ($('#follow_checkbox').is(':checked')) {
        following_type = 0;
      }
      app_types.push(following_type);
      let comment_type = 1;
      if ($('#comment_checkbox').is(':checked')) {
        comment_type = 0;
      }
      app_types.push(comment_type);
      let repost_type = 1;
      if ($('#repost_checkbox').is(':checked')) {
        repost_type = 0;
      }
      app_types.push(repost_type);

      // キャンペーン当選条件
      let win_types = [];
      let follower_type = 1;
      if ($('#follower_checkbox').is(':checked')) {
        follower_type = 0;
      }
      win_types.push(follower_type);
      let comment_count_type = 1;
      if ($('#comment_count_checkbox').is(':checked')) {
        comment_count_type = 0;
      }
      win_types.push(comment_count_type);

      // 投稿内容 キャプション
      let caption = $('.post_content_textarea').val();

      let ic_id = $(this).data('ic_id');

      $.ajax({
        url: '/save_draft',
        type: 'POST',
        data: {
          post_type: post_type,
          post_time: post_time,
          caption: caption,
          save_type: 1,
          ic_id: ic_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == 0) {
          alert(data.message);
          location.href = '/campaign_setting';
        } else {
          alert(data.message);
        }
      });
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // キャンペーン投稿一覧
  //-----------------------------------------------------------------------------------------------------------------
  //############################################################
  // 条件選択　コメント文字数
  //############################################################
  $('.post_num_input').on('change', function () {
    let min_length = $(this).val();
    let num = $(this).data('num');
    let comment_list = $(`.post_card_content_box_text_js_${num}`)
      .map(function () {
        return $(this).text();
      })
      .get();

    for (let i = 0; i < comment_list.length; i++) {
      if (Number(min_length) > comment_list[i].length) {
        $(`.post_card_content_container_js_${num}_${i}`).css('display', 'none');
      } else {
        $(`.post_card_content_container_js_${num}_${i}`).css('display', 'block');
      }
    }
  });

  $('.update_post').on('click', function () {
    $(this).parents().children('.update_loadding').css('display', 'block');
    let box_count = $(this).data('box_count');
    let id = $(this).data('id');
    let ig_post_id = $(this).data('ig_post_id');
    let comments_count = $(this).data('comments_count');
    $.ajax({
      url: '/update_ig_post',
      type: 'POST',
      data: {
        box_count: box_count,
        id: id,
        ig_post_id: ig_post_id,
        comments_count: comments_count,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        $(`.comment_list_${data.box_count}`).remove();
        $(`.post_card_content_link_${data.box_count}`).children().remove();
        $.each(data.instagram_campaign_comment, function (index, c) {
          $(`.post_card_comment_container_${data.box_count}`).append(
            `<div class="post_card_content_container_list_box comment_list_${data.box_count} post_card_content_container_js_${data.box_count}_${index}">
                <div class="post_card_content_box">
                  <a href="https://instagram.com/${c.username}" target="_blank">
                    <p style="font-size:10px;">username:${c.username}</p>
                    <div class="post_card_content_box_text post_card_content_box_text_js_${index}">${c.text}</div>
                    <p style="font-size:10px;">投稿時刻:${c.timestamp}</p>
                  </a>
                </div>
              </div>`
          );
        });
        $(`.post_card_content_link_${data.box_count}`).append(
          `<span id="favo-box" style="margin-right:20px;"><i class="fas fa-heart favo"></i>${data.instagram_campaign.like_count}</span>
            <span id="comment-box"><i class="fas fa-envelope dm"></i>${data.instagram_campaign.comments_count}</span>`
        );
        $('.update_loadding').css('display', 'none');
      }
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // 出しわけグループ設定
  //-----------------------------------------------------------------------------------------------------------------
  // 出しわけグループ選択
  $('#parent_group_select_box').on('change', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();

    if (parent_group_id == 'new') {
      $('.parent_group_set_wrapper').css('display', 'block');
      $('.parent_edit_name_setting_wrapper').css('display', 'none');
      $('.parent_url_setting_wrapper').css('display', 'none');
      $('.parent_ugc_group_setting_wrapper').css('display', 'none');
      $('.parent_element_setting_wrapper').css('display', 'none');
      $('.parent_group_delete_setting_wrapper').css('display', 'none');
    } else {
      location.href = `/parent_group_setting?parent_group_id=${parent_group_id}`;
    }
  });
  // 出しわけグループ登録
  $('#parent_group_set').on('click', function () {
    let parent_group_input_val = $('#parent_group_input').val();
    if (!parent_group_input_val) {
      alert('出しわけグループ名を入力してください。');
      return;
    }
    $('#parent_group_set').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/i/create_parent_group',
      type: 'POST',
      data: {
        name: parent_group_input_val,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('出しわけグループ名を作成しました。');
      location.href = `/parent_group_setting?parent_group_id=${data.parent_group.id}`;
    });
  });

  // 選択したUGCグループの連携/連携解除
  $('#parent_ugc_group_set').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let checked_values = [];
    $("input[name='ugc_groups']:checked").each(function () {
      checked_values.push($(this).val());
    });

    $.ajax({
      url: DOMAIN + '/i/update_parent_group_ugc_group',
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
        ugc_group_ids: checked_values,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('UGCグループを連携しました。');
        location.href = `/parent_group_setting?parent_group_id=${parent_group_id}`;
      }
    });
  });

  //  出しわけグループ名編集
  $('#parent_edit_name_submit').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let new_parent_name = $('.parent_edit_name_input').val();
    if (!new_parent_name) {
      alert('グループ名を入力してください。');
      return;
    }
    $.ajax({
      url: '/update_parent_name',
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
        name: new_parent_name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('出しわけグループ名を編集しました。');
        location.href = `/parent_group_setting?parent_group_id=${data.parent_group.id}`;
      }
    });
  });

  // 出しわけグループのURL登録
  $('#parent_url_add_input').on('click', function () {
    $(this)
      .parent()
      .children('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 px-6 text-left ">
              <input class="parent_url_input w-380px h-30px py-0 px-6 border-b border-base-500 dark:border-none" type="text">
            </td>
            <td>
              <div class="parent_url_del text-2xl cursor-pointer text-base-500 dark:text-gray-600">ー</div>
            </td>
          </tr>`
      );
    $('.parent_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.parent_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });
  $('#parent_url_set').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let urls = [];
    $('.parent_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_parent_url',
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('URLを登録しました');
      location.reload();
    });
  });

  // 出しわけグループの金額条件登録
  $('#parent_amount_set').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let parent_amount_element = $('#parent_amount_element_input').val();
    let parent_amount_condition = $('#parent_amount_condition_input option:selected').val();
    let parent_amount = $('#parent_amount_input').val();
    let parent_amount_upper_condition = $('#parent_amount_upper_condition_input option:selected').val();
    let parent_amount_upper = $('#parent_amount_upper_input').val();
    let parent_amount_filter = $('#parent_amount_filter option:selected').val();

    if (parent_amount_element == '') {
      alert('class名またはid名が未記入です。');
      return;
    }
    if (parent_amount == '') {
      alert('金額1が未記入です。');
      return;
    }

    if (parent_amount_upper && Number(parent_amount) >= Number(parent_amount_upper)) {
      alert('金額2は金額1より大きい数字にしてください。');
      return;
    }
    if (parent_amount_condition == 0 || parent_amount_condition == 2 || parent_amount_condition == 4) {
      parent_amount_upper = '';
    }

    $.ajax({
      url: '/update_amount_condition',
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
        parent_amount_element: parent_amount_element,
        parent_amount_condition: parent_amount_condition,
        parent_amount: parent_amount,
        parent_amount_upper_condition: parent_amount_upper_condition,
        parent_amount_upper: parent_amount_upper,
        parent_amount_filter: parent_amount_filter,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('金額による出しわけ条件を設定しました。');
      location.reload();
    });
  });

  // 出しわけグループのテキスト条件登録
  $('#parent_text_set').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let parent_text_element = $('#parent_text_element_input').val();
    let parent_text_condition = $('#parent_text_condition_input option:selected').val();
    let parent_text = $('#parent_text_input').val();

    if (parent_text_element == '') {
      alert('class名またはid名が未記入です。');
      return;
    }
    if (parent_text == '') {
      alert('テキストが未記入です。');
      return;
    }
    if (!parent_text_element.startsWith('.') && !parent_text_element.startsWith('#')) {
      alert('文字列の先頭には . もしくは # を付けてください。');
      return;
    }
    $.ajax({
      url: '/update_text_condition',
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
        parent_text_element: parent_text_element,
        parent_text_condition: parent_text_condition,
        parent_text: parent_text,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('テキストによる出しわけを設定しました。');
      location.reload();
    });
  });

  // 出しわけグループの金額条件登録
  $('#parent_img_set').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let parent_img_element = $('#parent_img_element_input').val();
    let parent_img_condition = $('#parent_img_condition_input option:selected').val();
    let parent_img = $('#parent_img_input').val();

    if (parent_img_element == '') {
      alert('class名またはid名が未記入です。');
      return;
    }
    if (parent_img == '') {
      alert('画像URLが未記入です。');
      return;
    }
    if (!parent_img_element.startsWith('.') && !parent_img_element.startsWith('#')) {
      alert('文字列の先頭には . もしくは # を付けてください。');
      return;
    }
    $.ajax({
      url: '/update_img_condition',
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
        parent_img_element: parent_img_element,
        parent_img_condition: parent_img_condition,
        parent_img: parent_img,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('画像による出しわけ条件を設定しました。');
      location.reload();
    });
  });

  // 出しわけグループの条件をリセット
  $('#parent_amount_reset, #parent_text_reset, #parent_img_reset').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let flag = $(this).data('flag');
    let element = $(this).data('element');
    let condition = $(this).data('condition');
    let val = $(this).data('val');

    $.ajax({
      url: `/reset_condition`,
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
        flag: flag,
        element: element,
        condition: condition,
        value: val,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('出しわけ条件をリセットしました。');
      location.reload();
    });
  });

  $('.jump_ugc_group').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();
    let ugc_group_id = $(this).data('ugc_group_id');

    location.href = `/ugc_setting?ugc_group_id=${ugc_group_id}`;
  });

  $('#parent_group_delete_btn').on('click', function () {
    let parent_group_id = $('#parent_group_select_box option:selected').val();

    if (!confirm('完全に削除され復元することはできません。本当に削除しますか？')) {
      return;
    }

    $.ajax({
      url: '/i/delete_parent_group',
      type: 'POST',
      data: {
        parent_group_id: parent_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('出しわけグループを削除しました。');
      location.href = `/parent_group_setting`;
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // UGC設定
  //-----------------------------------------------------------------------------------------------------------------
  // UGCグループ選択
  $('.ugc_group_select_box').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    if (ugc_group_id == 'new') {
      $('.ugc_group_set_wrapper_display').css('display', 'block');
      $('.ugc_edit_name_setting_wrapper').css('display', 'none');
      $('.ugc_copy_setting_wrapper').css('display', 'none');
      $('.ugc_edit_title_setting_wrapper').css('display', 'none');
      $('.ugc_edit_related_items_title_setting_wrapper').css('display', 'none');
      $('.ugc_setting_wrapper_post_list').css('display', 'none');
      $('.ugc_element_setting_wrapper').css('display', 'none');
      $('.ugc_open_setting_wrapper').css('display', 'none');
      $('.ugc_display_count_setting_wrapper').css('display', 'none');
      $('.ugc_url_setting_wrapper').css('display', 'none');
      $('.ugc_display_pattern_setting_wrapper').css('display', 'none');
      $('.ugc_display_order_setting_wrapper').css('display', 'none');
      $('.ugc_custom_setting_wrapper').css('display', 'none');
      $('.ugc_device_setting_wrapper').css('display', 'none');
      $('.ugc_ab_test_setting_wrapper').css('display', 'none');
      $('.ugc_custom_css_wrapper').css('display', 'none');
      $('.ugc_delete_setting_wrapper').css('display', 'none');
      $('.ugc_add_tab_setting_wrapper').css('display', 'none');
      $('.ugc_tab_setting_wrapper').css('display', 'none');
      $('#editGroupName').css('display', 'none');
      $('#ugc_copy_submit').css('display', 'none');
      $('#ugc_group_delete_btn').css('display', 'none');
    } else {
      location.href = `${window.location.pathname}?ugc_group_id=${ugc_group_id}`;
    }
  });

  $('.jump_parent_group').on('click', function () {
    parent_group_id = $(this).data('parent_group_id');
    location.href = `/parent_group_setting?parent_group_id=${parent_group_id}`;
  });

  // ABテストのモード切り替え
  $('#ugc_group_ab_test_btn').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();

    $.ajax({
      url: '/update_ugc_ab_test_mode',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        if (data.ugc_group.is_ab_test == '0') {
          alert('ABテストモードを停止しました。');
        } else {
          alert('ABテストモードを開始しました。');
        }
        location.reload();
      }
    });
  });

  // ABテストの新規作成
  $('#create_ugc_group_ab_test_btn').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    $.ajax({
      url: '/create_ugc_ab_test',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('テストを作成しました。');
        location.reload();
      } else {
        console.log(data.error_message);
      }
    });
  });

  //  デフォルトのABテストの設定
  $('#update_default_ab_test_btn').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ab_test_id = $("input[name='ab_test_radio']:checked").val();
    console.log(ab_test_id);
    $.ajax({
      url: '/update_default_ab_test',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ab_test_id: ab_test_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('ABテストを実施していない時のデフォルトのテストを設定しました。');
        location.href = `/ugc_setting?ugc_group_id=${ugc_group_id}&ab=${ab_test_id}`;
      }
    });
  });

  // ABテスト選択
  $('.ugc_group_ab_test_select_box').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_select_box option:selected').val();

    location.href = `/ugc_setting?ugc_group_id=${ugc_group_id}&ab=${ugc_group_ab_test_id}`;
  });

  // デバイス選択
  $('.ugc_setting_device_pc, .ugc_setting_device_phone').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $(this).data('device');

    location.href = `${window.location.pathname}?ugc_group_id=${ugc_group_id}&is_device=${is_device}`;
  });

  //  UGCグループ名編集
  $('#ugc_edit_name_submit').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_edit_name_val = $('.ugc_edit_name_input').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    $.ajax({
      url: '/update_ugc_name',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        name: ugc_edit_name_val,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('UGCグループ名を編集しました。');
        location.href = `/page_setting?ugc_group_id=${data.ugc_group.id}&ab=${ugc_group_ab_test_id}`;
      }
    });
  });

  //  UGCグループコピー
  $('#ugc_copy_submit').on('click', function () {
    $('#ugc_copy_submit').css('pointer-events', 'none');
    $('.loadding').css('display', 'block');
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    $.ajax({
      url: '/create_ugc_copy',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('UGCグループのコピーを作成しました。');
        location.href = `/page_setting?ugc_group_id=${data.new_group_id}`;
      } else {
        alert('UGCグループのコピーに失敗しました。');
        $('#ugc_copy_submit').css('pointer-events', 'auto');
        $('.loadding').css('display', 'none');
      }
    });
  });

  // ugc表示順選択
  $('#ugc_order_select').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let ugc_order_select = $('#ugc_order_select option:selected').val();

    let url = new URL(window.location.href);
    if (url.searchParams.has('ugc_order_by')) {
      url.searchParams.set('ugc_order_by', ugc_order_select);
    } else {
      url.searchParams.append('ugc_order_by', ugc_order_select);
    }
    history.replaceState({}, null, url.toString());
    location.reload();
  });

  // UGCグループ公開設定
  $('.ugc_open_select').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let ugc_show_valid_val = $('.ugc_open_select option:selected').val();
    let is_device = $('#ugc_setting_device_val').val();
    $.ajax({
      url: '/update_show_valid',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        show_valid: ugc_show_valid_val,
        is_device: is_device,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        if (data.show_valid == 1) {
          alert('UGCグループを公開しました。');
        } else {
          alert('UGCグループを非公開にしました。');
        }
        location.reload();
      }
    });
  });

  //  UGC表示数設定
  $('#ugc_display_count_submit').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let ugc_display_count_select_val = $('#ugc_display_count_select_val').val();
    let is_device = $('#ugc_setting_device_val').val();
    $.ajax({
      url: '/update_display_count',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        display_count: ugc_display_count_select_val,
        is_device: is_device,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('UGC表示数を設定しました。');
        location.reload();
      }
    });
  });
  //  UGC表示パターン設定
  $('.ugc_display_type_select').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let ugc_display_type_val = $('.ugc_display_type_select option:selected').val();
    let ugc_display_order_val = $('.ugc_display_order_select option:selected').val();
    let is_device = $('#ugc_setting_device_val').val();

    $.ajax({
      url: '/update_display_type',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        display_type: ugc_display_type_val,
        is_device: is_device,
        display_order: ugc_display_order_val,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('表示パターンを設定しました。');
        location.reload();
      }
    });
  });
  //  UGC表示順設定
  $('.ugc_display_order_select').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let ugc_display_order_val = $('.ugc_display_order_select option:selected').val();

    let ugc_display_type_val = $('.ugc_display_type_select option:selected').val();
    let is_device = $('#ugc_setting_device_val').val();
    $.ajax({
      url: '/update_display_order',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        display_order: ugc_display_order_val,
        is_device: is_device,
        display_type: ugc_display_type_val,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('表示順を設定しました。');
        location.reload();
      }
    });
  });

  $('#ugc_group_delete_btn').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();

    if (!confirm('完全に削除され復元することはできません。本当に削除しますか？')) {
      return;
    }

    $.ajax({
      url: '/i/delete_ugc_group',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('UGCグループを削除しました。');
      location.href = `/page_setting`;
    });
  });

  $('#ugc_group_set').on('click', function () {
    let ugc_group_input_val = $('.ugc_group_input').val();
    if (!ugc_group_input_val) {
      alert('UGCグループ名を入力してください。');
      return;
    }
    $('#ugc_group_set').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/i/create_ugc_group',
      type: 'POST',
      data: {
        name: ugc_group_input_val,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('UGCグループを作成しました。');
      location.href = `/page_setting?ugc_group_id=${data.ugc_group.id}`;
    });
  });

  $('#element_change_mode').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let is_device = $('#ugc_setting_device_val').val();
    let element_change_mode_val = $(this).val();

    $.ajax({
      url: '/update_ugc_element_mode',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        is_device: is_device,
        element_change_mode_val: element_change_mode_val,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  $('#ugc_element_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();
    let element_id_val = $('#element_id_input').val();
    let element_class_val = $('#element_class_input').val();
    let element_index_val = $('#element_index_input').val();
    let parent_id_val = $('#parent_id_input').val();
    let parent_class_val = $('#parent_class_input').val();
    let parent_index_val = $('#parent_index_input').val();
    let grand_id_val = $('#grand_id_input').val();
    let grand_class_val = $('#grand_class_input').val();
    let grand_index_val = $('#grand_index_input').val();
    let great_grand_id_val = $('#great_grand_id_input').val();
    let great_grand_class_val = $('#great_grand_class_input').val();
    let ugc_element_placement = $('.ugc_element_placement option:selected').val();

    $.ajax({
      url: '/create_ugc_element',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        element_id: element_id_val,
        element_class: element_class_val,
        element_index: element_index_val,
        parent_id: parent_id_val,
        parent_class: parent_class_val,
        parent_index: parent_index_val,
        grand_id: grand_id_val,
        grand_class: grand_class_val,
        grand_index: grand_index_val,
        great_grand_id: great_grand_id_val,
        great_grand_class: great_grand_class_val,
        element_placement: ugc_element_placement,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('要素の挿入先を登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_element_hierarchy_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();
    let element_hierarchy_input_val = $('#element_hierarchy_input').val();
    let ugc_element_placement = $('.ugc_element_hierarchy_list .ugc_element_placement option:selected').val();

    $.ajax({
      url: '/create_ugc_element_hierarchy',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        element_hierarchy_input: element_hierarchy_input_val,
        element_placement: ugc_element_placement,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('要素の挿入先を登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_add_tab_submit').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();
    let ugc_add_tab_name = $('.ugc_add_tab_input').val();

    if (!ugc_add_tab_name) {
      alert('タブ名を入力してください。');
      return;
    }

    $.ajax({
      url: '/add_tab_name',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        tab_name: ugc_add_tab_name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('タブを追加しました。');
        location.reload();
      }
    });
  });

  $('.ugc_tag_check').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();
    let tab_id = $('.ugc_tab_select option:selected').val();
    let sns_post_ugc_group_id = $(this).data('sns_post_ugc_group_id');
    let check_flag;

    if ($(this).prop('checked')) {
      // チェックボックスはチェックされています
      check_flag = 1;
    } else {
      // チェックボックスはチェックされていません
      check_flag = 0;
    }

    $.ajax({
      url: '/link_tab_to_post',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        tab_id: tab_id,
        sns_post_ugc_group_id: sns_post_ugc_group_id,
        check_flag: check_flag,
      },
      dataType: 'json',
    }).done(function (data) {});
  });

  $('.ugc_tab_select').on('change', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();
    let tab_id = $('.ugc_tab_select option:selected').val();
    let sns_post_ugc_group_id = $(this).data('sns_post_ugc_group_id');

    let url = new URL(window.location.href);
    if (url.searchParams.has('tab_id')) {
      url.searchParams.set('tab_id', tab_id);
    } else {
      url.searchParams.append('tab_id', tab_id);
    }
    history.replaceState({}, null, url.toString());
    location.reload();
  });

  $('#ugc_edit_tab_name_submit').on('click', function () {
    let tab_id = $('.ugc_tab_select option:selected').val();
    let ugc_edit_tab_name_input = $('.ugc_edit_tab_name_input').val();
    let ugc_tab_style_id = $(this).data('ugc_tab_style_id');

    if (!ugc_edit_tab_name_input) {
      alert('名前を入れて下さい。');
      return;
    }

    $.ajax({
      url: '/edit_tab_name',
      type: 'POST',
      data: {
        tab_id: tab_id,
        edit_tab_name: ugc_edit_tab_name_input,
        ugc_tab_style_id: ugc_tab_style_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('タブ名を編集しました。');
        location.reload();
      }
    });
  });

  $('.ugc_tag_delete').on('click', function () {
    let tab_id = $('.ugc_tab_select option:selected').val();
    let ugc_tab_style_id = $(this).data('ugc_tab_style_id');

    $.ajax({
      url: '/delete_ugc_tag',
      type: 'POST',
      data: {
        tab_id: tab_id,
        ugc_tab_style_id: ugc_tab_style_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('カテゴリを削除しました。');
        let url = new URL(window.location.href);
        url.searchParams.delete('tab_id');
        history.replaceState({}, null, url.toString());
        location.reload();
      } else {
        alert('最後の一個のカテゴリは削除できません。');
      }
    });
  });

  $('#ugc_common_custom_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();
    let is_category_title = $('#is_category_title').val();
    let is_category_title_icon = $('#is_category_title_icon').val();
    let category_title_margin = $('#category_title_margin').val();
    let category_title_height = $('#category_title_height').val();
    let category_title_justify_content = $('#category_title_justify_content').val();
    let category_title_icon_size = $('#category_title_icon_size').val();
    let category_title_original_icon_width = $('#category_title_original_icon_width').val();
    let category_title_original_icon_height = $('#category_title_original_icon_height').val();
    let category_title_original_icon_img_url = $('#category_title_original_icon_img_url').val();
    let category_title_icon_margin = $('#category_title_icon_margin').val();
    let category_title_text = $('#category_title_text').val();
    let category_title_font_family = $('#category_title_font_family').val();
    let category_title_font_size = $('#category_title_font_size').val();
    let category_title_font_weight = $('#category_title_font_weight').val();
    let category_title_font_color = $('#category_title_font_color').val();

    let category_subtitle_margin = $('#category_subtitle_margin').val();
    let category_subtitle_height = $('#category_subtitle_height').val();
    let category_subtitle_text = $('#category_subtitle_text').val();
    let category_subtitle_font_family = $('#category_subtitle_font_family').val();
    let category_subtitle_font_size = $('#category_subtitle_font_size').val();
    let category_subtitle_font_weight = $('#category_subtitle_font_weight').val();
    let category_subtitle_font_color = $('#category_subtitle_font_color').val();

    let clickable_subtitle_margin = $('#clickable_subtitle_margin').val();
    let clickable_subtitle_height = $('#clickable_subtitle_height').val();
    let clickable_subtitle_text = $('#clickable_subtitle_text').val();
    let clickable_subtitle_font_family = $('#clickable_subtitle_font_family').val();
    let clickable_subtitle_font_size = $('#clickable_subtitle_font_size').val();
    let clickable_subtitle_font_weight = $('#clickable_subtitle_font_weight').val();
    let clickable_subtitle_font_color = $('#clickable_subtitle_font_color').val();
    let clickable_subtitle_text_align = $('#clickable_subtitle_text_align').val();
    let clickable_subtitle_a_text = $('#clickable_subtitle_a_text').val();
    let clickable_subtitle_a_url = $('#clickable_subtitle_a_url').val();
    let clickable_subtitle_a_font_family = $('#clickable_subtitle_a_font_family').val();
    let clickable_subtitle_a_font_size = $('#clickable_subtitle_a_font_size').val();
    let clickable_subtitle_a_font_weight = $('#clickable_subtitle_a_font_weight').val();
    let clickable_subtitle_a_font_color = $('#clickable_subtitle_a_font_color').val();
    let clickable_subtitle_a_margin = $('#clickable_subtitle_a_margin').val();
    let clickable_subtitle_a_text_decoration = $('#clickable_subtitle_a_text_decoration').val();

    let container_justify_content = $('#container_justify_content').val();
    let container_width = $('#container_width').val();
    let container_margin = $('#container_margin').val();
    let container_margin_x = $('#container_margin_x').val();
    let container_left = $('#container_left').val();
    let container_transform = $('#container_transform').val();
    let img_column_count = $('#img_column_count').val();
    let img_box_width = $('#img_box_width').val();
    let img_box_height = $('#img_box_height').val();
    let img_box_border_radius = $('#img_box_border_radius').val();
    let img_box_object_fit = $('#img_box_object_fit').val();
    let img_box_margin = $('#img_box_margin').val();
    let img_box_background_color = $('#img_box_background_color').val();
    let is_caption = $('#is_caption').val();
    let is_hover = $('#is_hover').val();

    let caption_font_size = $('#caption_font_size').val();
    let caption_font_family = $('#caption_font_family').val();
    let caption_font_weight = $('#caption_font_weight').val();
    let caption_font_color = $('#caption_font_color').val();
    let caption_height = $('#caption_height').val();
    let caption_max_height = $('#caption_max_height').val();
    let caption_line_height = $('#caption_line_height').val();
    let caption_margin = $('#caption_margin').val();
    let caption_blur_height = $('#caption_blur_height').val();
    let caption_blur_width = $('#caption_blur_width').val();
    let caption_blur_top = $('#caption_blur_top').val();
    let caption_blur_left = $('#caption_blur_left').val();
    let caption_blur_background_color = $('#caption_blur_background_color').val();

    let is_username = $('#is_username').val();
    let username_justify_content = $('#username_justify_content').val();
    let username_margin = $('#username_margin').val();
    let is_username_icon = $('#is_username_icon').val();
    let username_icon_width = $('#username_icon_width').val();
    let username_icon_height = $('#username_icon_height').val();
    let username_icon_margin = $('#username_icon_margin').val();
    let username_font_size = $('#username_font_size').val();
    let username_font_family = $('#username_font_family').val();
    let username_font_weight = $('#username_font_weight').val();
    let username_font_color = $('#username_font_color').val();

    $.ajax({
      url: '/update_ugc_common_styles',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        is_category_title: is_category_title,
        is_category_title_icon: is_category_title_icon,
        category_title_margin: category_title_margin,
        category_title_height: category_title_height,
        category_title_justify_content: category_title_justify_content,
        category_title_icon_size: category_title_icon_size,
        category_title_original_icon_width: category_title_original_icon_width,
        category_title_original_icon_height: category_title_original_icon_height,
        category_title_original_icon_img_url: category_title_original_icon_img_url,
        category_title_icon_margin: category_title_icon_margin,
        category_title_text: category_title_text,
        category_title_font_family: category_title_font_family,
        category_title_font_size: category_title_font_size,
        category_title_font_weight: category_title_font_weight,
        category_title_font_color: category_title_font_color,
        category_subtitle_margin: category_subtitle_margin,
        category_subtitle_height: category_subtitle_height,
        category_subtitle_text: category_subtitle_text,
        category_subtitle_font_family: category_subtitle_font_family,
        category_subtitle_font_size: category_subtitle_font_size,
        category_subtitle_font_weight: category_subtitle_font_weight,
        category_subtitle_font_color: category_subtitle_font_color,
        clickable_subtitle_margin: clickable_subtitle_margin,
        clickable_subtitle_height: clickable_subtitle_height,
        clickable_subtitle_text: clickable_subtitle_text,
        clickable_subtitle_font_family: clickable_subtitle_font_family,
        clickable_subtitle_font_size: clickable_subtitle_font_size,
        clickable_subtitle_font_weight: clickable_subtitle_font_weight,
        clickable_subtitle_font_color: clickable_subtitle_font_color,
        clickable_subtitle_text_align: clickable_subtitle_text_align,
        clickable_subtitle_a_text: clickable_subtitle_a_text,
        clickable_subtitle_a_url: clickable_subtitle_a_url,
        clickable_subtitle_a_font_family: clickable_subtitle_a_font_family,
        clickable_subtitle_a_font_size: clickable_subtitle_a_font_size,
        clickable_subtitle_a_font_weight: clickable_subtitle_a_font_weight,
        clickable_subtitle_a_font_color: clickable_subtitle_a_font_color,
        clickable_subtitle_a_margin: clickable_subtitle_a_margin,
        clickable_subtitle_a_text_decoration: clickable_subtitle_a_text_decoration,
        container_justify_content: container_justify_content,
        container_width: container_width,
        container_margin: container_margin,
        container_margin_x: container_margin_x,
        container_left: container_left,
        container_transform: container_transform,
        img_column_count: img_column_count,
        img_box_width: img_box_width,
        img_box_height: img_box_height,
        img_box_border_radius: img_box_border_radius,
        img_box_object_fit: img_box_object_fit,
        img_box_margin: img_box_margin,
        img_box_background_color: img_box_background_color,
        is_caption: is_caption,
        is_hover: is_hover,
        caption_font_size: caption_font_size,
        caption_font_family: caption_font_family,
        caption_font_weight: caption_font_weight,
        caption_font_color: caption_font_color,
        caption_height: caption_height,
        caption_max_height: caption_max_height,
        caption_line_height: caption_line_height,
        caption_margin: caption_margin,
        caption_blur_height: caption_blur_height,
        caption_blur_width: caption_blur_width,
        caption_blur_top: caption_blur_top,
        caption_blur_left: caption_blur_left,
        caption_blur_background_color: caption_blur_background_color,
        is_username: is_username,
        username_justify_content: username_justify_content,
        username_margin: username_margin,
        is_username_icon: is_username_icon,
        username_icon_width: username_icon_width,
        username_icon_height: username_icon_height,
        username_icon_margin: username_icon_margin,
        username_font_size: username_font_size,
        username_font_family: username_font_family,
        username_font_weight: username_font_weight,
        username_font_color: username_font_color,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('共通デザインを登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_grid_custom_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();
    let grid_first_display_img_count = $('#grid_first_display_img_count').val();
    let grid_view_more_display_img_count = $('#grid_view_more_display_img_count').val();
    let is_scroll_flag = $('#is_scroll_flag').val();
    let grid_display_btn_width = $('#grid_display_btn_width').val();
    let grid_display_btn_font_size = $('#grid_display_btn_font_size').val();
    let grid_display_btn_font_family = $('#grid_display_btn_font_family').val();
    let grid_display_btn_font_weight = $('#grid_display_btn_font_weight').val();
    let grid_display_btn_font_color = $('#grid_display_btn_font_color').val();
    let grid_view_more_btn_text = $('#grid_view_more_btn_text').val();

    let grid_view_more_text_align = $('#grid_view_more_text_align').val();
    let grid_view_more_btn_padding = $('#grid_view_more_btn_padding').val();
    let grid_view_more_btn_border = $('#grid_view_more_btn_border').val();
    let grid_view_more_btn_border_radius = $('#grid_view_more_btn_border_radius').val();

    let grid_view_more_btn_plus_minus_border_color = $('#grid_view_more_btn_plus_minus_border_color').val();
    let grid_view_more_btn_plus_minus_before_right = $('#grid_view_more_btn_plus_minus_before_right').val();
    let grid_view_more_btn_plus_minus_before_top = $('#grid_view_more_btn_plus_minus_before_top').val();
    let grid_view_more_btn_plus_minus_before_width = $('#grid_view_more_btn_plus_minus_before_width').val();
    let grid_view_more_btn_plus_minus_before_height = $('#grid_view_more_btn_plus_minus_before_height').val();
    let grid_view_more_btn_plus_minus_before_transform = $('#grid_view_more_btn_plus_minus_before_transform').val();
    let grid_view_more_btn_plus_minus_after_right = $('#grid_view_more_btn_plus_minus_after_right').val();
    let grid_view_more_btn_plus_minus_after_top = $('#grid_view_more_btn_plus_minus_after_top').val();
    let grid_view_more_btn_plus_minus_after_width = $('#grid_view_more_btn_plus_minus_after_width').val();
    let grid_view_more_btn_plus_minus_after_height = $('#grid_view_more_btn_plus_minus_after_height').val();
    let grid_view_more_btn_plus_minus_after_transform = $('#grid_view_more_btn_plus_minus_after_transform').val();

    let is_grid_view_more_btn_plus_minus = $('#is_grid_view_more_btn_plus_minus').val();
    let grid_close_btn_text = $('#grid_close_btn_text').val();
    let grid_view_more_btn_margin = $('#grid_view_more_btn_margin').val();

    $.ajax({
      url: '/update_ugc_grid_styles',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        grid_first_display_img_count: grid_first_display_img_count,
        grid_view_more_display_img_count: grid_view_more_display_img_count,
        is_scroll_flag: is_scroll_flag,
        grid_display_btn_width: grid_display_btn_width,
        grid_display_btn_font_family: grid_display_btn_font_family,
        grid_display_btn_font_weight: grid_display_btn_font_weight,
        grid_display_btn_font_color: grid_display_btn_font_color,
        grid_view_more_btn_text: grid_view_more_btn_text,
        grid_view_more_text_align: grid_view_more_text_align,
        grid_view_more_btn_padding: grid_view_more_btn_padding,
        grid_view_more_btn_border: grid_view_more_btn_border,
        grid_view_more_btn_border_radius: grid_view_more_btn_border_radius,
        is_grid_view_more_btn_plus_minus: is_grid_view_more_btn_plus_minus,
        grid_close_btn_text: grid_close_btn_text,
        grid_display_btn_font_size: grid_display_btn_font_size,
        grid_view_more_btn_margin: grid_view_more_btn_margin,
        grid_view_more_btn_plus_minus_border_color: grid_view_more_btn_plus_minus_border_color,
        grid_view_more_btn_plus_minus_before_right: grid_view_more_btn_plus_minus_before_right,
        grid_view_more_btn_plus_minus_before_top: grid_view_more_btn_plus_minus_before_top,
        grid_view_more_btn_plus_minus_before_width: grid_view_more_btn_plus_minus_before_width,
        grid_view_more_btn_plus_minus_before_height: grid_view_more_btn_plus_minus_before_height,
        grid_view_more_btn_plus_minus_before_transform: grid_view_more_btn_plus_minus_before_transform,
        grid_view_more_btn_plus_minus_after_right: grid_view_more_btn_plus_minus_after_right,
        grid_view_more_btn_plus_minus_after_top: grid_view_more_btn_plus_minus_after_top,
        grid_view_more_btn_plus_minus_after_width: grid_view_more_btn_plus_minus_after_width,
        grid_view_more_btn_plus_minus_after_height: grid_view_more_btn_plus_minus_after_height,
        grid_view_more_btn_plus_minus_after_transform: grid_view_more_btn_plus_minus_after_transform,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('グリッドデザインを登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_slider_custom_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();

    let is_slider_prev_btn = $('#is_slider_prev_btn').val();
    let slider_prev_btn_top = $('#slider_prev_btn_top').val();
    let slider_prev_btn_left = $('#slider_prev_btn_left').val();
    let slider_prev_btn_width = $('#slider_prev_btn_width').val();
    let slider_prev_btn_height = $('#slider_prev_btn_height').val();
    let slider_prev_btn_border_radius = $('#slider_prev_btn_border_radius').val();
    let slider_prev_btn_text_color = $('#slider_prev_btn_text_color').val();
    let slider_prev_btn_backgroud_color = $('#slider_prev_btn_backgroud_color').val();
    let slider_prev_btn_backgroud_opacity = $('#slider_prev_btn_backgroud_opacity').val();
    let slider_prev_btn_text_line_width = $('#slider_prev_btn_text_line_width').val();
    let slider_prev_btn_text_line_height = $('#slider_prev_btn_text_line_height').val();
    let slider_prev_btn_text_line_weight = $('#slider_prev_btn_text_line_weight').val();
    let slider_prev_btn_text_position_right = $('#slider_prev_btn_text_position_right').val();
    let slider_prev_btn_text_position_top = $('#slider_prev_btn_text_position_top').val();
    let slider_prev_btn_text_line_rotate = $('#slider_prev_btn_text_line_rotate').val();
    let slider_prev_btn_text_line_translatey = $('#slider_prev_btn_text_line_translatey').val();
    let slider_prev_btn_text_line_skew = $('#slider_prev_btn_text_line_skew').val();
    let is_slider_next_btn = $('#is_slider_next_btn').val();
    let slider_next_btn_top = $('#slider_next_btn_top').val();
    let slider_next_btn_left = $('#slider_next_btn_left').val();
    let slider_next_btn_width = $('#slider_next_btn_width').val();
    let slider_next_btn_height = $('#slider_next_btn_height').val();
    let slider_next_btn_border_radius = $('#slider_next_btn_border_radius').val();
    let slider_next_btn_text_color = $('#slider_next_btn_text_color').val();
    let slider_next_btn_backgroud_color = $('#slider_next_btn_backgroud_color').val();
    let slider_next_btn_backgroud_opacity = $('#slider_next_btn_backgroud_opacity').val();
    let slider_next_btn_text_line_width = $('#slider_next_btn_text_line_width').val();
    let slider_next_btn_text_line_height = $('#slider_next_btn_text_line_height').val();
    let slider_next_btn_text_line_weight = $('#slider_next_btn_text_line_weight').val();
    let slider_next_btn_text_position_right = $('#slider_next_btn_text_position_right').val();
    let slider_next_btn_text_position_top = $('#slider_next_btn_text_position_top').val();
    let slider_next_btn_text_line_rotate = $('#slider_next_btn_text_line_rotate').val();
    let slider_next_btn_text_line_translatey = $('#slider_next_btn_text_line_translatey').val();
    let slider_next_btn_text_line_skew = $('#slider_next_btn_text_line_skew').val();
    let slider_btn_z_index = $('#slider_btn_z_index').val();

    $.ajax({
      url: '/update_ugc_slider_styles',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        is_slider_prev_btn: is_slider_prev_btn,
        slider_prev_btn_top: slider_prev_btn_top,
        slider_prev_btn_left: slider_prev_btn_left,
        slider_prev_btn_width: slider_prev_btn_width,
        slider_prev_btn_height: slider_prev_btn_height,
        slider_prev_btn_border_radius: slider_prev_btn_border_radius,
        slider_prev_btn_text_color: slider_prev_btn_text_color,
        slider_prev_btn_backgroud_color: slider_prev_btn_backgroud_color,
        slider_prev_btn_backgroud_opacity: slider_prev_btn_backgroud_opacity,
        slider_prev_btn_text_line_width: slider_prev_btn_text_line_width,
        slider_prev_btn_text_line_height: slider_prev_btn_text_line_height,
        slider_prev_btn_text_line_weight: slider_prev_btn_text_line_weight,
        slider_prev_btn_text_position_right: slider_prev_btn_text_position_right,
        slider_prev_btn_text_position_top: slider_prev_btn_text_position_top,
        slider_prev_btn_text_line_rotate: slider_prev_btn_text_line_rotate,
        slider_prev_btn_text_line_translatey: slider_prev_btn_text_line_translatey,
        slider_prev_btn_text_line_skew: slider_prev_btn_text_line_skew,
        is_slider_next_btn: is_slider_next_btn,
        slider_next_btn_top: slider_next_btn_top,
        slider_next_btn_left: slider_next_btn_left,
        slider_next_btn_width: slider_next_btn_width,
        slider_next_btn_height: slider_next_btn_height,
        slider_next_btn_border_radius: slider_next_btn_border_radius,
        slider_next_btn_text_color: slider_next_btn_text_color,
        slider_next_btn_backgroud_color: slider_next_btn_backgroud_color,
        slider_next_btn_backgroud_opacity: slider_next_btn_backgroud_opacity,
        slider_next_btn_text_line_width: slider_next_btn_text_line_width,
        slider_next_btn_text_line_height: slider_next_btn_text_line_height,
        slider_next_btn_text_line_weight: slider_next_btn_text_line_weight,
        slider_next_btn_text_position_right: slider_next_btn_text_position_right,
        slider_next_btn_text_position_top: slider_next_btn_text_position_top,
        slider_next_btn_text_line_rotate: slider_next_btn_text_line_rotate,
        slider_next_btn_text_line_translatey: slider_next_btn_text_line_translatey,
        slider_next_btn_text_line_skew: slider_next_btn_text_line_skew,
        slider_btn_z_index: slider_btn_z_index,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('スライダーのデザインを登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_tab_custom_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();

    let tab_name_container_justify_content = $('#tab_name_container_justify_content').val();
    let tab_name_container_margin = $('#tab_name_container_margin').val();
    let tab_name_font_size = $('#tab_name_font_size').val();
    let tab_name_font_family = $('#tab_name_font_family').val();
    let tab_name_font_weight = $('#tab_name_font_weight').val();
    let tab_name_font_color = $('#tab_name_font_color').val();
    let tab_name_border_radius = $('#tab_name_border_radius').val();
    let tab_name_border = $('#tab_name_border').val();
    let tab_name_padding = $('#tab_name_padding').val();
    let tab_name_margin = $('#tab_name_margin').val();
    let tab_name_max_width = $('#tab_name_max_width').val();
    let tab_name_background_color = $('#tab_name_background_color').val();
    let tab_name_transition = $('#tab_name_transition').val();
    let tab_name_hover_background_color = $('#tab_name_hover_background_color').val();
    let tab_name_hover_font_color = $('#tab_name_hover_font_color').val();
    let tab_name_hover_opacity = $('#tab_name_hover_opacity').val();
    let tab_name_selected_background_color = $('#tab_name_selected_background_color').val();
    let tab_name_selected_font_color = $('#tab_name_selected_font_color').val();
    let tab_loading_text = $('#tab_loading_text').val();
    let tab_loading_width = $('#tab_loading_width').val();
    let tab_loading_height = $('#tab_loading_height').val();
    let tab_loading_font_size = $('#tab_loading_font_size').val();
    let tab_loading_font_family = $('#tab_loading_font_family').val();
    let tab_loading_font_weight = $('#tab_loading_font_weight').val();
    let tab_loading_font_color = $('#tab_loading_font_color').val();

    let tab_first_display_img_count = $('#tab_first_display_img_count').val();
    let tab_view_more_display_img_count = $('#tab_view_more_display_img_count').val();
    let tab_display_btn_width = $('#tab_display_btn_width').val();
    let tab_display_btn_font_size = $('#tab_display_btn_font_size').val();
    let tab_display_btn_font_family = $('#tab_display_btn_font_family').val();
    let tab_display_btn_font_weight = $('#tab_display_btn_font_weight').val();
    let tab_display_btn_font_color = $('#tab_display_btn_font_color').val();
    let tab_view_more_btn_text = $('#tab_view_more_btn_text').val();

    let tab_view_more_text_align = $('#tab_view_more_text_align').val();
    let tab_view_more_btn_padding = $('#tab_view_more_btn_padding').val();
    let tab_view_more_btn_border = $('#tab_view_more_btn_border').val();
    let tab_view_more_btn_border_radius = $('#tab_view_more_btn_border_radius').val();

    let tab_view_more_btn_plus_minus_border_color = $('#tab_view_more_btn_plus_minus_border_color').val();
    let tab_view_more_btn_plus_minus_before_right = $('#tab_view_more_btn_plus_minus_before_right').val();
    let tab_view_more_btn_plus_minus_before_top = $('#tab_view_more_btn_plus_minus_before_top').val();
    let tab_view_more_btn_plus_minus_before_width = $('#tab_view_more_btn_plus_minus_before_width').val();
    let tab_view_more_btn_plus_minus_before_height = $('#tab_view_more_btn_plus_minus_before_height').val();
    let tab_view_more_btn_plus_minus_before_transform = $('#tab_view_more_btn_plus_minus_before_transform').val();
    let tab_view_more_btn_plus_minus_after_right = $('#tab_view_more_btn_plus_minus_after_right').val();
    let tab_view_more_btn_plus_minus_after_top = $('#tab_view_more_btn_plus_minus_after_top').val();
    let tab_view_more_btn_plus_minus_after_width = $('#tab_view_more_btn_plus_minus_after_width').val();
    let tab_view_more_btn_plus_minus_after_height = $('#tab_view_more_btn_plus_minus_after_height').val();
    let tab_view_more_btn_plus_minus_after_transform = $('#tab_view_more_btn_plus_minus_after_transform').val();

    let is_tab_view_more_btn_plus_minus = $('#is_tab_view_more_btn_plus_minus').val();
    let tab_close_btn_text = $('#tab_close_btn_text').val();
    let tab_view_more_btn_margin = $('#tab_view_more_btn_margin').val();

    $.ajax({
      url: '/update_ugc_tab_styles',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        tab_name_container_justify_content: tab_name_container_justify_content,
        tab_name_container_margin: tab_name_container_margin,
        tab_name_font_size: tab_name_font_size,
        tab_name_font_family: tab_name_font_family,
        tab_name_font_weight: tab_name_font_weight,
        tab_name_font_color: tab_name_font_color,
        tab_name_border_radius: tab_name_border_radius,
        tab_name_border: tab_name_border,
        tab_name_padding: tab_name_padding,
        tab_name_margin: tab_name_margin,
        tab_name_max_width: tab_name_max_width,
        tab_name_background_color: tab_name_background_color,
        tab_name_transition: tab_name_transition,
        tab_name_hover_background_color: tab_name_hover_background_color,
        tab_name_hover_font_color: tab_name_hover_font_color,
        tab_name_hover_opacity: tab_name_hover_opacity,
        tab_name_selected_background_color: tab_name_selected_background_color,
        tab_name_selected_font_color: tab_name_selected_font_color,
        tab_loading_text: tab_loading_text,
        tab_loading_width: tab_loading_width,
        tab_loading_height: tab_loading_height,
        tab_loading_font_size: tab_loading_font_size,
        tab_loading_font_family: tab_loading_font_family,
        tab_loading_font_weight: tab_loading_font_weight,
        tab_loading_font_color: tab_loading_font_color,
        tab_first_display_img_count: tab_first_display_img_count,
        tab_view_more_display_img_count: tab_view_more_display_img_count,
        tab_display_btn_width: tab_display_btn_width,
        tab_display_btn_font_family: tab_display_btn_font_family,
        tab_display_btn_font_weight: tab_display_btn_font_weight,
        tab_display_btn_font_color: tab_display_btn_font_color,
        tab_view_more_btn_text: tab_view_more_btn_text,
        tab_view_more_text_align: tab_view_more_text_align,
        tab_view_more_btn_padding: tab_view_more_btn_padding,
        tab_view_more_btn_border: tab_view_more_btn_border,
        tab_view_more_btn_border_radius: tab_view_more_btn_border_radius,
        is_tab_view_more_btn_plus_minus: is_tab_view_more_btn_plus_minus,
        tab_close_btn_text: tab_close_btn_text,
        tab_display_btn_font_size: tab_display_btn_font_size,
        tab_view_more_btn_margin: tab_view_more_btn_margin,
        tab_view_more_btn_plus_minus_border_color: tab_view_more_btn_plus_minus_border_color,
        tab_view_more_btn_plus_minus_before_right: tab_view_more_btn_plus_minus_before_right,
        tab_view_more_btn_plus_minus_before_top: tab_view_more_btn_plus_minus_before_top,
        tab_view_more_btn_plus_minus_before_width: tab_view_more_btn_plus_minus_before_width,
        tab_view_more_btn_plus_minus_before_height: tab_view_more_btn_plus_minus_before_height,
        tab_view_more_btn_plus_minus_before_transform: tab_view_more_btn_plus_minus_before_transform,
        tab_view_more_btn_plus_minus_after_right: tab_view_more_btn_plus_minus_after_right,
        tab_view_more_btn_plus_minus_after_top: tab_view_more_btn_plus_minus_after_top,
        tab_view_more_btn_plus_minus_after_width: tab_view_more_btn_plus_minus_after_width,
        tab_view_more_btn_plus_minus_after_height: tab_view_more_btn_plus_minus_after_height,
        tab_view_more_btn_plus_minus_after_transform: tab_view_more_btn_plus_minus_after_transform,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('タブ表示デザインを登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_modal_custom_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();

    let modal_max_width = $('#modal_max_width').val();
    let modal_max_height = $('#modal_max_height').val();
    let modal_left_width = $('#modal_left_width').val();
    let modal_right_width = $('#modal_right_width').val();
    let modal_right_height = $('#modal_right_height').val();
    let is_modal_related_items = $('#is_modal_related_items').val();
    let is_modal_related_items_title = $('#is_modal_related_items_title').val();
    let modal_related_items_title_text = $('#modal_related_items_title_text').val();
    let modal_related_items_title_font_family = $('#modal_related_items_title_font_family').val();
    let modal_related_items_title_font_size = $('#modal_related_items_title_font_size').val();
    let modal_related_items_title_font_weight = $('#modal_related_items_title_font_weight').val();
    let modal_related_items_title_font_color = $('#modal_related_items_title_font_color').val();
    let is_modal_related_items_link = $('#is_modal_related_items_link').val();
    let modal_related_items_img_column_margin = $('#modal_related_items_img_column_margin').val();
    let modal_related_items_img_column_height = $('#modal_related_items_img_column_height').val();
    let modal_related_items_img_column_width = $('#modal_related_items_img_column_width').val();
    let modal_related_items_initial_img_count = $('#modal_related_items_initial_img_count').val();
    let modal_related_items_img_height = $('#modal_related_items_img_height').val();
    let modal_related_items_img_width = $('#modal_related_items_img_width').val();
    let modal_related_items_img_margin = $('#modal_related_items_img_margin').val();
    let modal_related_items_name_line_height = $('#modal_related_items_name_line_height').val();
    let modal_related_items_name_font_size = $('#modal_related_items_name_font_size').val();
    let modal_related_items_name_font_family = $('#modal_related_items_name_font_family').val();
    let modal_related_items_name_font_weight = $('#modal_related_items_name_font_weight').val();
    let modal_related_items_name_text_align = $('#modal_related_items_name_text_align').val();
    let modal_related_items_name_font_color = $('#modal_related_items_name_font_color').val();
    let modal_related_items_price_font_size = $('#modal_related_items_price_font_size').val();
    let modal_related_items_price_font_family = $('#modal_related_items_price_font_family').val();
    let modal_related_items_price_font_weight = $('#modal_related_items_price_font_weight').val();
    let modal_related_items_price_text_align = $('#modal_related_items_price_text_align').val();
    let modal_related_items_price_font_color = $('#modal_related_items_price_font_color').val();
    let modal_related_items_price_unit_text = $('#modal_related_items_price_unit_text').val();
    let is_modal_photo_by_link = $('#is_modal_photo_by_link').val();
    let modal_photo_by_icon_size = $('#modal_photo_by_icon_size').val();
    let modal_photo_by_margin = $('#modal_photo_by_margin').val();
    let modal_photo_by_text_align = $('#modal_photo_by_text_align').val();
    let modal_photo_by_text = $('#modal_photo_by_text').val();
    let modal_photo_by_font_size = $('#modal_photo_by_font_size').val();
    let modal_photo_by_font_family = $('#modal_photo_by_font_family').val();
    let modal_photo_by_font_weight = $('#modal_photo_by_font_weight').val();
    let modal_photo_by_font_color = $('#modal_photo_by_font_color').val();
    let is_modal_related_items_product_comment = $('#is_modal_related_items_product_comment').val();
    let modal_related_items_product_comment_height = $('#modal_related_items_product_comment_height').val();
    let modal_related_items_product_comment_line_height = $('#modal_related_items_product_comment_line_height').val();
    let modal_related_items_product_comment_position = $('#modal_related_items_product_comment_position').val();
    let modal_related_items_product_comment_font_size = $('#modal_related_items_product_comment_font_size').val();
    let modal_related_items_product_comment_font_family = $('#modal_related_items_product_comment_font_family').val();
    let modal_related_items_product_comment_font_weight = $('#modal_related_items_product_comment_font_weight').val();
    let modal_related_items_product_comment_font_color = $('#modal_related_items_product_comment_font_color').val();
    let modal_del_btn_size = $('#modal_del_btn_size').val();
    let modal_sns_post_img_object_fit = $('#modal_sns_post_img_object_fit').val();

    let modal_prev_post_btn_bg_color = $('#modal_prev_post_btn_bg_color').val();
    let modal_prev_post_btn_opacity = $('#modal_prev_post_btn_opacity').val();
    let modal_prev_post_btn_top = $('#modal_prev_post_btn_top').val();
    let modal_prev_post_btn_left = $('#modal_prev_post_btn_left').val();
    let modal_prev_post_btn_width = $('#modal_prev_post_btn_width').val();
    let modal_prev_post_btn_height = $('#modal_prev_post_btn_height').val();
    let modal_prev_post_btn_line_color = $('#modal_prev_post_btn_line_color').val();
    let modal_prev_post_btn_line_width = $('#modal_prev_post_btn_line_width').val();
    let modal_prev_post_btn_line_height = $('#modal_prev_post_btn_line_height').val();
    let modal_prev_post_btn_line_right = $('#modal_prev_post_btn_line_right').val();
    let modal_prev_post_btn_line_top = $('#modal_prev_post_btn_line_top').val();
    let modal_prev_post_btn_line_weight = $('#modal_prev_post_btn_line_weight').val();
    let modal_prev_post_btn_line_rotate = $('#modal_prev_post_btn_line_rotate').val();
    let modal_prev_post_btn_line_translatey = $('#modal_prev_post_btn_line_translatey').val();

    let modal_next_post_btn_bg_color = $('#modal_next_post_btn_bg_color').val();
    let modal_next_post_btn_opacity = $('#modal_next_post_btn_opacity').val();
    let modal_next_post_btn_top = $('#modal_next_post_btn_top').val();
    let modal_next_post_btn_left = $('#modal_next_post_btn_left').val();
    let modal_next_post_btn_width = $('#modal_next_post_btn_width').val();
    let modal_next_post_btn_height = $('#modal_next_post_btn_height').val();
    let modal_next_post_btn_line_color = $('#modal_next_post_btn_line_color').val();
    let modal_next_post_btn_line_width = $('#modal_next_post_btn_line_width').val();
    let modal_next_post_btn_line_height = $('#modal_next_post_btn_line_height').val();
    let modal_next_post_btn_line_right = $('#modal_next_post_btn_line_right').val();
    let modal_next_post_btn_line_top = $('#modal_next_post_btn_line_top').val();
    let modal_next_post_btn_line_weight = $('#modal_next_post_btn_line_weight').val();
    let modal_next_post_btn_line_rotate = $('#modal_next_post_btn_line_rotate').val();
    let modal_next_post_btn_line_translatey = $('#modal_next_post_btn_line_translatey').val();

    let modal_dot_left_display = $('#modal_dot_left_display').val();
    let modal_dot_left_bg_color = $('#modal_dot_left_bg_color').val();
    let modal_dot_left_height = $('#modal_dot_left_height').val();
    let modal_dot_left_width = $('#modal_dot_left_width').val();
    let modal_dot_left_opacity = $('#modal_dot_left_opacity').val();
    let modal_dot_left_border = $('#modal_dot_left_border').val();
    let modal_dot_left_border_radius = $('#modal_dot_left_border_radius').val();
    let modal_dot_left_margin = $('#modal_dot_left_margin').val();
    let modal_dot_left_line_height = $('#modal_dot_left_line_height').val();
    let modal_dot_left_line_width = $('#modal_dot_left_line_width').val();
    let modal_dot_left_line_top = $('#modal_dot_left_line_top').val();
    let modal_dot_left_line_right = $('#modal_dot_left_line_right').val();
    let modal_dot_left_line_border_top = $('#modal_dot_left_line_border_top').val();
    let modal_dot_left_line_border_right = $('#modal_dot_left_line_border_right').val();
    let modal_dot_left_line_transform = $('#modal_dot_left_line_transform').val();

    let modal_dot_right_display = $('#modal_dot_right_display').val();
    let modal_dot_right_bg_color = $('#modal_dot_right_bg_color').val();
    let modal_dot_right_height = $('#modal_dot_right_height').val();
    let modal_dot_right_width = $('#modal_dot_right_width').val();
    let modal_dot_right_opacity = $('#modal_dot_right_opacity').val();
    let modal_dot_right_border = $('#modal_dot_right_border').val();
    let modal_dot_right_border_radius = $('#modal_dot_right_border_radius').val();
    let modal_dot_right_margin = $('#modal_dot_right_margin').val();
    let modal_dot_right_line_height = $('#modal_dot_right_line_height').val();
    let modal_dot_right_line_width = $('#modal_dot_right_line_width').val();
    let modal_dot_right_line_top = $('#modal_dot_right_line_top').val();
    let modal_dot_right_line_right = $('#modal_dot_right_line_right').val();
    let modal_dot_right_line_border_top = $('#modal_dot_right_line_border_top').val();
    let modal_dot_right_line_border_right = $('#modal_dot_right_line_border_right').val();
    let modal_dot_right_line_transform = $('#modal_dot_right_line_transform').val();

    let modal_dot_display = $('#modal_dot_display').val();
    let modal_dot_height = $('#modal_dot_height').val();
    let modal_dot_width = $('#modal_dot_width').val();
    let modal_dot_opacity = $('#modal_dot_opacity').val();
    let modal_dot_border = $('#modal_dot_border').val();
    let modal_dot_border_radius = $('#modal_dot_border_radius').val();
    let modal_dot_margin = $('#modal_dot_margin').val();

    $.ajax({
      url: '/update_ugc_modal_styles',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,

        modal_max_width: modal_max_width,
        modal_max_height: modal_max_height,
        modal_left_width: modal_left_width,
        modal_right_width: modal_right_width,
        modal_right_height: modal_right_height,
        is_modal_related_items: is_modal_related_items,
        is_modal_related_items_title: is_modal_related_items_title,
        modal_related_items_title_text: modal_related_items_title_text,
        modal_related_items_title_font_family: modal_related_items_title_font_family,
        modal_related_items_title_font_weight: modal_related_items_title_font_weight,
        modal_related_items_title_font_size: modal_related_items_title_font_size,
        modal_related_items_title_font_color: modal_related_items_title_font_color,
        is_modal_related_items_link: is_modal_related_items_link,
        modal_related_items_img_column_margin: modal_related_items_img_column_margin,
        modal_related_items_img_column_height: modal_related_items_img_column_height,
        modal_related_items_img_column_width: modal_related_items_img_column_width,
        modal_related_items_initial_img_count: modal_related_items_initial_img_count,
        modal_related_items_img_height: modal_related_items_img_height,
        modal_related_items_img_width: modal_related_items_img_width,
        modal_related_items_img_margin: modal_related_items_img_margin,
        modal_related_items_name_line_height: modal_related_items_name_line_height,
        modal_related_items_name_font_size: modal_related_items_name_font_size,
        modal_related_items_name_font_family: modal_related_items_name_font_family,
        modal_related_items_name_font_weight: modal_related_items_name_font_weight,
        modal_related_items_name_font_color: modal_related_items_name_font_color,
        modal_related_items_name_text_align: modal_related_items_name_text_align,
        modal_related_items_price_font_size: modal_related_items_price_font_size,
        modal_related_items_price_font_family: modal_related_items_price_font_family,
        modal_related_items_price_font_weight: modal_related_items_price_font_weight,
        modal_related_items_price_font_color: modal_related_items_price_font_color,
        modal_related_items_price_text_align: modal_related_items_price_text_align,
        modal_related_items_price_unit_text: modal_related_items_price_unit_text,
        is_modal_photo_by_link: is_modal_photo_by_link,
        modal_photo_by_icon_size: modal_photo_by_icon_size,
        modal_photo_by_margin: modal_photo_by_margin,
        modal_photo_by_text_align: modal_photo_by_text_align,
        modal_photo_by_text: modal_photo_by_text,
        modal_photo_by_font_size: modal_photo_by_font_size,
        modal_photo_by_font_family: modal_photo_by_font_family,
        modal_photo_by_font_weight: modal_photo_by_font_weight,
        modal_photo_by_font_color: modal_photo_by_font_color,
        is_modal_related_items_product_comment: is_modal_related_items_product_comment,
        modal_related_items_product_comment_height: modal_related_items_product_comment_height,
        modal_related_items_product_comment_line_height: modal_related_items_product_comment_line_height,
        modal_related_items_product_comment_position: modal_related_items_product_comment_position,
        modal_related_items_product_comment_font_size: modal_related_items_product_comment_font_size,
        modal_related_items_product_comment_font_family: modal_related_items_product_comment_font_family,
        modal_related_items_product_comment_font_weight: modal_related_items_product_comment_font_weight,
        modal_related_items_product_comment_font_color: modal_related_items_product_comment_font_color,
        modal_del_btn_size: modal_del_btn_size,
        modal_sns_post_img_object_fit: modal_sns_post_img_object_fit,
        modal_prev_post_btn_bg_color: modal_prev_post_btn_bg_color,
        modal_prev_post_btn_opacity: modal_prev_post_btn_opacity,
        modal_prev_post_btn_top: modal_prev_post_btn_top,
        modal_prev_post_btn_left: modal_prev_post_btn_left,
        modal_prev_post_btn_width: modal_prev_post_btn_width,
        modal_prev_post_btn_height: modal_prev_post_btn_height,
        modal_prev_post_btn_line_color: modal_prev_post_btn_line_color,
        modal_prev_post_btn_line_width: modal_prev_post_btn_line_width,
        modal_prev_post_btn_line_height: modal_prev_post_btn_line_height,
        modal_prev_post_btn_line_right: modal_prev_post_btn_line_right,
        modal_prev_post_btn_line_top: modal_prev_post_btn_line_top,
        modal_prev_post_btn_line_weight: modal_prev_post_btn_line_weight,
        modal_prev_post_btn_line_rotate: modal_prev_post_btn_line_rotate,
        modal_prev_post_btn_line_translatey: modal_prev_post_btn_line_translatey,
        modal_next_post_btn_bg_color: modal_next_post_btn_bg_color,
        modal_next_post_btn_opacity: modal_next_post_btn_opacity,
        modal_next_post_btn_top: modal_next_post_btn_top,
        modal_next_post_btn_left: modal_next_post_btn_left,
        modal_next_post_btn_width: modal_next_post_btn_width,
        modal_next_post_btn_height: modal_next_post_btn_height,
        modal_next_post_btn_line_color: modal_next_post_btn_line_color,
        modal_next_post_btn_line_width: modal_next_post_btn_line_width,
        modal_next_post_btn_line_height: modal_next_post_btn_line_height,
        modal_next_post_btn_line_right: modal_next_post_btn_line_right,
        modal_next_post_btn_line_top: modal_next_post_btn_line_top,
        modal_next_post_btn_line_weight: modal_next_post_btn_line_weight,
        modal_next_post_btn_line_rotate: modal_next_post_btn_line_rotate,
        modal_next_post_btn_line_translatey: modal_next_post_btn_line_translatey,
        modal_dot_left_display: modal_dot_left_display,
        modal_dot_left_bg_color: modal_dot_left_bg_color,
        modal_dot_left_height: modal_dot_left_height,
        modal_dot_left_width: modal_dot_left_width,
        modal_dot_left_opacity: modal_dot_left_opacity,
        modal_dot_left_border: modal_dot_left_border,
        modal_dot_left_border_radius: modal_dot_left_border_radius,
        modal_dot_left_margin: modal_dot_left_margin,
        modal_dot_left_line_height: modal_dot_left_line_height,
        modal_dot_left_line_width: modal_dot_left_line_width,
        modal_dot_left_line_top: modal_dot_left_line_top,
        modal_dot_left_line_right: modal_dot_left_line_right,
        modal_dot_left_line_border_top: modal_dot_left_line_border_top,
        modal_dot_left_line_border_right: modal_dot_left_line_border_right,
        modal_dot_left_line_transform: modal_dot_left_line_transform,
        modal_dot_right_display: modal_dot_right_display,
        modal_dot_right_bg_color: modal_dot_right_bg_color,
        modal_dot_right_height: modal_dot_right_height,
        modal_dot_right_width: modal_dot_right_width,
        modal_dot_right_opacity: modal_dot_right_opacity,
        modal_dot_right_border: modal_dot_right_border,
        modal_dot_right_border_radius: modal_dot_right_border_radius,
        modal_dot_right_margin: modal_dot_right_margin,
        modal_dot_right_line_height: modal_dot_right_line_height,
        modal_dot_right_line_width: modal_dot_right_line_width,
        modal_dot_right_line_top: modal_dot_right_line_top,
        modal_dot_right_line_right: modal_dot_right_line_right,
        modal_dot_right_line_border_top: modal_dot_right_line_border_top,
        modal_dot_right_line_border_right: modal_dot_right_line_border_right,
        modal_dot_right_line_transform: modal_dot_right_line_transform,
        modal_dot_display: modal_dot_display,
        modal_dot_height: modal_dot_height,
        modal_dot_width: modal_dot_width,
        modal_dot_opacity: modal_dot_opacity,
        modal_dot_border: modal_dot_border,
        modal_dot_border_radius: modal_dot_border_radius,
        modal_dot_margin: modal_dot_margin,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('モーダルのデザインを登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_part_custom_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let ugc_group_ab_test_id = $('.ugc_group_ab_test_id').val();
    let is_device = $('#ugc_setting_device_val').val();

    let is_top_dividing_line = $('#is_top_dividing_line').val();
    let top_dividing_line_width = $('#top_dividing_line_width').val();
    let top_dividing_line_height = $('#top_dividing_line_height').val();
    let top_dividing_line_color = $('#top_dividing_line_color').val();
    let top_dividing_line_margin = $('#top_dividing_line_margin').val();
    let is_jump_other_page_btn = $('#is_jump_other_page_btn').val();
    let jump_other_page_btn_text = $('#jump_other_page_btn_text').val();
    let jump_other_page_url = $('#jump_other_page_url').val();
    let jump_other_page_btn_text_font_color = $('#jump_other_page_btn_text_font_color').val();
    let jump_other_page_btn_text_font_size = $('#jump_other_page_btn_text_font_size').val();
    let jump_other_page_btn_text_font_family = $('#jump_other_page_btn_text_font_family').val();
    let jump_other_page_btn_text_font_weight = $('#jump_other_page_btn_text_font_weight').val();
    let jump_other_page_btn_border_color = $('#jump_other_page_btn_border_color').val();
    let jump_other_page_btn_border_radius = $('#jump_other_page_btn_border_radius').val();
    let jump_other_page_btn_text_align = $('#jump_other_page_btn_text_align').val();
    let jump_other_page_btn_margin = $('#jump_other_page_btn_margin').val();
    let jump_other_page_btn_width = $('#jump_other_page_btn_width').val();
    let jump_other_page_btn_height = $('#jump_other_page_btn_height').val();
    let is_ig_cta_container = $('#is_ig_cta_container').val();
    let ig_cta_container_margin = $('#ig_cta_container_margin').val();
    let ig_cta_container_padding = $('#ig_cta_container_padding').val();
    let ig_cta_container_text_align = $('#ig_cta_container_text_align').val();
    let ig_cta_box_text = $('#ig_cta_box_text').val();
    let ig_cta_box_text_font_color = $('#ig_cta_box_text_font_color').val();
    let ig_cta_box_text_font_size = $('#ig_cta_box_text_font_size').val();
    let ig_cta_box_text_font_family = $('#ig_cta_box_text_font_family').val();
    let ig_cta_box_text_font_weight = $('#ig_cta_box_text_font_weight').val();
    let ig_cta_box_text_align = $('#ig_cta_box_text_align').val();
    let ig_cta_img_height = $('#ig_cta_img_height').val();
    let ig_cta_img_width = $('#ig_cta_img_width').val();
    let ig_cta_img_margin = $('#ig_cta_img_margin').val();
    let ig_cta_img_url = $('#ig_cta_img_url').val();

    let is_cta_title = $('#is_cta_title').val();
    let is_cta_title_icon = $('#is_cta_title_icon').val();
    let cta_title_margin = $('#cta_title_margin').val();
    let cta_title_height = $('#cta_title_height').val();
    let cta_title_justify_content = $('#cta_title_justify_content').val();
    let cta_title_icon_size = $('#cta_title_icon_size').val();
    let cta_title_icon_margin = $('#cta_title_icon_margin').val();
    let cta_title_text = $('#cta_title_text').val();
    let cta_title_font_family = $('#cta_title_font_family').val();
    let cta_title_font_size = $('#cta_title_font_size').val();
    let cta_title_font_weight = $('#cta_title_font_weight').val();
    let cta_title_font_color = $('#cta_title_font_color').val();

    $.ajax({
      url: '/update_ugc_part_styles',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        ugc_group_ab_test_id: ugc_group_ab_test_id,
        is_device: is_device,
        is_top_dividing_line: is_top_dividing_line,
        top_dividing_line_width: top_dividing_line_width,
        top_dividing_line_height: top_dividing_line_height,
        top_dividing_line_color: top_dividing_line_color,
        top_dividing_line_margin: top_dividing_line_margin,
        is_jump_other_page_btn: is_jump_other_page_btn,
        jump_other_page_btn_text: jump_other_page_btn_text,
        jump_other_page_url: jump_other_page_url,
        jump_other_page_btn_text_font_color: jump_other_page_btn_text_font_color,
        jump_other_page_btn_text_font_size: jump_other_page_btn_text_font_size,
        jump_other_page_btn_text_font_family: jump_other_page_btn_text_font_family,
        jump_other_page_btn_text_font_weight: jump_other_page_btn_text_font_weight,
        jump_other_page_btn_border_color: jump_other_page_btn_border_color,
        jump_other_page_btn_border_radius: jump_other_page_btn_border_radius,
        jump_other_page_btn_text_align: jump_other_page_btn_text_align,
        jump_other_page_btn_margin: jump_other_page_btn_margin,
        jump_other_page_btn_width: jump_other_page_btn_width,
        jump_other_page_btn_height: jump_other_page_btn_height,
        is_ig_cta_container: is_ig_cta_container,
        ig_cta_container_margin: ig_cta_container_margin,
        ig_cta_container_padding: ig_cta_container_padding,
        ig_cta_container_text_align: ig_cta_container_text_align,
        is_cta_title: is_cta_title,
        is_cta_title_icon: is_cta_title_icon,
        cta_title_margin: cta_title_margin,
        cta_title_height: cta_title_height,
        cta_title_justify_content: cta_title_justify_content,
        cta_title_icon_size: cta_title_icon_size,
        cta_title_icon_margin: cta_title_icon_margin,
        cta_title_text: cta_title_text,
        cta_title_font_family: cta_title_font_family,
        cta_title_font_size: cta_title_font_size,
        cta_title_font_weight: cta_title_font_weight,
        cta_title_font_color: cta_title_font_color,
        ig_cta_box_text: ig_cta_box_text,
        ig_cta_box_text_font_color: ig_cta_box_text_font_color,
        ig_cta_box_text_font_size: ig_cta_box_text_font_size,
        ig_cta_box_text_font_family: ig_cta_box_text_font_family,
        ig_cta_box_text_font_weight: ig_cta_box_text_font_weight,
        ig_cta_box_text_align: ig_cta_box_text_align,
        ig_cta_img_height: ig_cta_img_height,
        ig_cta_img_width: ig_cta_img_width,
        ig_cta_img_margin: ig_cta_img_margin,
        ig_cta_img_url: ig_cta_img_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('部品のデザインを登録しました。');
        location.reload();
      }
    });
  });

  //  カスタムCSS登録/更新
  $('#update_custom_css').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let custom_css = $('#custom_css').val();

    $.ajax({
      url: '/update_custom_css',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        custom_css: custom_css,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('カスタムCSSを更新しました');
      }
    });
  });

  $('#ugc_url_add_imput').on('click', function () {
    $(this)
      .parent()
      .children('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 px-6 text-left ">
              <input class="ugc_url_input w-380px h-30px py-0 px-6 border-b border-base-500 dark:border-none" type="text" />
            </td>
            <td>
              <div class="ugc_url_del text-2xl cursor-pointer text-base-500">	<i class="fas fa-minus-circle"></i></div>
            </td>
          </tr>`
      );
    $('.ugc_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.ugc_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#ugc_url_set').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let urls = [];
    $('.ugc_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_ugc_url',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('URLを登録しました');
      location.reload();
    });
  });

  $('.ugc_slideup_btn, .parent_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.ugc_slide_flag, .parent_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.ugc_slidedown_btn, .parent_slidedown_btn').fadeIn(0));
  });

  $('.ugc_slidedown_btn, .parent_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.ugc_slide_flag, .parent_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.ugc_slideup_btn, .parent_slideup_btn').fadeIn(0));
  });

  $('.ugc_cancel_submit_btn').on('click', function () {
    let ugc_group_id = $('.ugc_group_select_box option:selected').val();
    let sns_post_id = $(this).data('id');
    $('.loadding').css('display', 'block');
    $.ajax({
      url: '/ugc_group_id_delete',
      type: 'POST',
      data: {
        sns_post_id: sns_post_id,
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  $('.ugc_setting_icon, .product_set_btn').on('click', function () {
    let sns_post_id = $(this).data('id');
    let ug_sp = $(this).data('ug_sp');
    let media_type = $(this).data('media_type');
    let media_url = $(this).data('media_url');
    let post_type_name = $(this).data('post_type_name');
    let account_id = $(this).data('account_id');
    let media_id = $(this).data('media_id');
    let created_at = $(this).data('created_at');
    let my_post_media_order_file_name = $(this).data('my_post_media_order_file_name');
    let my_post_media_order_media_type = $(this).data('my_post_media_order_media_type');
    let original_file_name = $(this).data('original_file_name');
    let video_src;
    let img_src;
    let ugc_group_id = $(this).data('ugc_group_id');

    console.log('my_post_media_order_file_name');
    console.log(my_post_media_order_file_name);

    let caption = $(this).data('caption');
    let permalink = $(this).data('permalink');
    let truncated_caption = truncate(caption, 40);

    function truncate(str, maxLength) {
      if (str.length <= maxLength) {
        return str;
      }
      return str.substring(0, maxLength) + '...';
    }

    let media_html;

    if (media_type === 'VIDEO') {
      video_src = `${S3_MEDIA_URL}/ig_hashtag_media/videos/${post_type_name}_ac${account_id}_${media_id}_${created_at}.mp4`;
      media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
    } else if (media_type === 'CAROUSEL_ALBUM' && media_url && (media_url.includes('//video') || media_url.includes('mp4?') || (media_url.includes('vs=') && !media_url.includes('jpg')))) {
      video_src = `${S3_MEDIA_URL}/ig_hashtag_media/videos/${post_type_name}_ac${account_id}_${media_id}_${created_at}.mp4`;
      media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
    } else if (media_type == 'MANUAL_OWN_POST') {
      if (my_post_media_order_media_type == 'VIDEO') {
        if (original_file_name) {
          video_src = `${S3_MEDIA_URL}/ig_hashtag_media/videos/${my_post_media_order_file_name}`;
          media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
        } else {
          video_src = media_url;
          media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
        }
      } else if (my_post_media_order_media_type == 'IMAGE') {
        img_src = `${S3_MEDIA_URL}/ig_hashtag_media/pictures/${my_post_media_order_file_name}`;
        media_html = `<img class="ugc_modal_left_img w-full h-full object-cover" src="${img_src}" alt="">`;
      }
    } else {
      img_src = `${S3_MEDIA_URL}/ig_hashtag_media/pictures/${post_type_name}_ac${account_id}_${media_id}_${created_at}.jpg`;
      media_html = `<img class="ugc_modal_left_img w-full h-full object-cover" src="${img_src}" alt="">`;
    }

    ////////////////////////////// manageサーバーの画像を見る場合 //////////////////////////////
    // if (media_type === 'VIDEO') {
    //   video_src = `/ig_hashtag_media/videos/${post_type_name}_ac${account_id}_${media_id}_${created_at}.mp4`;
    //   media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
    // } else if (media_type === 'CAROUSEL_ALBUM' && media_url && (media_url.includes('//video') || media_url.includes('mp4?') || (media_url.includes('vs=') && !media_url.includes('jpg')))) {
    //   video_src = `/ig_hashtag_media/videos/${post_type_name}_ac${account_id}_${media_id}_${created_at}.mp4`;
    //   media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
    // } else if (media_type == 'MANUAL_OWN_POST') {
    //   if (my_post_media_order_media_type == 'VIDEO') {
    //     if (original_file_name) {
    //       video_src = `/ig_hashtag_media/videos/${my_post_media_order_file_name}`;
    //       media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
    //     } else {
    //       video_src = media_url;
    //       media_html = `<video loop autoplay muted playsinline class="ugc_modal_left_img w-full h-full object-cover" src=${video_src} alt=""></video>`;
    //     }
    //   } else if (my_post_media_order_media_type == 'IMAGE') {
    //     img_src = `/ig_hashtag_media/pictures/${my_post_media_order_file_name}`;
    //     media_html = `<img class="ugc_modal_left_img w-full h-full object-cover" src="${img_src}" alt="">`;
    //   }
    // } else {
    //   img_src = `/ig_hashtag_media/pictures/${post_type_name}_ac${account_id}_${media_id}_${created_at}.jpg`;
    //   media_html = `<img class="ugc_modal_left_img w-full h-full object-cover" src="${img_src}" alt="">`;
    // }
    ////////////////////////////// manageサーバーの画像を見る場合 //////////////////////////////

    $('.main').append(
      `<div class="platta_pr_modal_container fixed z-[999999] top-0 left-0 w-full h-full">
          <div class="platta_pr_modal_bg fixed top-0 left-0 w-full h-full opacity-50 bg-black"></div>
          <div class="platta_pr_modal fixed top-1/2 left-1/2 w-1000px h-650px my-0 mx-auto -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-900">
            <span class="platta_pr_modal_del text-3xl leading-[22px] absolute top-[2px] left-[970px] w-7 h-7 cursor-pointer text-center text-white rounded-[50%] dark:text-gray-400">×</span>
            <div class="platta_pr_modal_box h-full ">
              <div class="modal_pr_title text-base m-0 pt-2 pr-[30px] pb-2 pl-6 text-gray-600 bg-base-200 dark:bg-gray-600 dark:text-gray-800">商品連携</div>
              <div class="modal_pr_container flex height-calc-100-minus-40">
                <div class="ugc_modal_left w-1/2">
                  <a href="${permalink}" target="_blank">
                    ${media_html}
                  </a>
                </div>
                <div class="ugc_modal_right w-1/2">
                  <div class="ugc_modal_right_pr_title font-bold flex items-center py-1 px-5 text-left mr-2">
                    <span>商品選択</span>
                    <input id="ugc_setting_product_search" class="input input-bordered rounded-md input-sm max-w-xs text-sm w-auto px-2 mx-2" data-id="${sns_post_id}"
                    data-ugc_group_id="${ugc_group_id}"
                    type="text" />
                    <i class="fas fa-redo ugc_setting_all_product_list cursor-pointer" data-id="${sns_post_id}" data-ugc_group_id="${ugc_group_id}"></i>
                  </div>
                  <div class="ugc_modal_right_pr_container overflow-y-auto height-calc-50-minus-70 p-1 border-y border-gray"></div>
                  <div class="ugc_modal_right_icon text-[25px] my-[10px] text-center">
                    <i class="fas fa-angle-double-down"></i>
                  </div>
                  <div class="ugc_modal_right_linked_pr_title font-bold py-1 px-5 text-left border-b border-gray">連携済み商品</div>
                  <div class="ugc_modal_right_linked_pr_container overflow-y-auto height-calc-50-minus-70 p-1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>`
    );
    $.ajax({
      url: '/get_product_list',
      type: 'GET',
      data: {
        sns_post_id: sns_post_id,
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret1 == '0') {
        $.each(data.products, function (index, product) {
          $('.ugc_modal_right_pr_container').append(
            `<div class="ugc_modal_right_pr_box flex items-center justify-between m-1 py-2 px-4 border-b border-gray-500">
                <img class="ugc_modal_right_pr_image_url h-60px mr-5" src="${product.image_url}">
                <div class="ugc_modal_right_pr_code_name_price">
                  <div class="ugc_modal_right_pr_code text-[13px] mb-[14px]">${product.code}</div>
                  <div class="ugc_modal_right_pr_name_price flex items-center justify-between">
                    <div class="ugc_modal_right_pr_name mr-2">${product.name}</div>
                    <div class="ugc_modal_right_pr_price m-0">${product.price}円</div>
                  </div>
                </div>
                <div class="ugc_modal_right_pr_link_btn w-80px ml-auto py-1 px-2 cursor-pointer text-center text-white rounded-lg bg-danger-500 hover:bg-danger-800 dark:hover:bg-dark_danger-hover dark:bg-dark_danger dark:text-gray-500"
                     data-product_id="${product.id}"
                     data-sns_post_id="${sns_post_id}"
                     data-ugc_group_id="${data.ugc_group_id}"
                     >連携する</div>
              </div>
              <div class="ugc_modal_right_pr_line w-98per h-[1px] my-1 bg-gray"></div>`
          );
        });
      }
      if (data.ret2 == '0') {
        $.each(data.linked_products, function (index, linked_product) {
          $('.ugc_modal_right_linked_pr_container').append(
            `<div class="ugc_modal_right_linked_pr_box flex items-center justify-between m-1 py-2 px-4 border-b border-gray-500">
              <img class="ugc_modal_right_linked_pr_image_url h-60px mr-5" src="${linked_product.image_url}">
              <div class="ugc_modal_right_linked_pr_code_name_price">
                <div class="ugc_modal_right_linked_pr_code text-[13px] mb-[14px]">${linked_product.code}</div>
                <div class="ugc_modal_right_linked_pr_name_price flex items-center justify-between">
                  <div class="ugc_modal_right_linked_pr_name mr-2">${linked_product.name}</div>
                  <div class="ugc_modal_right_linked_pr_price m-0">${linked_product.price}円</div>
                </div>
              </div>
              <div class="ugc_modal_right_cancel_pr_link_btn w-80px ml-auto py-1 px-2 cursor-pointer text-center text-white rounded-lg bg-gray-500 hover:bg-gray-800 dark:hover:bg-gray-800 dark:bg-gray-700 dark:text-gray-500"
                    data-sns_post_id="${sns_post_id}"
                    data-product_id="${linked_product.id}"
                    data-ugc_group_id="${data.ugc_group_id}"
                    ">連携解除</div>
            </div>
            <div class="ugc_modal_right_linked_pr_line w-98per h-[1px] my-1 bg-gray"></div>`
          );
        });
      }
    });
    $('.platta_pr_modal_del').on('click', function () {
      $('.platta_pr_modal_container').remove();
    });
    $('.platta_pr_modal_bg').on('click', function () {
      $('.platta_pr_modal_container').remove();
    });
  });

  $(document)
    .off('click', '.ugc_modal_right_pr_link_btn')
    .on('click', '.ugc_modal_right_pr_link_btn', function () {
      let product_id = $(this).data('product_id');
      let sns_post_id = $(this).data('sns_post_id');
      let ugc_group_id = $(this).data('ugc_group_id');
      $.ajax({
        url: '/link_product',
        type: 'POST',
        data: {
          sns_post_id: sns_post_id,
          product_id: product_id,
          ugc_group_id: ugc_group_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          let lp = JSON.stringify(data.linked_product);
          let linked_product = JSON.parse(lp);
          $(`.ugc_modal_right_pr_link_btn[data-product_id="${linked_product.id}"]`).closest('.ugc_modal_right_pr_box').next('.ugc_modal_right_pr_line').remove();
          $(`.ugc_modal_right_pr_link_btn[data-product_id="${linked_product.id}"]`).closest('.ugc_modal_right_pr_box').remove();

          $('.ugc_modal_right_linked_pr_container').append(
            `<div class="ugc_modal_right_linked_pr_box flex items-center justify-between m-1 py-2 px-4">
              <img class="ugc_modal_right_linked_pr_image_url h-60px mr-5" src="${linked_product.image_url}">
              <div class="ugc_modal_right_linked_pr_code_name_price">
                <div class="ugc_modal_right_linked_pr_code text-[13px] mb-[14px]">${linked_product.code}</div>
                <div class="ugc_modal_right_linked_pr_name_price flex items-center justify-between">
                  <div class="ugc_modal_right_linked_pr_name mr-2">${linked_product.name}</div>
                  <div class="ugc_modal_right_linked_pr_price m-0">${linked_product.price}円</div>
                </div>
              </div>
              <div class="ugc_modal_right_cancel_pr_link_btn w-80px ml-auto py-1 px-2 cursor-pointer text-center text-white rounded-lg bg-gray-500 hover:bg-gray-800 dark:hover:bg-gray-800 dark:bg-gray-700 dark:text-gray-500"
                   data-sns_post_id="${sns_post_id}"
                   data-product_id="${linked_product.id}"
                   data-ugc_group_id="${ugc_group_id}"
                   >連携解除</div>
            </div>
            <div class="ugc_modal_right_linked_pr_line w-98per h-[1px] my-1 bg-gray"></div>`
          );
        }
      });
    });

  $(document).on('click', '.ugc_modal_right_cancel_pr_link_btn', function () {
    let product_id = $(this).data('product_id');
    let sns_post_id = $(this).data('sns_post_id');
    let ugc_group_id = $(this).data('ugc_group_id');
    $.ajax({
      url: '/unlink_product',
      type: 'POST',
      data: {
        sns_post_id: sns_post_id,
        product_id: product_id,
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        let p = JSON.stringify(data.products);
        let product = JSON.parse(p);

        $('.ugc_modal_right_pr_container').append(
          `<div class="ugc_modal_right_pr_box flex items-center justify-between m-1 py-2 px-4">
            <img class="ugc_modal_right_pr_image_url h-60px mr-5" src="${product.image_url}">
            <div class="ugc_modal_right_pr_name_price">
              <div class="gc_modal_right_pr_code text-[13px] mb-[14px]">${product.code}</div>
              <div class="ugc_modal_right_pr_name_price flex items-center justify-between">
                <div class="ugc_modal_right_pr_name mr-2">${product.name}</div>
                <div class="ugc_modal_right_pr_price m-0">${product.price}円</div>
              </div>
            </div>
            <div class="ugc_modal_right_pr_link_btn w-80px ml-auto py-1 px-2 cursor-pointer text-center text-white rounded-lg bg-danger-500 hover:bg-danger-800 dark:hover:bg-dark_danger-hover dark:bg-dark_danger dark:text-gray-500"
                 data-sns_post_id="${sns_post_id}"
                 data-product_id="${product.id}"
                 data-ugc_group_id="${ugc_group_id}"
                 >連携する</div>
          </div>
          <div class=""ugc_modal_right_pr_line w-98per h-[1px] my-1 bg-gray"></div>`
        );

        $(`.ugc_modal_right_cancel_pr_link_btn[data-product_id="${product_id}"]`).closest('.ugc_modal_right_linked_pr_box').next('.ugc_modal_right_linked_pr_line').remove();
        $(`.ugc_modal_right_cancel_pr_link_btn[data-product_id="${product_id}"]`).closest('.ugc_modal_right_linked_pr_box').remove();
      }
    });
  });

  // 検索ボックスでエンターキーが押されたときの処理
  $(document).off('keypress', '#ugc_setting_product_search')
           .on('keypress', '#ugc_setting_product_search', function(e) {
    if (e.which === 13) {
      e.preventDefault();

      $('.ugc_modal_right_pr_box, .ugc_modal_right_pr_line').remove();
      let sns_post_id = $(this).data('id');
      let search_word = $(this).val().toLowerCase();
      let ugc_group_id = $(this).data('ugc_group_id');
      $.ajax({
        url: '/get_product_list',
        type: 'GET',
        data: {
          sns_post_id: sns_post_id,
          p: search_word,
          ugc_group_id: ugc_group_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret1 == '0') {
          $.each(data.products, function (index, product) {
            $('.ugc_modal_right_pr_container').append(
              `<div class="ugc_modal_right_pr_box flex items-center justify-between m-1 py-2 px-4 border-b border-gray-500">
                  <img class="ugc_modal_right_pr_image_url h-60px mr-5" src="${product.image_url}">
                  <div class="ugc_modal_right_pr_code_name_price">
                    <div class="ugc_modal_right_pr_code text-[13px] mb-[14px]">${product.code}</div>
                    <div class="ugc_modal_right_pr_name_price flex items-center justify-between">
                      <div class="ugc_modal_right_pr_name mr-2">${product.name}</div>
                      <div class="ugc_modal_right_pr_price m-0">${product.price}円</div>
                    </div>
                  </div>
                  <div class="ugc_modal_right_pr_link_btn w-80px ml-auto py-1 px-2 cursor-pointer text-center text-white rounded-lg bg-danger-500 hover:bg-danger-800 dark:hover:bg-dark_danger-hover dark:bg-dark_danger dark:text-gray-500"
                       data-product_id="${product.id}"
                       data-sns_post_id="${sns_post_id}"
                       data-ugc_group_id="${ugc_group_id}">連携する</div>
                </div>
                <div class="ugc_modal_right_pr_line w-98per h-[1px] my-1 bg-gray"></div>`
            );
          });
        }
      });
    }
  });

  $('.ugc_sns_posts_cancel_check').on('change', function () {
    if ($('.ugc_sns_posts_cancel_check:checked').length > 0) {
      // チェックボックスが1つでも選択されている場合
      $('#ugc_sns_posts_cancel_submit_btn').css('display', 'block');
    } else {
      // チェックボックスが1つも選択されていない場合
      $('#ugc_sns_posts_cancel_submit_btn').css('display', 'none');
    }
  });

  $('#ugc_sns_posts_cancel_submit_btn')
    .off()
    .on('click', function () {
      $(this).css('pointer-events', 'none');
      $(this).text('削除しています...');
      $(this).css('background', 'gray');
      let sns_post_ids = [];
      let ugc_group_id = $('.ugc_group_select_box option:selected').val();
      $('.ugc_sns_posts_cancel_check:checked').each(function () {
        sns_post_ids.push($(this).data('id'));
      });
      if (!sns_post_ids) {
        alert('連携解除したい投稿を選択してください。');
        return;
      }
      $.ajax({
        url: '/ugc_group_ids_delete',
        type: 'POST',
        data: {
          sns_post_ids: sns_post_ids,
          ugc_group_id: ugc_group_id,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          alert('UGCグループ連携を一括解除しました。');
          location.reload();
        }
      });
    });

  $(document).on('click', '.ugc_setting_all_product_list', function () {
    $('.ugc_modal_right_pr_box, .ugc_modal_right_pr_line').remove();
    $('.ugc_modal_right_linked_pr_box, .ugc_modal_right_linked_pr_line').remove();
    $('#ugc_setting_product_search').val('');

    let sns_post_id = $(this).data('id');
    let ugc_group_id = $(this).data('ugc_group_id');
    $.ajax({
      url: '/get_product_list',
      type: 'GET',
      data: {
        sns_post_id: sns_post_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret1 == '0') {
        $.each(data.products, function (index, product) {
          $('.ugc_modal_right_pr_container').append(
            `<div class="ugc_modal_right_pr_box flex items-center justify-between m-1 py-2 px-4 border-b border-gray-500">
                  <img class="ugc_modal_right_pr_image_url h-60px mr-5" src="${product.image_url}">
                  <div class="ugc_modal_right_pr_code_name_price">
                    <div class="ugc_modal_right_pr_code text-[13px] mb-[14px]">${product.code}</div>
                    <div class="ugc_modal_right_pr_name_price flex items-center justify-between">
                      <div class="ugc_modal_right_pr_name mr-2">${product.name}</div>
                      <div class="ugc_modal_right_pr_price m-0">${product.price}円</div>
                    </div>
                  </div>
                  <div class="ugc_modal_right_pr_link_btn w-80px ml-auto py-1 px-2 cursor-pointer text-center text-white rounded-lg bg-danger-500 hover:bg-danger-800 dark:hover:bg-dark_danger-hover dark:bg-dark_danger dark:text-gray-500"
                       data-product_id="${product.id}"
                       data-sns_post_id="${sns_post_id}"
                       data-ugc_group_id="${ugc_group_id}">連携する</div>
                </div>
                <div class="ugc_modal_right_pr_line w-98per h-[1px] my-1 bg-gray"></div>`
          );
        });
      }

      if (data.ret2 == '0') {
        $.each(data.linked_products, function (index, linked_product) {
          $('.ugc_modal_right_linked_pr_container').append(
            `<div class="ugc_modal_right_linked_pr_box flex items-center justify-between m-1 py-2 px-4 border-b border-gray-500">
              <img class="ugc_modal_right_linked_pr_image_url h-60px mr-5" src="${linked_product.image_url}">
              <div class="ugc_modal_right_linked_pr_code_name_price">
                <div class="ugc_modal_right_linked_pr_code text-[13px] mb-[14px]">${linked_product.code}</div>
                <div class="ugc_modal_right_linked_pr_name_price flex items-center justify-between">
                  <div class="ugc_modal_right_linked_pr_name mr-2">${linked_product.name}</div>
                  <div class="ugc_modal_right_linked_pr_price m-0">${linked_product.price}円</div>
                </div>
              </div>
              <div class="ugc_modal_right_cancel_pr_link_btn w-80px ml-auto py-1 px-2 cursor-pointer text-center text-white rounded-lg bg-gray-500 hover:bg-gray-800 dark:hover:bg-gray-800 dark:bg-gray-700 dark:text-gray-500"
                   data-sns_post_id="${sns_post_id}"
                   data-product_id="${linked_product.id}"
                   data-ugc_group_id="${ugc_group_id}"
                   >連携解除</div>
            </div>
            <div class="ugc_modal_right_linked_pr_line w-98per h-[1px] my-1 bg-gray"></div>`
          );
        });
      }
    });
  });

  // $('.ugc_group_link').on('change', function () {
  //   if ($(this).data('ugc_username') == '' && location.href.includes('communication_management')) {
  //     alert(
  //       `ユーザーネームが登録されていないUGCです。
  //        UGC設定ボタンから設定の上、再度お試しください。`.replace(/[ \t]/g, '')
  //     );
  //     location.reload();
  //   }

  //   if ($('.ugc_group_link:checked').length > 0) {
  //     // チェックボックスが1つでも選択されている場合
  //     $('#ugc_group_link_btn').show();
  //     $('#ugc_create_btn').show();
  //   } else {
  //     // チェックボックスが1つも選択されていない場合
  //     $('#ugc_group_link_btn').hide();
  //     $('#ugc_create_btn').hide();
  //   }
  // });

  let firstChecked = false;

  
  $('#ugc_hidden_btn').on('click', function () {
    if (!confirm('チェックした投稿を非表示にしますか？')) {
      return;
    }
  
    // チェックされている checkbox の data-id を配列で取得
    const hidden_list = $('.ugc_group_link:checked').map(function () {
      return $(this).data('id');
    }).get();
  
    if (hidden_list.length === 0) {
      alert('チェックされた投稿がありません');
      return;
    }
  
    $.ajax({
      type: 'POST',
      url: DOMAIN + '/cmm_set_hidden',
      data: {
        hidden_list: hidden_list,
      },
      dataType: 'json',
      success: function (data) {
        location.reload();
      },
    });
  });
  
  $('#ugc_hidden_cancel_btn').on('click', function () {
    if (!confirm('チェックした投稿の非表示を解除しますか？')) {
      return;
    }
  
    // チェックされている checkbox の data-id を配列で取得
    const cancel_list = $('.ugc_group_link:checked').map(function () {
      return $(this).data('id');
    }).get();
  
    if (cancel_list.length === 0) {
      alert('チェックされた投稿がありません');
      return;
    }
  
    $.ajax({
      type: 'POST',
      url: DOMAIN + '/cmm_cancel_hidden',
      data: {
        cancel_list: cancel_list,
      },
      dataType: 'json',
      success: function (data) {
        location.reload();
      },
    });
  });


  $('.ugc_group_link').on('change', function() {
    if ($(this).data('ugc_username') == '' && location.href.includes('communication_management')) {
      alert(
        `ユーザーネームが登録されていないUGCです。
         UGC設定ボタンから設定の上、再度お試しください。`.replace(/[ \t]/g, '')
      );
      location.reload();
    }

    if ($(this).is(':checked') && !firstChecked) {
      let caption = $(this).data('caption');
      console.log("First checked caption: ", caption); // デバッグ用ログ
      $('#ugc_create_btn').attr('data-caption', caption); // attrメソッドで属性を設定
      firstChecked = true;
    }

    // すべてのチェックボックスが未チェックの場合、フラグをリセット
    if (!$('.ugc_group_link:checked').length) {
      firstChecked = false;
      $('#ugc_create_btn').attr('data-caption', ''); // データキャプションをクリア
    }

    if ($('.ugc_group_link:checked').length > 0) {
      // チェックボックスが1つでも選択されている場合
      $('#ugc_group_link_btn').show();
      $('#ugc_hidden_btn').show();
      $('#ugc_create_btn').show();
    } else {
      // チェックボックスが1つも選択されていない場合
      $('#ugc_group_link_btn').hide();
      $('#ugc_create_btn').hide();
      $('#ugc_hidden_btn').hide();
    }

    if ($('.cancel_hidden_link:checked').length > 0) {
      // チェックボックスが1つでも選択されている場合
      $('#ugc_hidden_cancel_btn').show();
    } else {
      // チェックボックスが1つも選択されていない場合
      $('#ugc_hidden_cancel_btn').hide();
    }

  });

  $('#ugc_create_btn').on('click', function () {
    let s3_img_url = [];
    let caption = $(this).data('caption');

    $('.ugc_group_link:checked').each(function () {
      s3_img_url.push($(this).data("img_url"));
    });
    if (s3_img_url.length == 0) {
      alert('投稿を選択してください。');
      return;
    }

    $.ajax({
      url: '/create_ugc_posts',
      type: 'POST',
      data: {
        img_urls: s3_img_url,
        caption: caption
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('登録が完了しました。左メニューの手動投稿管理でご確認ください。');
        location.reload();
      }
    });
  });

  $('#ugc_group_link_btn')
    .off()
    .on('click', function () {
      let sns_post_ids = [];
      let user_names = [];
      $('.ugc_group_link:checked').each(function () {
        sns_post_ids.push($(this).data('id'));
        user_names.push($(this).data('ugc_username'));
        console.log('user_names:', user_names);
        return;
      });
      $('.modal_submit').attr('data-sns_post_id', sns_post_ids);
      $('.modal_submit')
        .off()
        .on('click', function () {
          let ugc_group_ids = [];
          $('input[name=ugc_groups]:checked').each(function () {
            ugc_group_ids.push($(this).val());
          });
          if (ugc_group_ids.length == 0) {
            alert('UGCグループを選択してください。');
            return;
          }
          $.ajax({
            url: '/ugc_group_id_set',
            type: 'POST',
            data: {
              sns_post_ids: sns_post_ids,
              ugc_group_ids: ugc_group_ids,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              if (!location.href.includes('communication_management')) {
                alert('UGCグループに連携しました。');
                location.reload();
              } else {
                $.ajax({
                  url: '/cmm_update_multiple_ugc_permissions',
                  type: 'POST',
                  data: {
                    sns_post_ids: sns_post_ids,
                  },
                  dataType: 'json',
                })
                  .done(function (data) {
                    // alert('Linked to UGC group.');
                    // alert(
                    //   `指定されたUGCグループに本投稿を連携しました。
                    //    本投稿のラベルの状態を自動的に"連携済み"に変更します。`.trim()
                    // );
                    // 改行を残してそれ以外の不要な空白を削除する
                    alert(
                      `指定されたUGCグループに本投稿を連携しました。
                本投稿のラベルの状態を自動的に"連携済み"に変更します。`.replace(/[ \t]/g, '')
                    );
                  })
                  .fail(function () {
                    alert(
                      `指定されたUGCグループに本投稿を連携しました。

                Notice:
                予期しないエラーにより、本投稿のラベルの状態を自動的に"連携済み"に変更できませんでした。

                お手数ですが、手動で本投稿のラベルの状態を"連携済み"にしていただくようお願い致します。`.replace(/[ \t]/g, '')
                    );
                  })
                  .always(function () {
                    location.reload();
                  });
              }
            }
          });
        });
    });

  // delete_mode_submitがクリックされた時の処理
  $('#delete_sns_post_mode_submit').on('click', function () {
    // 現在のURLを取得
    let currentUrl = new URL(window.location.href);

    // URLパラメーターにdelete_mode=1を追加
    currentUrl.searchParams.set('delete_mode', '1');

    // 新しいURLにリダイレクト
    window.location.href = currentUrl.toString();
  });

  // not_delete_sns_post_mode_submitがクリックされた時の処理
  $('#not_delete_sns_post_mode_submit').on('click', function () {
    // 現在のURLを取得
    let currentUrl = new URL(window.location.href);

    // URLパラメーターのdelete_mode=1を削除
    currentUrl.searchParams.delete('delete_mode');

    // 新しいURLにリダイレクト
    window.location.href = currentUrl.toString();
  });

  $('.sns_post_delete_checkbox').on('change', function () {
    if ($('.sns_post_delete_checkbox:checked').length > 0) {
      // チェックボックスが1つでも選択されている場合
      $('#sns_post_checked_delete_btn').show();
    } else {
      // チェックボックスが1つも選択されていない場合
      $('#sns_post_checked_delete_btn').hide();
    }
  });

  // UGCの一括削除
  $('#sns_post_checked_delete_btn').on('click', function () {
    // data-idの値を格納するための配列を初期化
    let checked_sns_posts_id_and_src = [];

    // チェックがついているチェックボックスのdata-id値を配列に追加
    $('.sns_post_delete_checkbox:checked').each(function () {
      let sns_post_id = $(this).data('id');
      let post_card = $(this).siblings('.post_tag_card');

      // post_tag_card内のimgまたはvideoタグのsrcを取得
      let imgSrc = post_card.find('a img').attr('src');
      let videoSrc = post_card.find('a video').attr('src');

      // srcが存在する方を使用
      let media_src = imgSrc || videoSrc;

      // オブジェクトとしてidとsrcを配列に追加
      checked_sns_posts_id_and_src.push({
        id: sns_post_id,
        src: media_src,
      });
    });

    // 結果をコンソールに出力（必要に応じて他の処理に変更できます）
    console.log(checked_sns_posts_id_and_src);

    $.ajax({
      url: '/delete_sns_posts',
      type: 'POST',
      data: {
        checked_sns_posts_id_and_src: checked_sns_posts_id_and_src,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      } else if (data.ret == 1) {
        alert('何らかの影響により削除できませんでした。');
      } else if (data.ret == 2) {
        alert('選択したUGCの中に連携されているものがある可能性があります。削除できませんでした。');
      }
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // 商品詳細表示設定
  //-----------------------------------------------------------------------------------------------------------------
  // デバイス選択
  $('.ugc_detail_page_setting_device_pc, .ugc_detail_page_setting_device_phone').on('click', function () {
    let is_device = $(this).data('device');
    location.href = `/ugc_detail_page_setting?is_device=${is_device}`;
  });

  // 一番最初に行う商品詳細設定
  $('#ugc_detail_page_first_setting').on('click', function () {
    $.ajax({
      url: '/create_detail_page_setting',
      type: 'POST',
      data: {},
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('商品詳細設定を完了しました。');
        location.reload();
      }
    });
  });

  $('.ugc_detail_page_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.ugc_detail_page_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.ugc_detail_page_slidedown_btn').fadeIn(0));
  });

  $('.ugc_detail_page_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.ugc_detail_page_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.ugc_detail_page_slideup_btn').fadeIn(0));
  });

  //  UGCグループ公開設定
  $('.ugc_detail_page_open_select').on('change', function () {
    let ugc_show_valid_val = $('.ugc_detail_page_open_select option:selected').val();
    let is_device = $('#ugc_detail_page_setting_device_val').val();
    $.ajax({
      url: '/update_detail_page_show_valid',
      type: 'POST',
      data: {
        show_valid: ugc_show_valid_val,
        is_device: is_device,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        if (data.show_valid == 1) {
          alert('商品詳細を公開しました。');
        } else if (data.show_valid == 2) {
          alert('商品詳細をプレビューで公開しました。');
        } else {
          alert('商品詳細を非公開にしました。');
        }
        location.href = `/ugc_detail_page_setting?mode=${data.show_valid}`;
      }
    });
  });

  $('#ugc_detail_page_create_preview_btn')
    .off()
    .on('click', function () {
      $('.loadding').css('display', 'block');
      let tag_check = $('#ugc_detail_page_create_preview_tag').prop('checked');
      let preview_url = $('#ugc_detail_page_create_preview_url').val();
      let html_name = $('#ugc_detail_page_create_preview_html_name').val();
      let product_name = $('#ugc_detail_page_create_preview_product_name').val();
      let product_img_name = $('#ugc_detail_page_create_preview_product_img_name').val();
      let product_price = $('#ugc_detail_page_create_preview_product_price').val();

      if (preview_url == '' || html_name == '' || product_name == '' || product_img_name == '') {
        $('.loadding').css('display', 'none');
        alert('必須項目を入力してください。');
        return;
      }

      $.ajax({
        url: '/save_detail_page_preview',
        type: 'POST',
        data: {
          url: preview_url,
          file_name: html_name,
          tag_check: tag_check,
          product_name: product_name,
          product_img_name: product_img_name,
          product_price: product_price,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          alert('プレビューを作成しました。');
          location.reload();
        }
      });
    });

  // UGC表示数設定
  $('#ugc_detail_page_display_count_submit').on('click', function () {
    let ugc_detail_page_display_count_select_val = $('#ugc_detail_page_display_count_select_val').val();
    let is_device = $('#ugc_detail_page_setting_device_val').val();
    $.ajax({
      url: '/update_detail_page_display_count',
      type: 'POST',
      data: {
        display_count: ugc_detail_page_display_count_select_val,
        is_device: is_device,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('UGC表示数を設定しました。');
        location.reload();
      }
    });
  });
  // UGC表示パターン設定
  $('.ugc_detail_page_display_type_select').on('change', function () {
    let ugc_display_type_val = $('.ugc_detail_page_display_type_select option:selected').val();
    let is_device = $('#ugc_detail_page_setting_device_val').val();
    $.ajax({
      url: '/update_detail_page_display_type',
      type: 'POST',
      data: {
        display_type: ugc_display_type_val,
        is_device: is_device,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('表示パターンを設定しました。');
        location.reload();
      }
    });
  });
  // UGC表示順設定
  $('.ugc_detail_display_order_select').on('change', function () {
    let ugc_display_order_val = $('.ugc_detail_display_order_select option:selected').val();
    let is_device = $('#ugc_detail_page_setting_device_val').val();
    $.ajax({
      url: '/update_detail_page_display_order',
      type: 'POST',
      data: {
        display_order: ugc_display_order_val,
        is_device: is_device,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('表示パターンを設定しました。');
        location.reload();
      }
    });
  });
  //  UGC差し込み先要素設定
  $('#ugc_detail_page_element_set').on('click', function () {
    let is_device = $('#ugc_detail_page_setting_device_val').val();
    let element_id_val = $('#detail_element_id_input').val();
    let element_class_val = $('#detail_element_class_input').val();
    let element_index_val = $('#detail_element_index_input').val();
    let parent_id_val = $('#detail_parent_id_input').val();
    let parent_class_val = $('#detail_parent_class_input').val();
    let parent_index_val = $('#detail_parent_index_input').val();
    let grand_id_val = $('#detail_grand_id_input').val();
    let grand_class_val = $('#detail_grand_class_input').val();
    let grand_index_val = $('#detail_grand_index_input').val();
    let great_grand_id_val = $('#detail_great_grand_id_input').val();
    let great_grand_class_val = $('#detail_great_grand_class_input').val();
    let ugc_element_placement = $('.ugc_detail_page_element_list .detail_element_placement option:selected').val();

    $.ajax({
      url: '/create_detail_page_ugc_element',
      type: 'POST',
      data: {
        is_device: is_device,
        element_id: element_id_val,
        element_class: element_class_val,
        element_index: element_index_val,
        parent_id: parent_id_val,
        parent_class: parent_class_val,
        parent_index: parent_index_val,
        grand_id: grand_id_val,
        grand_class: grand_class_val,
        grand_index: grand_index_val,
        great_grand_id: great_grand_id_val,
        great_grand_class: great_grand_class_val,
        element_placement: ugc_element_placement,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('要素の挿入先を登録しました。');
        location.reload();
      }
    });
  });

  /// デザインカスタマイズ-共通部品
  $('#ugc_detail_page_common_custom_set').on('click', function () {
    let is_device = $('#ugc_detail_page_setting_device_val').val();
    let is_category_title = $('#is_category_title').val();
    let is_category_title_icon = $('#is_category_title_icon').val();
    let category_title_margin = $('#category_title_margin').val();
    let category_title_height = $('#category_title_height').val();
    let category_title_justify_content = $('#category_title_justify_content').val();
    let category_title_icon_size = $('#category_title_icon_size').val();
    let category_title_original_icon_width = $('#category_title_original_icon_width').val();
    let category_title_original_icon_height = $('#category_title_original_icon_height').val();
    let category_title_original_icon_img_url = $('#category_title_original_icon_img_url').val();
    let category_title_icon_margin = $('#category_title_icon_margin').val();
    let category_title_text = $('#category_title_text').val();
    let category_title_font_family = $('#category_title_font_family').val();
    let category_title_font_size = $('#category_title_font_size').val();
    let category_title_font_weight = $('#category_title_font_weight').val();
    let category_title_font_color = $('#category_title_font_color').val();

    let category_subtitle_margin = $('#category_subtitle_margin').val();
    let category_subtitle_height = $('#category_subtitle_height').val();
    let category_subtitle_text = $('#category_subtitle_text').val();
    let category_subtitle_font_family = $('#category_subtitle_font_family').val();
    let category_subtitle_font_size = $('#category_subtitle_font_size').val();
    let category_subtitle_font_weight = $('#category_subtitle_font_weight').val();
    let category_subtitle_font_color = $('#category_subtitle_font_color').val();

    let container_justify_content = $('#container_justify_content').val();
    let container_width = $('#container_width').val();
    let container_margin = $('#container_margin').val();
    let container_margin_x = $('#container_margin_x').val();
    let container_left = $('#container_left').val();
    let container_transform = $('#container_transform').val();
    let img_column_count = $('#img_column_count').val();
    let img_box_width = $('#img_box_width').val();
    let img_box_height = $('#img_box_height').val();
    let img_box_border_radius = $('#img_box_border_radius').val();
    let img_box_object_fit = $('#img_box_object_fit').val();
    let img_box_margin = $('#img_box_margin').val();
    let img_box_background_color = $('#img_box_background_color').val();
    let is_caption = $('#is_caption').val();
    let is_hover = $('#is_hover').val();

    let caption_font_size = $('#caption_font_size').val();
    let caption_font_family = $('#caption_font_family').val();
    let caption_font_weight = $('#caption_font_weight').val();
    let caption_font_color = $('#caption_font_color').val();
    let caption_height = $('#caption_height').val();
    let caption_max_height = $('#caption_max_height').val();
    let caption_line_height = $('#caption_line_height').val();
    let caption_margin = $('#caption_margin').val();
    let caption_blur_height = $('#caption_blur_height').val();
    let caption_blur_width = $('#caption_blur_width').val();
    let caption_blur_top = $('#caption_blur_top').val();
    let caption_blur_left = $('#caption_blur_left').val();
    let caption_blur_background_color = $('#caption_blur_background_color').val();

    let is_username = $('#is_username').val();
    let username_justify_content = $('#username_justify_content').val();
    let username_margin = $('#username_margin').val();
    let is_username_icon = $('#is_username_icon').val();
    let username_icon_width = $('#username_icon_width').val();
    let username_icon_height = $('#username_icon_height').val();
    let username_icon_margin = $('#username_icon_margin').val();
    let username_font_size = $('#username_font_size').val();
    let username_font_family = $('#username_font_family').val();
    let username_font_weight = $('#username_font_weight').val();
    let username_font_color = $('#username_font_color').val();

    $.ajax({
      url: '/update_detail_page_ugc_common_styles',
      type: 'POST',
      data: {
        is_device: is_device,
        is_category_title: is_category_title,
        is_category_title_icon: is_category_title_icon,
        category_title_margin: category_title_margin,
        category_title_height: category_title_height,
        category_title_justify_content: category_title_justify_content,
        category_title_icon_size: category_title_icon_size,
        category_title_original_icon_width: category_title_original_icon_width,
        category_title_original_icon_height: category_title_original_icon_height,
        category_title_original_icon_img_url: category_title_original_icon_img_url,
        category_title_icon_margin: category_title_icon_margin,
        category_title_text: category_title_text,
        category_title_font_family: category_title_font_family,
        category_title_font_size: category_title_font_size,
        category_title_font_weight: category_title_font_weight,
        category_title_font_color: category_title_font_color,
        category_subtitle_margin: category_subtitle_margin,
        category_subtitle_height: category_subtitle_height,
        category_subtitle_text: category_subtitle_text,
        category_subtitle_font_family: category_subtitle_font_family,
        category_subtitle_font_size: category_subtitle_font_size,
        category_subtitle_font_weight: category_subtitle_font_weight,
        category_subtitle_font_color: category_subtitle_font_color,
        container_justify_content: container_justify_content,
        container_width: container_width,
        container_margin: container_margin,
        container_margin_x: container_margin_x,
        container_left: container_left,
        container_transform: container_transform,
        img_column_count: img_column_count,
        img_box_width: img_box_width,
        img_box_height: img_box_height,
        img_box_border_radius: img_box_border_radius,
        img_box_object_fit: img_box_object_fit,
        img_box_margin: img_box_margin,
        img_box_background_color: img_box_background_color,
        is_caption: is_caption,
        is_hover: is_hover,
        caption_font_size: caption_font_size,
        caption_font_family: caption_font_family,
        caption_font_weight: caption_font_weight,
        caption_font_color: caption_font_color,
        caption_height: caption_height,
        caption_max_height: caption_max_height,
        caption_line_height: caption_line_height,
        caption_margin: caption_margin,
        caption_blur_height: caption_blur_height,
        caption_blur_width: caption_blur_width,
        caption_blur_top: caption_blur_top,
        caption_blur_left: caption_blur_left,
        caption_blur_background_color: caption_blur_background_color,
        is_username: is_username,
        username_justify_content: username_justify_content,
        username_margin: username_margin,
        is_username_icon: is_username_icon,
        username_icon_width: username_icon_width,
        username_icon_height: username_icon_height,
        username_icon_margin: username_icon_margin,
        username_font_size: username_font_size,
        username_font_family: username_font_family,
        username_font_weight: username_font_weight,
        username_font_color: username_font_color,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('共通デザインを登録しました。');
        location.reload();
      }
    });
  });

  // デザインカスタマイズ-スライダー
  $('#ugc_detail_page_slider_custom_set').on('click', function () {
    let is_device = $('#ugc_detail_page_setting_device_val').val();

    let is_slider_prev_btn = $('#is_slider_prev_btn').val();
    let slider_prev_btn_top = $('#slider_prev_btn_top').val();
    let slider_prev_btn_left = $('#slider_prev_btn_left').val();
    let slider_prev_btn_width = $('#slider_prev_btn_width').val();
    let slider_prev_btn_height = $('#slider_prev_btn_height').val();
    let slider_prev_btn_border_radius = $('#slider_prev_btn_border_radius').val();
    let slider_prev_btn_text_color = $('#slider_prev_btn_text_color').val();
    let slider_prev_btn_backgroud_color = $('#slider_prev_btn_backgroud_color').val();
    let slider_prev_btn_backgroud_opacity = $('#slider_prev_btn_backgroud_opacity').val();
    let slider_prev_btn_text_line_width = $('#slider_prev_btn_text_line_width').val();
    let slider_prev_btn_text_line_height = $('#slider_prev_btn_text_line_height').val();
    let slider_prev_btn_text_line_weight = $('#slider_prev_btn_text_line_weight').val();
    let slider_prev_btn_text_position_right = $('#slider_prev_btn_text_position_right').val();
    let slider_prev_btn_text_position_top = $('#slider_prev_btn_text_position_top').val();
    let slider_prev_btn_text_line_rotate = $('#slider_prev_btn_text_line_rotate').val();
    let slider_prev_btn_text_line_translatey = $('#slider_prev_btn_text_line_translatey').val();
    let slider_prev_btn_text_line_skew = $('#slider_prev_btn_text_line_skew').val();
    let is_slider_next_btn = $('#is_slider_next_btn').val();
    let slider_next_btn_top = $('#slider_next_btn_top').val();
    let slider_next_btn_left = $('#slider_next_btn_left').val();
    let slider_next_btn_width = $('#slider_next_btn_width').val();
    let slider_next_btn_height = $('#slider_next_btn_height').val();
    let slider_next_btn_border_radius = $('#slider_next_btn_border_radius').val();
    let slider_next_btn_text_color = $('#slider_next_btn_text_color').val();
    let slider_next_btn_backgroud_color = $('#slider_next_btn_backgroud_color').val();
    let slider_next_btn_backgroud_opacity = $('#slider_next_btn_backgroud_opacity').val();
    let slider_next_btn_text_line_width = $('#slider_next_btn_text_line_width').val();
    let slider_next_btn_text_line_height = $('#slider_next_btn_text_line_height').val();
    let slider_next_btn_text_line_weight = $('#slider_next_btn_text_line_weight').val();
    let slider_next_btn_text_position_right = $('#slider_next_btn_text_position_right').val();
    let slider_next_btn_text_position_top = $('#slider_next_btn_text_position_top').val();
    let slider_next_btn_text_line_rotate = $('#slider_next_btn_text_line_rotate').val();
    let slider_next_btn_text_line_translatey = $('#slider_next_btn_text_line_translatey').val();
    let slider_next_btn_text_line_skew = $('#slider_next_btn_text_line_skew').val();

    $.ajax({
      url: '/update_detail_page_ugc_slider_styles',
      type: 'POST',
      data: {
        is_device: is_device,
        is_slider_prev_btn: is_slider_prev_btn,
        slider_prev_btn_top: slider_prev_btn_top,
        slider_prev_btn_left: slider_prev_btn_left,
        slider_prev_btn_width: slider_prev_btn_width,
        slider_prev_btn_height: slider_prev_btn_height,
        slider_prev_btn_border_radius: slider_prev_btn_border_radius,
        slider_prev_btn_text_color: slider_prev_btn_text_color,
        slider_prev_btn_backgroud_color: slider_prev_btn_backgroud_color,
        slider_prev_btn_backgroud_opacity: slider_prev_btn_backgroud_opacity,
        slider_prev_btn_text_line_width: slider_prev_btn_text_line_width,
        slider_prev_btn_text_line_height: slider_prev_btn_text_line_height,
        slider_prev_btn_text_line_weight: slider_prev_btn_text_line_weight,
        slider_prev_btn_text_position_right: slider_prev_btn_text_position_right,
        slider_prev_btn_text_position_top: slider_prev_btn_text_position_top,
        slider_prev_btn_text_line_rotate: slider_prev_btn_text_line_rotate,
        slider_prev_btn_text_line_translatey: slider_prev_btn_text_line_translatey,
        slider_prev_btn_text_line_skew: slider_prev_btn_text_line_skew,
        is_slider_next_btn: is_slider_next_btn,
        slider_next_btn_top: slider_next_btn_top,
        slider_next_btn_left: slider_next_btn_left,
        slider_next_btn_width: slider_next_btn_width,
        slider_next_btn_height: slider_next_btn_height,
        slider_next_btn_border_radius: slider_next_btn_border_radius,
        slider_next_btn_text_color: slider_next_btn_text_color,
        slider_next_btn_backgroud_color: slider_next_btn_backgroud_color,
        slider_next_btn_backgroud_opacity: slider_next_btn_backgroud_opacity,
        slider_next_btn_text_line_width: slider_next_btn_text_line_width,
        slider_next_btn_text_line_height: slider_next_btn_text_line_height,
        slider_next_btn_text_line_weight: slider_next_btn_text_line_weight,
        slider_next_btn_text_position_right: slider_next_btn_text_position_right,
        slider_next_btn_text_position_top: slider_next_btn_text_position_top,
        slider_next_btn_text_line_rotate: slider_next_btn_text_line_rotate,
        slider_next_btn_text_line_translatey: slider_next_btn_text_line_translatey,
        slider_next_btn_text_line_skew: slider_next_btn_text_line_skew,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('スライダーのデザインを登録しました。');
        location.reload();
      }
    });
  });

  // デザインカスタマイズ-モーダル
  $('#ugc_detail_page_modal_custom_set').on('click', function () {
    let is_device = $('#ugc_detail_page_setting_device_val').val();

    let modal_max_width = $('#modal_max_width').val();
    let modal_max_height = $('#modal_max_height').val();
    let modal_left_width = $('#modal_left_width').val();
    let modal_right_width = $('#modal_right_width').val();
    let modal_right_height = $('#modal_right_height').val();
    let is_modal_related_items = $('#is_modal_related_items').val();
    let is_modal_related_items_title = $('#is_modal_related_items_title').val();
    let modal_related_items_title_text = $('#modal_related_items_title_text').val();
    let modal_related_items_title_font_family = $('#modal_related_items_title_font_family').val();
    let modal_related_items_title_font_size = $('#modal_related_items_title_font_size').val();
    let modal_related_items_title_font_weight = $('#modal_related_items_title_font_weight').val();
    let modal_related_items_title_font_color = $('#modal_related_items_title_font_color').val();
    let is_modal_related_items_link = $('#is_modal_related_items_link').val();
    let modal_related_items_img_column_height = $('#modal_related_items_img_column_height').val();
    let modal_related_items_img_column_width = $('#modal_related_items_img_column_width').val();
    let modal_related_items_initial_img_count = $('#modal_related_items_initial_img_count').val();
    let modal_related_items_img_height = $('#modal_related_items_img_height').val();
    let modal_related_items_img_width = $('#modal_related_items_img_width').val();
    let modal_related_items_img_margin = $('#modal_related_items_img_margin').val();
    let modal_related_items_name_font_size = $('#modal_related_items_name_font_size').val();
    let modal_related_items_name_font_family = $('#modal_related_items_name_font_family').val();
    let modal_related_items_name_font_weight = $('#modal_related_items_name_font_weight').val();
    let modal_related_items_name_text_align = $('#modal_related_items_name_text_align').val();
    let modal_related_items_name_font_color = $('#modal_related_items_name_font_color').val();
    let modal_related_items_price_font_size = $('#modal_related_items_price_font_size').val();
    let modal_related_items_price_font_family = $('#modal_related_items_price_font_family').val();
    let modal_related_items_price_font_weight = $('#modal_related_items_price_font_weight').val();
    let modal_related_items_price_text_align = $('#modal_related_items_price_text_align').val();
    let modal_related_items_price_font_color = $('#modal_related_items_price_font_color').val();
    let modal_related_items_price_unit_text = $('#modal_related_items_price_unit_text').val();
    let is_modal_photo_by_link = $('#is_modal_photo_by_link').val();
    let modal_photo_by_icon_size = $('#modal_photo_by_icon_size').val();
    let modal_photo_by_margin = $('#modal_photo_by_margin').val();
    let modal_photo_by_text = $('#modal_photo_by_text').val();
    let modal_photo_by_font_size = $('#modal_photo_by_font_size').val();
    let modal_photo_by_font_family = $('#modal_photo_by_font_family').val();
    let modal_photo_by_font_weight = $('#modal_photo_by_font_weight').val();
    let modal_photo_by_font_color = $('#modal_photo_by_font_color').val();
    let is_modal_related_items_product_comment = $('#is_modal_related_items_product_comment').val();
    let modal_related_items_product_comment_height = $('#modal_related_items_product_comment_height').val();
    let modal_related_items_product_comment_position = $('#modal_related_items_product_comment_position').val();
    let modal_related_items_product_comment_font_size = $('#modal_related_items_product_comment_font_size').val();
    let modal_related_items_product_comment_font_family = $('#modal_related_items_product_comment_font_family').val();
    let modal_related_items_product_comment_font_weight = $('#modal_related_items_product_comment_font_weight').val();
    let modal_related_items_product_comment_font_color = $('#modal_related_items_product_comment_font_color').val();
    let modal_del_btn_size = $('#modal_del_btn_size').val();
    let modal_sns_post_img_object_fit = $('#modal_sns_post_img_object_fit').val();

    let modal_prev_post_btn_bg_color = $('#modal_prev_post_btn_bg_color').val();
    let modal_prev_post_btn_opacity = $('#modal_prev_post_btn_opacity').val();
    let modal_prev_post_btn_top = $('#modal_prev_post_btn_top').val();
    let modal_prev_post_btn_left = $('#modal_prev_post_btn_left').val();
    let modal_prev_post_btn_width = $('#modal_prev_post_btn_width').val();
    let modal_prev_post_btn_height = $('#modal_prev_post_btn_height').val();
    let modal_prev_post_btn_line_color = $('#modal_prev_post_btn_line_color').val();
    let modal_prev_post_btn_line_width = $('#modal_prev_post_btn_line_width').val();
    let modal_prev_post_btn_line_height = $('#modal_prev_post_btn_line_height').val();
    let modal_prev_post_btn_line_right = $('#modal_prev_post_btn_line_right').val();
    let modal_prev_post_btn_line_top = $('#modal_prev_post_btn_line_top').val();
    let modal_prev_post_btn_line_weight = $('#modal_prev_post_btn_line_weight').val();
    let modal_prev_post_btn_line_rotate = $('#modal_prev_post_btn_line_rotate').val();
    let modal_prev_post_btn_line_translatey = $('#modal_prev_post_btn_line_translatey').val();

    let modal_next_post_btn_bg_color = $('#modal_next_post_btn_bg_color').val();
    let modal_next_post_btn_opacity = $('#modal_next_post_btn_opacity').val();
    let modal_next_post_btn_top = $('#modal_next_post_btn_top').val();
    let modal_next_post_btn_left = $('#modal_next_post_btn_left').val();
    let modal_next_post_btn_width = $('#modal_next_post_btn_width').val();
    let modal_next_post_btn_height = $('#modal_next_post_btn_height').val();
    let modal_next_post_btn_line_color = $('#modal_next_post_btn_line_color').val();
    let modal_next_post_btn_line_width = $('#modal_next_post_btn_line_width').val();
    let modal_next_post_btn_line_height = $('#modal_next_post_btn_line_height').val();
    let modal_next_post_btn_line_right = $('#modal_next_post_btn_line_right').val();
    let modal_next_post_btn_line_top = $('#modal_next_post_btn_line_top').val();
    let modal_next_post_btn_line_weight = $('#modal_next_post_btn_line_weight').val();
    let modal_next_post_btn_line_rotate = $('#modal_next_post_btn_line_rotate').val();
    let modal_next_post_btn_line_translatey = $('#modal_next_post_btn_line_translatey').val();

    let modal_dot_left_display = $('#modal_dot_left_display').val();
    let modal_dot_left_bg_color = $('#modal_dot_left_bg_color').val();
    let modal_dot_left_height = $('#modal_dot_left_height').val();
    let modal_dot_left_width = $('#modal_dot_left_width').val();
    let modal_dot_left_opacity = $('#modal_dot_left_opacity').val();
    let modal_dot_left_border = $('#modal_dot_left_border').val();
    let modal_dot_left_border_radius = $('#modal_dot_left_border_radius').val();
    let modal_dot_left_margin = $('#modal_dot_left_margin').val();
    let modal_dot_left_line_height = $('#modal_dot_left_line_height').val();
    let modal_dot_left_line_width = $('#modal_dot_left_line_width').val();
    let modal_dot_left_line_top = $('#modal_dot_left_line_top').val();
    let modal_dot_left_line_right = $('#modal_dot_left_line_right').val();
    let modal_dot_left_line_border_top = $('#modal_dot_left_line_border_top').val();
    let modal_dot_left_line_border_right = $('#modal_dot_left_line_border_right').val();
    let modal_dot_left_line_transform = $('#modal_dot_left_line_transform').val();

    let modal_dot_right_display = $('#modal_dot_right_display').val();
    let modal_dot_right_bg_color = $('#modal_dot_right_bg_color').val();
    let modal_dot_right_height = $('#modal_dot_right_height').val();
    let modal_dot_right_width = $('#modal_dot_right_width').val();
    let modal_dot_right_opacity = $('#modal_dot_right_opacity').val();
    let modal_dot_right_border = $('#modal_dot_right_border').val();
    let modal_dot_right_border_radius = $('#modal_dot_right_border_radius').val();
    let modal_dot_right_margin = $('#modal_dot_right_margin').val();
    let modal_dot_right_line_height = $('#modal_dot_right_line_height').val();
    let modal_dot_right_line_width = $('#modal_dot_right_line_width').val();
    let modal_dot_right_line_top = $('#modal_dot_right_line_top').val();
    let modal_dot_right_line_right = $('#modal_dot_right_line_right').val();
    let modal_dot_right_line_border_top = $('#modal_dot_right_line_border_top').val();
    let modal_dot_right_line_border_right = $('#modal_dot_right_line_border_right').val();
    let modal_dot_right_line_transform = $('#modal_dot_right_line_transform').val();

    let modal_dot_display = $('#modal_dot_display').val();
    let modal_dot_height = $('#modal_dot_height').val();
    let modal_dot_width = $('#modal_dot_width').val();
    let modal_dot_opacity = $('#modal_dot_opacity').val();
    let modal_dot_border = $('#modal_dot_border').val();
    let modal_dot_border_radius = $('#modal_dot_border_radius').val();
    let modal_dot_margin = $('#modal_dot_margin').val();

    $.ajax({
      url: '/update_detail_page_ugc_modal_styles',
      type: 'POST',
      data: {
        is_device: is_device,
        modal_max_width: modal_max_width,
        modal_max_height: modal_max_height,
        modal_left_width: modal_left_width,
        modal_right_width: modal_right_width,
        modal_right_height: modal_right_height,
        is_modal_related_items: is_modal_related_items,
        is_modal_related_items_title: is_modal_related_items_title,
        modal_related_items_title_text: modal_related_items_title_text,
        modal_related_items_title_font_family: modal_related_items_title_font_family,
        modal_related_items_title_font_weight: modal_related_items_title_font_weight,
        modal_related_items_title_font_size: modal_related_items_title_font_size,
        modal_related_items_title_font_color: modal_related_items_title_font_color,
        is_modal_related_items_link: is_modal_related_items_link,
        modal_related_items_img_column_height: modal_related_items_img_column_height,
        modal_related_items_img_column_width: modal_related_items_img_column_width,
        modal_related_items_initial_img_count: modal_related_items_initial_img_count,
        modal_related_items_img_height: modal_related_items_img_height,
        modal_related_items_img_width: modal_related_items_img_width,
        modal_related_items_img_margin: modal_related_items_img_margin,
        modal_related_items_name_font_size: modal_related_items_name_font_size,
        modal_related_items_name_font_family: modal_related_items_name_font_family,
        modal_related_items_name_font_weight: modal_related_items_name_font_weight,
        modal_related_items_name_font_color: modal_related_items_name_font_color,
        modal_related_items_name_text_align: modal_related_items_name_text_align,
        modal_related_items_price_font_size: modal_related_items_price_font_size,
        modal_related_items_price_font_family: modal_related_items_price_font_family,
        modal_related_items_price_font_weight: modal_related_items_price_font_weight,
        modal_related_items_price_font_color: modal_related_items_price_font_color,
        modal_related_items_price_text_align: modal_related_items_price_text_align,
        modal_related_items_price_unit_text: modal_related_items_price_unit_text,
        is_modal_photo_by_link: is_modal_photo_by_link,
        modal_photo_by_icon_size: modal_photo_by_icon_size,
        modal_photo_by_margin: modal_photo_by_margin,
        modal_photo_by_text: modal_photo_by_text,
        modal_photo_by_font_size: modal_photo_by_font_size,
        modal_photo_by_font_family: modal_photo_by_font_family,
        modal_photo_by_font_weight: modal_photo_by_font_weight,
        modal_photo_by_font_color: modal_photo_by_font_color,
        is_modal_related_items_product_comment: is_modal_related_items_product_comment,
        modal_related_items_product_comment_height: modal_related_items_product_comment_height,
        modal_related_items_product_comment_position: modal_related_items_product_comment_position,
        modal_related_items_product_comment_font_size: modal_related_items_product_comment_font_size,
        modal_related_items_product_comment_font_family: modal_related_items_product_comment_font_family,
        modal_related_items_product_comment_font_weight: modal_related_items_product_comment_font_weight,
        modal_related_items_product_comment_font_color: modal_related_items_product_comment_font_color,
        modal_del_btn_size: modal_del_btn_size,
        modal_sns_post_img_object_fit: modal_sns_post_img_object_fit,
        modal_prev_post_btn_bg_color: modal_prev_post_btn_bg_color,
        modal_prev_post_btn_opacity: modal_prev_post_btn_opacity,
        modal_prev_post_btn_top: modal_prev_post_btn_top,
        modal_prev_post_btn_left: modal_prev_post_btn_left,
        modal_prev_post_btn_width: modal_prev_post_btn_width,
        modal_prev_post_btn_height: modal_prev_post_btn_height,
        modal_prev_post_btn_line_color: modal_prev_post_btn_line_color,
        modal_prev_post_btn_line_width: modal_prev_post_btn_line_width,
        modal_prev_post_btn_line_height: modal_prev_post_btn_line_height,
        modal_prev_post_btn_line_right: modal_prev_post_btn_line_right,
        modal_prev_post_btn_line_top: modal_prev_post_btn_line_top,
        modal_prev_post_btn_line_weight: modal_prev_post_btn_line_weight,
        modal_prev_post_btn_line_rotate: modal_prev_post_btn_line_rotate,
        modal_prev_post_btn_line_translatey: modal_prev_post_btn_line_translatey,
        modal_next_post_btn_bg_color: modal_next_post_btn_bg_color,
        modal_next_post_btn_opacity: modal_next_post_btn_opacity,
        modal_next_post_btn_top: modal_next_post_btn_top,
        modal_next_post_btn_left: modal_next_post_btn_left,
        modal_next_post_btn_width: modal_next_post_btn_width,
        modal_next_post_btn_height: modal_next_post_btn_height,
        modal_next_post_btn_line_color: modal_next_post_btn_line_color,
        modal_next_post_btn_line_width: modal_next_post_btn_line_width,
        modal_next_post_btn_line_height: modal_next_post_btn_line_height,
        modal_next_post_btn_line_right: modal_next_post_btn_line_right,
        modal_next_post_btn_line_top: modal_next_post_btn_line_top,
        modal_next_post_btn_line_weight: modal_next_post_btn_line_weight,
        modal_next_post_btn_line_rotate: modal_next_post_btn_line_rotate,
        modal_next_post_btn_line_translatey: modal_next_post_btn_line_translatey,
        modal_dot_left_display: modal_dot_left_display,
        modal_dot_left_bg_color: modal_dot_left_bg_color,
        modal_dot_left_height: modal_dot_left_height,
        modal_dot_left_width: modal_dot_left_width,
        modal_dot_left_opacity: modal_dot_left_opacity,
        modal_dot_left_border: modal_dot_left_border,
        modal_dot_left_border_radius: modal_dot_left_border_radius,
        modal_dot_left_margin: modal_dot_left_margin,
        modal_dot_left_line_height: modal_dot_left_line_height,
        modal_dot_left_line_width: modal_dot_left_line_width,
        modal_dot_left_line_top: modal_dot_left_line_top,
        modal_dot_left_line_right: modal_dot_left_line_right,
        modal_dot_left_line_border_top: modal_dot_left_line_border_top,
        modal_dot_left_line_border_right: modal_dot_left_line_border_right,
        modal_dot_left_line_transform: modal_dot_left_line_transform,
        modal_dot_right_display: modal_dot_right_display,
        modal_dot_right_bg_color: modal_dot_right_bg_color,
        modal_dot_right_height: modal_dot_right_height,
        modal_dot_right_width: modal_dot_right_width,
        modal_dot_right_opacity: modal_dot_right_opacity,
        modal_dot_right_border: modal_dot_right_border,
        modal_dot_right_border_radius: modal_dot_right_border_radius,
        modal_dot_right_margin: modal_dot_right_margin,
        modal_dot_right_line_height: modal_dot_right_line_height,
        modal_dot_right_line_width: modal_dot_right_line_width,
        modal_dot_right_line_top: modal_dot_right_line_top,
        modal_dot_right_line_right: modal_dot_right_line_right,
        modal_dot_right_line_border_top: modal_dot_right_line_border_top,
        modal_dot_right_line_border_right: modal_dot_right_line_border_right,
        modal_dot_right_line_transform: modal_dot_right_line_transform,
        modal_dot_display: modal_dot_display,
        modal_dot_height: modal_dot_height,
        modal_dot_width: modal_dot_width,
        modal_dot_opacity: modal_dot_opacity,
        modal_dot_border: modal_dot_border,
        modal_dot_border_radius: modal_dot_border_radius,
        modal_dot_margin: modal_dot_margin,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('モーダルのデザインを登録しました。');
        location.reload();
      }
    });
  });

  $('#ugc_detail_page_part_custom_set').on('click', function () {
    let is_device = $('#ugc_detail_page_setting_device_val').val();

    let is_top_dividing_line = $('#is_top_dividing_line').val();
    let top_dividing_line_width = $('#top_dividing_line_width').val();
    let top_dividing_line_height = $('#top_dividing_line_height').val();
    let top_dividing_line_color = $('#top_dividing_line_color').val();
    let top_dividing_line_margin = $('#top_dividing_line_margin').val();
    let is_jump_other_page_btn = $('#is_jump_other_page_btn').val();
    let jump_other_page_btn_text = $('#jump_other_page_btn_text').val();
    let jump_other_page_url = $('#jump_other_page_url').val();
    let jump_other_page_btn_text_font_color = $('#jump_other_page_btn_text_font_color').val();
    let jump_other_page_btn_text_font_size = $('#jump_other_page_btn_text_font_size').val();
    let jump_other_page_btn_text_font_family = $('#jump_other_page_btn_text_font_family').val();
    let jump_other_page_btn_text_font_weight = $('#jump_other_page_btn_text_font_weight').val();
    let jump_other_page_btn_border_color = $('#jump_other_page_btn_border_color').val();
    let jump_other_page_btn_border_radius = $('#jump_other_page_btn_border_radius').val();
    let jump_other_page_btn_text_align = $('#jump_other_page_btn_text_align').val();
    let jump_other_page_btn_margin = $('#jump_other_page_btn_margin').val();
    let jump_other_page_btn_width = $('#jump_other_page_btn_width').val();
    let jump_other_page_btn_height = $('#jump_other_page_btn_height').val();

    $.ajax({
      url: '/update_detail_page_ugc_part_styles',
      type: 'POST',
      data: {
        is_device: is_device,
        is_top_dividing_line: is_top_dividing_line,
        top_dividing_line_width: top_dividing_line_width,
        top_dividing_line_height: top_dividing_line_height,
        top_dividing_line_color: top_dividing_line_color,
        top_dividing_line_margin: top_dividing_line_margin,
        is_jump_other_page_btn: is_jump_other_page_btn,
        jump_other_page_btn_text: jump_other_page_btn_text,
        jump_other_page_url: jump_other_page_url,
        jump_other_page_btn_text_font_color: jump_other_page_btn_text_font_color,
        jump_other_page_btn_text_font_size: jump_other_page_btn_text_font_size,
        jump_other_page_btn_text_font_family: jump_other_page_btn_text_font_family,
        jump_other_page_btn_text_font_weight: jump_other_page_btn_text_font_weight,
        jump_other_page_btn_border_color: jump_other_page_btn_border_color,
        jump_other_page_btn_border_radius: jump_other_page_btn_border_radius,
        jump_other_page_btn_text_align: jump_other_page_btn_text_align,
        jump_other_page_btn_margin: jump_other_page_btn_margin,
        jump_other_page_btn_width: jump_other_page_btn_width,
        jump_other_page_btn_height: jump_other_page_btn_height,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('部品のデザインを登録しました。');
        location.reload();
      }
    });
  });

  //  カスタムCSS登録/更新
  $('#update_ugc_detail_page_setting_custom_css').on('click', function () {
    let is_device = $('#ugc_detail_page_setting_device_val').val();
    let custom_css = $('#ugc_detail_page_setting_custom_css').val();

    $.ajax({
      url: '/update_detail_page_custom_css',
      type: 'POST',
      data: {
        is_device: is_device,
        custom_css: custom_css,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('カスタムCSSを更新しました');
        location.reload();
      }
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // UGCレポート
  //-----------------------------------------------------------------------------------------------------------------
  function updateUrlAndRedirect(params, baseUrl = window.location.href) {
    let url = new URL(baseUrl);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    // start_dayおよびend_dayのパラメータがparamsに存在しない場合、これらのパラメータをURLから削除
    if (!params.start_day) {
      url.searchParams.delete('start_day');
    }
    if (!params.end_day) {
      url.searchParams.delete('end_day');
    }
    // 現在の履歴エントリに新しいURLを追加する
    history.pushState({}, '', url.toString());
    // ページをリロードする
    location.reload();
  }

  // パラメータを取得する関数
  function getParameters() {
    let params = {
      ugc_group_id: $('#ugc_selects option:selected').val(),
      id: $('#ugc_sns_post_selects option:selected').val(),
      device: $('.ugc_device_select').data('device'),
      gf: $('#ugc_graph_pattern_select_input').val(),
      ab: $('#ugc_report_ab_selects option:selected').val(),
    };

    if (params.gf === '30') {
      params.start_day = $('#report_start_day').val();
      params.end_day = $('#report_end_day').val();
    } else if (params.gf === '12') {
      delete params.start_day;
      delete params.end_day;
    }

    return params;
  }

  $('#ugc_sns_post_selects, #ugc_report_ab_selects').on('change', function () {
    updateUrlAndRedirect(getParameters());
  });

  $('#report_start_day, #report_end_day').on('change', function () {
    updateUrlAndRedirect(getParameters());
  });

  $('#ugc_selects').on('change', function () {
    const ugc_group_id = $('#ugc_selects option:selected').val();
    const sns_post_id = $('#ugc_sns_post_selects option:selected').val();
    const ugc_group_ab = $('#ugc_report_ab_selects option:selected').val();
    const device = $('.ugc_device_select').data('device');
    const start_day = $('#report_start_day').val();
    const end_day = $('#report_end_day').val();
    const selected_month = $('#ua_ugc_group_month_selects option:selected').val() || '';

    add_params = '';

    if (start_day && end_day) {
      add_params += '&start_day=' + start_day;
      add_params += '&end_day=' + end_day;
    }

    location.href = `/ugc_report?ugc_group_id=${ugc_group_id}&id=${sns_post_id}&device=${device}${add_params}&m=${selected_month}`;
  });

  $('.ugc_graph_pattern_select_day, .ugc_graph_pattern_select_month').on('click', function () {
    let params;
    if ($(this).hasClass('ugc_graph_pattern_select_day')) {
      params = getParameters();
      params.gf = '30';
      params.start_day = $('#report_start_day').val();
      params.end_day = $('#report_end_day').val();
    } else if ($(this).hasClass('ugc_graph_pattern_select_month')) {
      params = getParameters();
      params.gf = '12';
      delete params.start_day;
      delete params.end_day;
    }
    updateUrlAndRedirect(params);
  });

  $('.ugc_report_btn').on('click', function () {
    let params = getParameters();
    params.ugc_group_id = $(this).data('ugc_group_id');
    params.id = $(this).data('id');
    params.device = 2;
    params.gf = 30;
    updateUrlAndRedirect(params, `${DOMAIN}/ugc_report`);
  });

  $('.ugc_device_select_all, .ugc_device_select_pc, .ugc_device_select_phone').on('click', function () {
    let params = getParameters();
    if ($(this).hasClass('ugc_device_select_all')) {
      params.device = '2';
    } else if ($(this).hasClass('ugc_device_select_pc')) {
      params.device = '0';
    } else if ($(this).hasClass('ugc_device_select_phone')) {
      params.device = '1';
    }
    updateUrlAndRedirect(params);
  });

  $('#download_ugc_csv').on('click', function () {
    let href = '/download_ugc_csv';
    href += `?ugc_group_id=${$('#ugc_selects option:selected').val()}`;
    href += `&m=${$('#ua_ugc_group_month_selects option:selected').val()}`;
    href += `&device=${$('.ugc_device_select').data('device')}`;
    location.href = href;
  });

  $('.delete_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    let ugc_group_id = $('#ugc_selects option:selected').val();

    $.ajax({
      url: '/delete_ugc_group_log',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.reload();
      }
    });
  });

  $('.delete_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    let ugc_group_id = $('#ugc_selects option:selected').val();

    $.ajax({
      url: '/delete_ugc_group_log_and_related_data',
      type: 'POST',
      data: {
        ugc_group_id: ugc_group_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.href = '/ugc_report';
      }
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // UGC分析
  //-----------------------------------------------------------------------------------------------------------------
  $('#ua_ugc_selects').on('change', function () {
    let ugc_group_id = $('#ua_ugc_selects option:selected').val();
    let ugc_group_ab = $('#ua_ugc_ab_selects option:selected').val();
    let device = $('.ua_ugc_device_select').data('device');
    let start_day = $('#analysis_start_day').val();
    let end_day = $('#analysis_end_day').val();

    if (ugc_group_id == 'none') {
      location.href = `/ugc_analysis`;
    } else {
      if (ugc_group_ab == 'none' || ugc_group_ab == null) {
        if (!start_day || !end_day) {
          location.href = `/ugc_analysis?ugc_group_id=${ugc_group_id}&device=${device}`;
        } else {
          location.href = `/ugc_analysis?ugc_group_id=${ugc_group_id}&device=${device}&start_day=${start_day}&end_day=${end_day}`;
        }
      } else {
        location.href = `/ugc_analysis?ugc_group_id=${ugc_group_id}&ab=n&device=${device}&start_day=${start_day}&end_day=${end_day}`;
        if (!start_day || !end_day) {
          location.href = `/ugc_analysis?ugc_group_id=${ugc_group_id}&ab=n&device=${device}`;
        } else {
          location.href = `/ugc_analysis?ugc_group_id=${ugc_group_id}&ab=n&device=${device}&start_day=${start_day}&end_day=${end_day}`;
        }
      }
    }
  });

  // URLを構築し、ページをリダイレクトする関数
  function redirectToAnalysis() {
    const ugc_group_id = $('#ua_ugc_selects option:selected').val();
    const ugc_group_ab = $('#ua_ugc_ab_selects option:selected').val();
    const device = $('.ua_ugc_device_select').data('device');
    const start_day = $('#analysis_start_day').val();
    const end_day = $('#analysis_end_day').val();

    let params = new URLSearchParams();

    // ugc_group_idが'none'の場合のみugc_group_idをパラメータに追加
    if (ugc_group_id !== 'none') {
      params.append('ugc_group_id', ugc_group_id);

      // ugc_group_abが有効な値の場合のみ追加
      if (ugc_group_ab !== 'none' && ugc_group_ab !== null && ugc_group_ab !== 'undefined') {
        params.append('ab', ugc_group_ab);
      }

      params.append('device', device);
      params.append('start_day', start_day);
      params.append('end_day', end_day);
    }

    // ページのリダイレクト
    location.href = `/ugc_analysis?${params.toString()}`;
  }

  // 各要素の変更イベントに関数をバインド
  $('#ua_ugc_ab_selects, #analysis_start_day, #analysis_end_day').on('change', redirectToAnalysis);

  $('#ua_ugc_group_month_selects').on('change', function () {
    let ugc_group_id = $('#ua_ugc_selects option:selected').val();
    let month = $('#ua_ugc_group_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      location.href = 'ugc_analysis';
    }
  });

  $('.ua_ugc_device_select_all').on('click', function () {
    let url = new URL(window.location.href);

    // パラメーターにdeviceがある場合
    if (url.searchParams.has('device')) {
      // 既に設定されている値を取得
      let current_value = url.searchParams.get('device');

      // 値が "0"か"1" なら "2" に更新する
      let new_value = current_value === '0' || current_value === '1' ? '2' : current_value;

      // パラメーターの値を更新する
      url.searchParams.set('device', new_value);
    } else {
      // パラメーターにdeviceがない場合
      // 新しいパラメーターを追加する
      url.searchParams.append('device', '2');
    }

    // 更新されたURLにリダイレクトする
    location.href = url.toString();
  });
  $('.ua_ugc_device_select_pc').on('click', function () {
    let url = new URL(window.location.href);

    // パラメーターにdeviceがある場合
    if (url.searchParams.has('device')) {
      // 既に設定されている値を取得
      let current_value = url.searchParams.get('device');

      // 値が "1","2" なら "0" に更新する
      let new_value = current_value === '1' || current_value === '2' ? '0' : current_value;

      // パラメーターの値を更新する
      url.searchParams.set('device', new_value);
    } else {
      // パラメーターにdeviceがない場合
      // 新しいパラメーターを追加する
      url.searchParams.append('device', '0');
    }

    // 更新されたURLにリダイレクトする
    location.href = url.toString();
  });
  $('.ua_ugc_device_select_phone').on('click', function () {
    let url = new URL(window.location.href);

    // パラメーターにdeviceがある場合
    if (url.searchParams.has('device')) {
      // 既に設定されている値を取得
      let current_value = url.searchParams.get('device');

      // 値が "0","2" なら "1" に更新する
      let new_value = current_value === '0' || current_value === '2' ? '1' : current_value;

      // パラメーターの値を更新する
      url.searchParams.set('device', new_value);
    } else {
      // パラメーターにdeviceがない場合
      // 新しいパラメーターを追加する
      url.searchParams.append('device', '1');
    }

    // 更新されたURLにリダイレクトする
    location.href = url.toString();
  });

  $('.table_header').on('click', function () {
    let url = new URL(window.location.href);
    let p_vap = $(this).data('flag');

    // パラメーターにpがある場合
    if (url.searchParams.has('p')) {
      // 既に設定されている値を取得
      let current_value = url.searchParams.get('p');

      if (p_vap == current_value) {
        url.searchParams.delete('p');
      } else {
        // パラメーターの値を更新する
        url.searchParams.set('p', p_vap);
      }
    } else {
      // パラメーターにdeviceがない場合
      // 新しいパラメーターを追加する
      url.searchParams.append('p', p_vap);
    }

    // 更新されたURLにリダイレクトする
    location.href = url.toString();
  });

  //-----------------------------------------------------------------------------------------------------------------
  // 商品マスタ
  //-----------------------------------------------------------------------------------------------------------------
  $('#new_product_set_btn').on('click', function () {
    $('.platta_ig_modal_container').fadeIn(100);
  });

  $('#product_search').on('keypress', function (e) {
    if (e.which === 13) {
      e.preventDefault(); // デフォルトのエンターキーの挙動を無効にする
      let search_word = $(this).val();
      location.href = `/products_setting?p=${search_word}`;
    }
  });

  $('.all_product_list').on('click', function () {
    location.reload();
  });

  $('.product_edit').on('click', function () {
    let product_id = $(this).data('id');
    let product_code = $(this).data('code');
    let product_name = $(this).data('name');
    let product_image_url = $(this).data('image_url');
    let product_url = $(this).data('url');
    let product_price = $(this).data('price');
    let is_product_price_visible = $(this).data('is_product_price_visible');
    let is_post_visible = $(this).data('is_post_visible');
    let product_comment = $(this).data('comment');

    $('#product_edit_id').val(product_id);
    $('#product_edit_code').val(product_code);
    $('#product_edit_name').val(product_name);
    $('#product_edit_image_url').val(product_image_url);
    $('#product_edit_page_url').val(product_url);
    $('#product_edit_price').val(product_price);
    is_product_price_visible == 1 ? $('#edit_is_product_price_visible').prop("checked", true) : $('#edit_is_product_price_visible').prop("checked", false);
    is_post_visible == 1 ? $('#edit_is_post_visible').prop("checked", true) : $('#edit_is_post_visible').prop("checked", false);
    $('#product_edit_comment').val(product_comment);
    $('.platta_ig_edit_modal_container').fadeIn(100);
  });

  $('.platta_ig_modal_del').on('click', function () {
    $('.platta_ig_modal_container').fadeOut(0);
  });
  $('.platta_ig_edit_modal_del').on('click', function () {
    $('.platta_ig_edit_modal_container').fadeOut(0);
  });
  $('.platta_ig_modal_bg, .platta_ig_edit_modal_bg').on('click', function () {
    $('.platta_ig_modal_container').fadeOut(0);
    $('.platta_ig_edit_modal_container').fadeOut(0);
  });

  let currentProductId = null;
  $('.product_posts').on('click', function () {
    currentProductId = $(this).data("id");
    $.ajax({
      url: '/product_posts',
      type: 'POST',
      data: {
        product_id: $(this).data("id")
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        const grid = $('#posts_grid');
        grid.empty();
  
        data.posts.forEach(function(post){
          let media = '';
          if (post.s3_img_url.endsWith('.mp4')) {
            media = `<video src="${post.s3_img_url}" muted></video>`;
          } else {
            media = `<img src="${post.s3_img_url}">`;
          }
  
          grid.append(`
            <div class="post_item">
              <input type="checkbox" class="post_checkbox" value="${post.id}">
              <div class="delete_badge">連携解除</div>
              ${media}
            </div>
          `);
        });
        $('#posts_modal').fadeIn(360);
        $('#posts_overlay').fadeIn(100);
      }
    });
  });
  
  $('#unlink_posts_btn').on('click', function () {

    // チェックされた投稿ID配列を作る
    const postIds = $('.post_checkbox:checked').map(function(){
      return $(this).val();
    }).get();
  
    if (postIds.length === 0) {
      alert('削除する投稿を選択してください');
      return;
    }
  
    if (!confirm('選択した投稿の連携を解除します。よろしいですか？')) {
      return;
    }
  
    $.ajax({
      url: '/unlink_product_posts',
      type: 'POST',
      data: {
        product_id: currentProductId,
        post_ids: postIds
      },
      dataType: 'json'
    }).done(function(data){
      if(data.ret == 0){
        location.reload();
      }else{
        alert('削除に失敗しました');
      }
    });
  
  });

  $(document).on('change', '.post_checkbox', function(){
    const badge = $(this).siblings('.delete_badge');
  
    if($(this).is(':checked')){
      badge.show();
    }else{
      badge.hide();
    }
  });  
  
  $('#close_posts').on('click', function(){
    $('#posts_modal').hide();
    $('#posts_overlay').hide();
  });

  $('.product_submit_btn').on('click', function () {
    $('.product_submit_btn').css('pointer-events', 'none');

    let product_code = $('#product_code').val();
    let product_name = $('#product_name').val();
    let product_image_url = $('#product_image_url').val();
    let product_page_url = $('#product_page_url').val();
    let product_price = $('#product_price').val();
    let is_product_price_visible = $('#is_product_price_visible').prop("checked") ? 1 : 0;
    let is_post_visible = $('#is_post_visible').prop("checked") ? 1 : 0;
    let product_sale_price = $('#product_sale_price').val();
    let product_comment = $('#product_comment').val();
    let product_stock_status = $('#product_stock_status').val();

    // if (product_name == '' || product_image_url == '' || product_page_url == '') {
    //   alert('入力必須項目は必ず入力してください。');
    //   $('.product_submit_btn').css('pointer-events', 'auto');
    //   return;
    // }

    $.ajax({
      url: '/product_submit',
      type: 'POST',
      data: {
        product_code: product_code,
        product_name: product_name,
        product_image_url: product_image_url,
        product_page_url: product_page_url,
        product_price: product_price,
        is_product_price_visible: is_product_price_visible,
        is_post_visible: is_post_visible,
        product_sale_price: product_sale_price,
        product_comment: product_comment,
        product_stock_status: product_stock_status,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('商品情報を登録しました。');
        location.reload();
      }
    });
  });

  $('.product_delete').on('click', function () {
    let product_id = $(this).data('id');
    let product_code = $(this).data('code');
    $.ajax({
      url: '/delete_product',
      type: 'POST',
      data: {
        product_id: product_id,
        product_code: product_code,
        delete_flag: 0,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('商品を削除しました。');
        location.reload();
      } else if (data.ret == '1') {
        if (!confirm('UGC投稿と連携されています。削除する場合は、連携も解除されます。本当に削除しますか？')) {
          return;
        } else {
          $.ajax({
            url: '/delete_product',
            type: 'POST',
            data: {
              product_id: product_id,
              product_code: product_code,
              delete_flag: 1,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              alert('商品を削除しました。投稿との連携も解除しました。');
              location.reload();
            }
          });
        }
      }
    });
  });
  $('.product_edit_submit_btn').on('click', function () {
    let product_id = $('#product_edit_id').val();
    let product_code = $('#product_edit_code').val();
    let product_page_url = $('#product_edit_page_url').val();
    let product_name = $('#product_edit_name').val();
    let product_image_url = $('#product_edit_image_url').val();
    let product_url = $('#product_edit_page_url').val();
    let product_price = $('#product_edit_price').val();
    let is_product_price_visible = $('#edit_is_product_price_visible').prop("checked") ? 1 : 0;
    let is_post_visible = $('#edit_is_post_visible').prop("checked") ? 1 : 0;
    let product_comment = $('#product_edit_comment').val();

    if (product_name == '' || product_image_url == '' || product_page_url == '') {
      alert('入力必須項目は必ず入力してください。');
      return;
    }

    $.ajax({
      url: '/edit_product',
      type: 'POST',
      data: {
        product_id: product_id,
        product_code: product_code,
        product_name: product_name,
        product_image_url: product_image_url,
        product_url: product_url,
        product_price: product_price,
        is_product_price_visible: is_product_price_visible,
        is_post_visible: is_post_visible,
        product_comment: product_comment,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('商品を情報を編集しました。');
        location.reload();
      }
    });
  });

  
  //-----------------------------------------------------------------------------------------------------------------
  // Hashframe
  //-----------------------------------------------------------------------------------------------------------------
  if (window.location.pathname.includes("/campaign_show") || window.location.pathname.includes("/campaign_new")) {
    const imageInput = document.getElementById("campaign-image-input");
    const previewContainer = document.getElementById("campaign-image-preview-container");

    let selectedFiles = [];

    // 画像プレビュー処理
    imageInput.addEventListener("change", function () {
      const files = Array.from(imageInput.files);

      if (selectedFiles.length + files.length > 5) {
        alert("画像は最大5つまでアップロードできます。");
        return;
      }

      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          const imageId = selectedFiles.length;
          selectedFiles.push(file);

          const imageWrapper = document.createElement("div");
          imageWrapper.classList.add("campaign-image-preview-item");
          imageWrapper.setAttribute("data-id", imageId);

          const img = document.createElement("img");
          img.src = e.target.result;

          const removeButton = document.createElement("button");
          removeButton.textContent = "削除";
          removeButton.classList.add("remove-button");
          removeButton.setAttribute("data-id", imageId);
          removeButton.addEventListener("click", function () {
            removeImage(imageId);
          });

          imageWrapper.appendChild(img);
          imageWrapper.appendChild(removeButton);
          previewContainer.appendChild(imageWrapper);
        };
        reader.readAsDataURL(file);
      });
    });

    // 画像削除処理
    function removeImage(imageId) {
      selectedFiles = selectedFiles.filter((_, index) => index !== imageId);
      previewContainer.querySelector(`[data-id='${imageId}']`).remove();
    }

    $('#title').on('blur', function () {
      if($(this).val().length > 80){
        alert("「PR案件のタイトル」の文字数制限を超えています。");
      }
    });
    $('#service_url').on('blur', function () {
      if($(this).val().length > 200){
        alert("「サービスのURL」の文字数制限を超えています。");
      }
    });
    $('#service_name').on('blur', function () {
      if($(this).val().length > 80){
        alert("「提供するサービス」の文字数制限を超えています。");
      }
    });
    $('#description').on('blur', function () {
      if($(this).val().length > 1200){
        alert("「サービスの概要」の文字数制限を超えています。");
      }
    });
    $('#task').on('blur', function () {
      if($(this).val().length > 500){
        alert("「やってほしいこと」の文字数制限を超えています。");
      }
    });
    $('#persona').on('blur', function () {
      if($(this).val().length > 200){
        alert("「こんな人にお仕事をお願いしたい」の文字数制限を超えています。");
      }
    });
    $('#precaution').on('blur', function () {
      if($(this).val().length > 300){
        alert("「投稿に関する注意事項」の文字数制限を超えています。");
      }
    });
    $('#postscript').on('blur', function () {
      if($(this).val().length > 200){
        alert("「投稿に記載するメンション・ハッシュタグ」の文字数制限を超えています。");
      }
    });

    $('.edit-campaign-images').on('click', function () {
      $('.image-preview-area').fadeOut(0);
      $('.edit-campaign-images').fadeOut(0);
      $('.image-input-area').fadeIn(500);
      $('.cancel-campaign-images').fadeIn(500);
      $('#campaign_image_edit').val("1");
      
    });
    
    $('.cancel-campaign-images').on('click', function () {
      $('.image-input-area').fadeOut(0);
      $('.cancel-campaign-images').fadeOut(0);
      $('.image-preview-area').fadeIn(500);
      $('.edit-campaign-images').fadeIn(500);
      $('#campaign_image_edit').val(0);
    });
  }
  
  let message_contents = $("#message_contents"); // スクロール対象の要素
  if (message_contents.length) { // 存在する場合のみ実行
    message_contents.animate({ scrollTop: message_contents[0].scrollHeight }, 800); // 800ms でアニメーション
  }

  $('#update_campaign, #create_campaign').on('click', function () {
    let campaign_id = $("#campaign_id").val().trim();
    let title = $("#title").val().trim();
    let category = $("#category").val().trim();
    let service_url = $("#service_url").val().trim();
    let service_name = $("#service_name").val().trim();
    let description = $("#description").val().trim();
    let task = $("#task").val().trim();
    let persona = $("#persona").val().trim();
    let precaution = $("#precaution").val().trim();
    let postscript = $("#postscript").val().trim();
    let recruitment_numbers = $("#recruitment_numbers").val().trim();
    let is_open = $('input[name="is_open"]:checked').val();
    let campaign_image_edit = $('#campaign_image_edit').val();

    if(title==""){
      alert("「PR案件のタイトル」を入力してください");
      return;
    }
    if(category==""){
      alert("「カテゴリー」を入力してください");
      return;
    }
    if(service_url==""){
      alert("「サービスのURL」を入力してください");
      return;
    }
    if(service_name==""){
      alert("「提供するサービス」を入力してください");
      return;
    }
    if(description==""){
      alert("「サービスの概要」を入力してください");
      return;
    }
    if(task==""){
      alert("「やってほしいこと」を入力してください");
      return;
    }
    if(persona==""){
      alert("「こんな人にお仕事をお願いしたい」を入力してください");
      return;
    }
    if(precaution==""){
      alert("「投稿に関する注意事項」を入力してください");
      return;
    }
    if(postscript==""){
      alert("「投稿に記載するメンション・ハッシュタグ」を入力してください");
      return;
    }
    if(recruitment_numbers==""){
      alert("「募集人数」を入力してください");
      return;
    }
    if(title.length > 50){
      alert("「PR案件のタイトル」の文字数制限を超えています。");
      return;
    }
    if(service_url.length > 200){
      alert("「提供するサービス」の文字数制限を超えています。");
      return;
    }
    if(service_name.length > 80){
      alert("「提供するサービス」の文字数制限を超えています。");
      return;
    }
    if(description.length > 1200){
      alert("「サービスの概要」の文字数制限を超えています。");
      return;
    }
    if(task.length > 500){
      alert("「やってほしいこと」の文字数制限を超えています。");
      return;
    }
    if(persona.length > 200){
      alert("「こんな人にお仕事をお願いしたい」の文字数制限を超えています。");
      return;
    }
    if(precaution.length > 300){
      alert("「投稿に関する注意事項」の文字数制限を超えています。");
      return;
    }
    if(postscript.length > 200){
      alert("「投稿に記載するメンション・ハッシュタグ」の文字数制限を超えています。");
      return;
    }
    let campaign_url = "";
    if(campaign_id==""){
      campaign_url = '/create_campaign';
    }else{
      campaign_url = '/update_campaign';
    }
    if (!confirm('この内容で送信しますか？')) {
      return;
    }

    let formData = new FormData();

    // テキストデータを追加
    formData.append("id", campaign_id);
    formData.append("is_open", is_open);
    formData.append("title", title);
    formData.append("category", category);
    formData.append("service_url", service_url);
    formData.append("service_name", service_name);
    formData.append("description", description);
    formData.append("task", task);
    formData.append("persona", persona);
    formData.append("precaution", precaution);
    formData.append("postscript", postscript);
    formData.append("recruitment_numbers", recruitment_numbers);
    formData.append("campaign_image_edit", campaign_image_edit);

    // 画像を取得して追加
    if((campaign_url == '/create_campaign') || (campaign_image_edit=="1")){
      let imageInput = document.getElementById("campaign-image-input");
      if (imageInput.files.length > 5) {
          alert("画像は最大5つまでアップロードできます。");
          return;
      }
      for (let i = 0; i < imageInput.files.length; i++) {
          formData.append("images[]", imageInput.files[i]);
      }
    }
    
    $.ajax({
      url: DOMAIN + campaign_url,
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
    }).done(function (data) {
      location.href="/campaign_index";
    });
  });

  // インフルエンサーをお気に入りに入れるボタン
  $('.favorite-btn').on('click', function () {
    $.ajax({
      url: DOMAIN + '/bookmark_user',
      type: 'POST',
      data: {
        user_id: $(this).data("user-id")
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // インフルエンサーを非表示にするボタン
  $('.hide-btn').on('click', function () {
    $.ajax({
      url: DOMAIN + '/hidden_user',
      type: 'POST',
      data: {
        user_id: $(this).data("user-id")
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // 依頼リクエストボタン
  $('.request2-btn').on('click', function () {
    const $btn = $(this);
  
    if ($("#campaign").val().trim() === "") {
      alert("依頼するキャンペーンを選択してください");
      return;
    }
  
    if ($("#message").val().trim() === "") {
      alert("メッセージを入力してください");
      return;
    }
  
    if (!confirm('この内容で送信しますか？')) return;
  
    // 二重送信防止
    if ($btn.hasClass('sending')) return;
  
    // 状態変更：スピナー＋ボタン無効
    $btn.addClass('sending').prop('disabled', true).html('<span class="spinner"></span> 送信中...');
  
    $.ajax({
      url: DOMAIN + '/campaign_request',
      type: 'POST',
      data: {
        user_id: $btn.data("user-id"),
        campaign_id: $("#campaign").val(),
        message: $("#message").val()
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.message === "OK") {
        alert("依頼を送信しました");
        location.href = "/user_index";
      } else {
        alert(ERROR_MSG);
        $btn.removeClass('sending').prop('disabled', false).text('リクエストを送信');
      }
    }).fail(function () {
      alert("送信に失敗しました");
      $btn.removeClass('sending').prop('disabled', false).text('リクエストを送信');
    });
  });
  
  // 依頼リクエストボタン
  $('.update-usertags').on('click', function () {
    $.ajax({
      url: DOMAIN + '/update_usertags',
      type: 'POST',
      data: {
        user_id: $(this).data("user-id"),
        tags: $("#tags").val()
      },
      dataType: 'json',
    }).done(function (data) {
      alert("タグを更新しました");
      location.reload();
    }).fail(function () {
      alert("送信に失敗しました");
    });
  });


  $('#campaign_status').on('change', function () {
    location.href="/campaign_index?is_open=" + $(this).val();
  });

  $('#entry_status').on('change', function () {
    location.href="/entry_index?status=" + $(this).val();
  });
  
  $('#request_status').on('change', function () {
    location.href="/request_index?status=" + $(this).val();
  });

  $('#maching_status').on('change', function () {
    location.href="/matching_index?status=" + $(this).val();
  });

  // 応募を採用ボタン
  $('.approval-btn').on('click', function () {
    const $btn = $(this);
    if (!confirm('この応募を採用しますか？')) {
      return;
    }
    // 二重送信防止
    if ($btn.hasClass('sending')) return;
    // 状態変更
    $btn.addClass('sending').prop('disabled', true).html('<span class="spinner"></span> 採用中...');
  
    $.ajax({
      url: DOMAIN + '/approval_entry',
      type: 'POST',
      data: {
        id: $btn.data("id")
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.message == "OK") {
        alert("応募を採用しました\nメニューの「メッセージ」からインフルエンサーに連絡をお願いします");
        location.href = "/entry_index";
      } else {
        alert(ERROR_MSG);
        $btn.removeClass('sending').prop('disabled', false).text('応募を採用');
      }
    }).fail(function () {
      alert("通信エラーが発生しました");
      $btn.removeClass('sending').prop('disabled', false).text('応募を採用');
    });
  });
  

  // 応募をお見送りボタン
  $('.disapproval-btn').on('click', function () {
    const $btn = $(this);
  
    if (!confirm('この応募をお見送りにしますか？')) return;
  
    // 二重送信防止
    if ($btn.hasClass('sending')) return;
  
    // エフェクト開始
    $btn.addClass('sending').prop('disabled', true).html('<span class="spinner"></span> お見送り中...');
  
    $.ajax({
      url: DOMAIN + '/disapproval_entry',
      type: 'POST',
      data: {
        id: $btn.data("id")
      },
      dataType: 'json',
    }).done(function () {
      location.href = "/entry_index";
    }).fail(function () {
      alert("処理に失敗しました");
      $btn.removeClass('sending').prop('disabled', false).text('応募をお見送り');
    });
  });  

  // 依頼フォーム開くボタン
  $('.request-btn').on('click', function () {
    $(".input-area").slideDown(240);
    $(".request-btn").fadeOut(0);
    $(".request2-btn").fadeIn(0);
    $(".cancel-btn").fadeIn(0);
  });

  // 依頼のキャンセルボタン
  $('.cancel-btn').on('click', function () {
    $(".input-area").slideUp(120);
    $(".request-btn").fadeIn(0);
    $(".request2-btn").fadeOut(0);
    $(".cancel-btn").fadeOut(0);
  });

  // インフルエンサー一覧のユーザ検索
  $('.user-search').on('click', function () {
    
    let nick_name = $("#nick_name").val().trim();
    $("#nick_name").val(nick_name);

    let from_age = parseInt($("#from_age").val(), 10);
    if (from_age < 20) {
      $("#from_age").val(20);
    }
    let to_age = parseInt($("#to_age").val(), 10);
    if (to_age > 99) {
      $("#to_age").val(99);
    }

    let href = "/user_index?s=1";
    if(nick_name!=""){
      href += "&nick_name=" + nick_name;
    }
    if($("#from_age").val()!=""){
      href += "&from_age=" + $("#from_age").val();
    }
    if($("#to_age").val()!=""){
      href += "&to_age=" +  $("#to_age").val();
    }
    if($("#gender").val()!=""){
      href += "&gender=" + $("#gender").val();
    }
    if($("#prefecture").val()!=""){
      href += "&prefecture=" + $("#prefecture").val();
    }
    if($("#category").val()!=""){
      href += "&category=" + $("#category").val();
    }
    if ($("#bookmark").is(":checked")) {
      href += "&bookmark=1";
    }
    if($("#from_follower").val()!=""){
      href += "&from_follower=" +  $("#from_follower").val();
    }
    if($("#to_follower").val()!=""){
      href += "&to_follower=" +  $("#to_follower").val();
    }
    if($("#tags").val()!=""){
      href += "&tags=" +  $("#tags").val();
    }
    if ($("#hidden").is(":checked")) {
      href += "&hidden=1";
    }
    location.href = href;
  });

  // メッセージ送信
  $('.send-message').on('click', function () {
    const $button = $(this);
    const message = $("#message_text").val();
  
    if (message.trim() === "") {
      alert("メッセージを入力してください");
      return;
    }
  
    // すでに送信中なら何もしない（← 二重送信防止）
    if ($button.hasClass('sending')) return;
  
    // 送信中の状態に切り替え（クラス追加・無効化・表示変更）
    $button.addClass('sending').prop('disabled', true);
    $button.html('<span class="spinner"></span> 送信中...');
  
    $.ajax({
      url: DOMAIN + '/send_message',
      type: 'POST',
      data: {
        message: message,
        room_id: $("#room_id").val(),
        user_id: $("#user_id").val()
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    }).fail(function () {
      alert("送信に失敗しました");
      // 失敗した場合はボタンを戻す
      $button.removeClass('sending').prop('disabled', false).text('📤 送信');
    });
  });  

  // 絵文字送信
  $('.send-emoji').on('click', function () {
    $(this).closest(".message-row").find(".emoji-area").html($(this).data("val"));
    $(this).closest(".message-row").find(".emoji-area").fadeIn(200);
    $.ajax({
      url: DOMAIN + '/send_emoji',
      type: 'POST',
      data: {
        emoji: $(this).data("val"),
        message_id: $(this).data("message-id"),
        room_id: $("#room_id").val(),
        user_id: $("#user_id").val()
      },
      dataType: 'json',
    }).done(function (data) {
    });
  });

  $(".message-row").on("mouseenter", function() {
    $(this).find(".emoji-form").show();
  });

  $(".message-row").on("mouseleave", function() {
    $(this).find(".emoji-form").hide();
  });

  $(".hide-room").on("click", function() {
    if (!confirm(`このチャットを非表示にしますか？`)) {
      return;
    }
    $.ajax({
      url: DOMAIN + '/hide_room',
      type: 'POST',
      data: {
        val: 1,
        room_id: $("#room_id").val()
      },
      dataType: 'json',
    }).done(function (data) {
      location.href = "/message_index";
    });
  });

  $(".show-room").on("click", function() {
    if (!confirm(`このチャットの非表示を解除しますか？`)) {
      return;
    }
    $.ajax({
      url: DOMAIN + '/hide_room',
      type: 'POST',
      data: {
        val: 0,
        room_id: $("#room_id").val()
      },
      dataType: 'json',
    }).done(function (data) {
      location.href = "/message_index?hidden=1";
    });
  });

  $(".check-post").on("click", function() {
    if (!confirm(`この依頼を完了させますか？`)) {
      return;
    }
    $.ajax({
      url: DOMAIN + '/check_post',
      type: 'POST',
      data: {
        room_id: $("#room_id").val()
      },
      dataType: 'json',
    }).done(function (data) {
      alert("依頼案件のチェックが完了しました、このスレッドは「完了」のタブに移動されます。");
      location.href = "/message_index";
    });
  });

  $("#copy-btn").on("click", function() {
    let copyText = $("#address_str").text();

    if (navigator.clipboard && navigator.clipboard.writeText) {
        // ✅ 最新ブラウザ向け
        navigator.clipboard.writeText(copyText).then(() => {
            let message = document.getElementById("copy-message");
            message.style.display = "block"; 
            setTimeout(() => message.style.display = "none", 2000);
        }).catch(err => {
            console.error("コピーに失敗しました:", err);
        });
    } else {
        // ✅ 旧ブラウザ向け（`execCommand`）
        let textarea = document.createElement("textarea");
        textarea.value = copyText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        let message = document.getElementById("copy-message");
        message.style.display = "block"; 
        setTimeout(() => message.style.display = "none", 2000);
    }
});

  $(".show-address").on("click", function() {
    $(".modal-address").fadeIn();
    $(".modal-bk").fadeIn();
  });

  // クリップアイコンをクリック → モーダルを開く
  $("#message-file-input").on("click", function() {
    $(".modal-bk").fadeIn();
    $(".modal-content").fadeIn();
  });
  
  $(".modal-close, .modal-bk").on("click", function() {
    $(".modal-content").fadeOut(50);
    $(".modal-address").fadeOut(50);
    $(".modal-bk").fadeOut(50);
  });

  let dropArea = $("#drop-area");
  
    // クリックでファイル選択
    dropArea.on("click", function() {
      document.getElementById("file-input").click();
    });

  // ドラッグオーバー時のスタイル変更
  dropArea.on("dragover", function(event) {
    event.preventDefault();
    dropArea.css("background", "#ddd");
  });

  // ドラッグ離した時のスタイルリセット
  dropArea.on("dragleave", function(event) {
    event.preventDefault();
    dropArea.css("background", "#f9f9f9");
  });

  // ドロップ時の処理
  dropArea.on("drop", function(event) {
    event.preventDefault();
    dropArea.css("background", "#f9f9f9");

    let files = event.originalEvent.dataTransfer.files;
    console.log("ドロップされたファイル:", files);
    handleFiles(files);
  });
  
  // ファイルが選択されたら処理
  $("#file-input").on("change", function(event) {
    let files = event.target.files;
    handleFiles(files);
  });
  
  // 画像をプレビュー表示
  function handleFiles(files) {
    if (files.length > 0) {
      let file = files[0];
      let reader = new FileReader();

      reader.onload = function(e) {
        $("#preview").attr("src", e.target.result).show();
        $("#image-upload-btn").data("file", file); // ボタンにファイルをセット
      };

      reader.readAsDataURL(file);
    }
  }

  // 画像をアップロード（S3に送信）
  $("#image-upload-btn").on("click", function() {
    let file = $(this).data("file");
    if (!file) {
      alert("ファイルを選択してください");
      return;
    }
  
    // 許可する画像の MIME タイプ（拡張子チェック）
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    
    if (!allowedTypes.includes(file.type)) {
      alert("画像ファイル（JPEG, PNG）のみアップロードできます");
      return;
    }

    // ボタンを一時的に無効化
    const $upload_button = $(this);
    $upload_button.prop("disabled", true);

    let formData = new FormData();
    formData.append("image", file);
    formData.append("room_id", $(this).data("room"));
    formData.append("user_id", $(this).data("user"));
  
    $.ajax({
      url: "/upload_message_file",
      type: "POST",
      data: formData,
      contentType: false,
      processData: false,
      success: function(response) {
        location.reload();
      },
      error: function(xhr, status, error) {
        alert("アップロードに失敗しました");
      },
      complete: function () {
        $upload_button.prop("disabled", false);
      }
    });
  });
  
  //-----------------------------------------------------------------------------------------------------------------
  // プレビュー作成
  //-----------------------------------------------------------------------------------------------------------------
  $('#create_preview_btn')
    .off()
    .on('click', function () {
      $('.loadding').css('display', 'block');
      let ugc_group_id = $('#create_preview_select option:selected').val();
      let preview_url = $('#create_preview_url').val();
      let preview_html_name = $('#create_preview_html_name').val();
      let tag_check = $('#create_preview_tag').prop('checked');
      if (ugc_group_id == '' || ugc_group_id == null || preview_url == '' || preview_html_name == '') {
        $('.loadding').css('display', 'none');
        alert('必須項目を入力してください。');
        return;
      }

      $.ajax({
        url: '/save_preview',
        type: 'POST',
        data: {
          ugc_group_id: ugc_group_id,
          url: preview_url,
          file_name: preview_html_name,
          tag_check: tag_check,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          alert('プレビューを作成しました。');
          location.reload();
        }
      });
    });

  $('.create_preview_html_edit').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/edit_preview_html',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        // モーダルを作成し、HTMLコンテンツとボタンを表示
        let modalHtml = `<div id="html_modal_wrapper"></div>
                        <div id="html_modal_container" class="fixed p-5 top-[2.5%] left-1/2 transform -translate-x-1/2 w-90per h-90per overflow-auto text-center bg-white dark:text-gray-500 dark:bg-gray-900 dark:border-b dark:border-black">
                          <div class="border border-gray-200 h-90per mb-4">
                            <textarea id="html_modal_text_area" class="p-2 h-full w-full"></textarea>
                          </div>
                          <div class="flex justify-center">
                            <div id="html_remove_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-gray-500 hover:bg-gray-700 dark:hover:bg-gray-600 dark:bg-gray-800 dark:text-gray-500">閉じる</div>
                            <div id="html_save_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-base-800 hover:bg-base-800 ml-2 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500">保存</div>
                          </div>
                        </div>`;

        // モーダルをbody要素に追加
        $('body').append(modalHtml);
        $('#html_modal_text_area').text(data.html_content);

        $('#html_save_btn').on('click', function () {
          let html = $('#html_modal_text_area').val();
          $.ajax({
            url: '/update_preview_html',
            type: 'POST',
            data: {
              id: preview_id,
              url: preview_url,
              html: html,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              alert('htmlを編集しました。');
              location.reload();
            }
          });
        });

        $('#html_modal_wrapper, #html_remove_btn').on('click', function (e) {
          $('#html_modal_wrapper, #html_modal_container, #html_modal_text_area, #html_save_btn').remove();
        });
      }
    });
  });

  $('.create_preview_url_delete').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/preview_delete',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('プレビューurlを削除しました。');
        location.reload();
      }
    });
  });

  //-----------------------------------------------------------------------------------------------------------------
  // コメント　レビュー用
  //-----------------------------------------------------------------------------------------------------------------
  $('.to_t_comment').on('click', function () {
    let href = '/t_comment';
    location.href = href;
  });

  //-----------------------------------------------------------------------------------------------------------------
  // コメント　レビュー用
  //-----------------------------------------------------------------------------------------------------------------
  $('.to_post_picture').on('click', function () {
    let href = '/post_picture';
    location.href = href;
  });

  $('.to_t_dm').on('click', function () {
    let href = '/t_dm';
    location.href = href;
  });

  // oembed レビュー用
  $('.to_oembed').on('click', function () {
    let href = '/oembed';
    location.href = href;
  });

  // ハッシュタグ、自社投稿関連
  let current_display_type = '';
  let reverse_current_display_type = '';

  // 投稿の表示タイプによってlocalStorageに保存するキー名を変える
  if (current_url.includes('hashtag_list?display_type=1')) {
    current_display_type = 'recent';
    // 投稿の表示タイプが切り替わったあとでは表示させるべきlocalStorageのアイテムが逆になる
    reverse_current_display_type = 'popular';
  } else if (current_url.includes('hashtag_list?display_type=0')) {
    current_display_type = 'popular';
    // 投稿の表示タイプが切り替わったあとでは表示させるべきlocalStorageのアイテムが逆になる
    reverse_current_display_type = 'recent';
  } else if (current_url.includes('/my_post_list')) {
    // 自社投稿の場合
    current_display_type = 'my';
  } else {
    // https://dev-manage-ssl.platta.jp/hashtag_list 等のクエリがない初期の場合
    current_display_type = 'recent';
    reverse_current_display_type = 'recent';
  }

  // 投稿収集一覧画面用
  //   const not_condition_placeholder = `検索結果から除外したいハッシュタグ名を下記のように改行で区切って続けて入力してください。
  // 注) ハッシュタグマーク # は含めないでください

  //   例:
  //   ドナルド
  //   ミッキー
  //   ミニー
  //       `;

  const not_condition_placeholder = `検索結果から除外したいハッシュタグ名を改行を入れて続けて入力してください。
注) ハッシュタグマーク # は含めないでください
      `;

  if ($('#excluded_words').length > 0) {
    $('#excluded_words')[0].placeholder = not_condition_placeholder;
  }

  // ハッシュタグ収集一覧画面のカレンダーにて今日の日付しか入力できないようにする
  if ($('#hashtag_initial_date')) {
    let today = new Date().toISOString().split('T')[0];
    // $('input[type="date"]').attr('max', today);
  }

  let selected_tag_ids = [];
  let selected_tag_names = [];

  // 表示する期間
  let initial_date = $('#hashtag_initial_date').val();
  let end_date = $('#hashtag_end_date').val();

  // タググループのidを取得する
  let tgg_id = $('#selected_hashtag_group option:selected').val();

  //############################################################
  // ハッシュタグ一覧画面のURLパラメータ生成
  //############################################################
  const generate_hashtag_list_url_params = function () {
    // 投稿の表示タイプ
    let display_type = "all";

    // 投稿された期間
    const { hashtagInitialDate, hashtagEndDate } = getDefaultHashtagDates();
    let initial_date = localStorage.getItem('hashtag_initial_date') || $('#hashtag_initial_date').val() || hashtagInitialDate;
    let end_date = localStorage.getItem('hashtag_end_date') || $('#hashtag_end_date').val() || hashtagEndDate;

    // タググループ
    let tgg_id = localStorage.getItem('hashtag_group') || $('#selected_hashtag_group option:selected').val() || "";

    // ハッシュタグリスト
    let lstorage_hashtag_list = JSON.parse(localStorage.getItem('hashtag_list')) || [];
    let all_tag_check_box = $('input.tag_info');

    if (lstorage_hashtag_list.length > 0) {
      selected_tag_ids = lstorage_hashtag_list
      $.each(all_tag_check_box, function (index, el) {
        if (lstorage_hashtag_list.includes($(el).val())) {
          el.checked = true;
        }
      });
    } else {
      $.each(all_tag_check_box, function (index, el) {
        el.checked = true;
      });

      $('.tag_info:checked').each(function () {
        selected_tag_ids.push($(this).val());
      });
    }

    // タグ名検索（AND/OR）
    let search_condition = localStorage.getItem('search_condition') || $('#search_condition option:selected').val() || "1";

    // ページ内表示件数
    let per_page_num = localStorage.getItem('per_page_num') || $('#per_page_num option:selected').val() || "50";

    let url_query_path = 
      `/hashtag_list?display_type=${display_type}` +
      `&initial_date=${initial_date}` +
      `&end_date=${end_date}` +
      `&tgg_id=${tgg_id}` +
      `&search_condition=${search_condition}` +
      `&per_page_num=${per_page_num}`;

    selected_tag_ids.forEach(function (tag_id, index) {
      url_query_path = url_query_path + `&tag_id_${index}=${tag_id}`;
    });

    return url_query_path;
  };

  // 検索条件の表示非表示 slideToggle -
  $('.accordion_filter, .cmm_accordion_filter').click(function () {
    $(this)
      .next()
      .slideToggle(300, function () {
        $(this).toggleClass('close');
      });
    if ($(this).next().hasClass('close')) {
      $(this).text('絞り込み条件を非表示にする');
    } else {
      $(this).text('絞り込み条件を表示する');
    }
  });

  // 投稿収集一覧 / My投稿一覧画面の開発、本番別 url
  let url_hashtag_list_dev, url_hashtag_list_pro, url_my_posts_dev, url_my_posts_pro;

  // 本番環境と開発環境に応じてurlを動的に切り替える
  if (window.location.href.indexOf('18.177.103.115') > -1) {
    // Development environment
    if (window.location.href.includes('http://18.177.103.115:3004/')) {
      url_hashtag_list_dev = 'http://18.177.103.115:3004/hashtag_list';
      url_my_posts_dev = 'http://18.177.103.115:3004/my_post_list';
    } else {
      url_hashtag_list_dev = 'http://18.177.103.115:3002/hashtag_list';
      url_my_posts_dev = 'http://18.177.103.115:3002/my_post_list';
    }
  } else if (window.location.href.indexOf('dev-manage-ssl') > -1) {
    // Development environment(https化)
    url_hashtag_list_dev = 'https://dev-manage-ssl.platta.jp/hashtag_list';
    url_my_posts_dev = 'https://dev-manage-ssl.platta.jp/my_post_list';
  } else {
    // Production environment
    url_hashtag_list_pro = 'https://manage.platta.jp/hashtag_list';
    url_my_posts_pro = 'https://manage.platta.jp/my_post_list';
  }

  if (
    // タググループが登録されていない、またはタグ名が登録されていない、またその両方の場合(初めてのお客様を想定)
    current_url === (url_hashtag_list_dev || url_hashtag_list_pro) &&
    ($('#selected_hashtag_group').children().length == 0 || $('#is_any_data').children().length == 0)
  ) {
    location.href = generate_hashtag_list_url_params();
  } else if (current_url === (url_hashtag_list_dev || url_hashtag_list_pro)) {
    location.href = generate_hashtag_list_url_params();
  }

  if (current_url.includes('/my_post_list?')) {
    $('.to_my_post_list').css('pointer-events', 'none');
  }

  // サイドバーからのルーティングだとループが起こるため下記のようにした
  $('.to_my_post_list').on('click', function (event) {
    $('.to_my_post_list').css('pointer-events', 'none');
    event.preventDefault();

    // 表示する期間
    let initial_date = $('#hashtag_initial_date').val();
    let end_date = $('#hashtag_end_date').val();

    // 投稿の種類(最近の投稿 or 人気の投稿)を取得する
    let display_type = $('.display_type:checked').val();

    // AND / OR 検索のidを取得する
    let search_condition = $('#search_condition option:selected').val();

    // ハッシュタグ収集一覧ページ内に表示する投稿の数を取得する
    let per_page_num = $('#per_page_num option:selected').val();

    let url_query_path = `/my_post_list?display_type=${display_type}&initial_date=${initial_date}&end_date=${end_date}&search_condition=${search_condition}&per_page_num=${per_page_num}`;

    // undefinedが入ってしまった場合の対処法
    if (url_query_path.includes('undefined')) {
      let today = new Date().toISOString().split('T')[0];
      let display_type = "all";
      let initial_date = '2022-01-01';
      let search_condition = 1;
      let per_page_num = 50;

      revised_my_post_url_query_path = `/my_post_list?display_type=${display_type}&initial_date=${initial_date}&end_date=${today}&search_condition=${search_condition}&per_page_num=${per_page_num}`;

      location.href = revised_my_post_url_query_path;
      return revised_my_post_url_query_path;
    }

    location.href = url_query_path;
  });

  // hashtag_list localStorage一覧
  let lstorage_hashtag_list_display_type;
  let lstorage_per_page_num;
  let lstorage_hashtag_initial_date;
  let lstorage_hashtag_end_date;
  let lstorage_hashtag_group;
  let lstorage_search_condition;
  let lstorage_hashtag_list;
  let lstorage_excluded_words_list;
  let lstorage_ugc_urls_list;

  // localStorageの中身を取り出す
  if (current_url.includes('/hashtag_list') || current_url.includes('/my_post')) {
    if (window.localStorage) {
      if (localStorage.getItem('hashtag_list_display_type')) {
        lstorage_hashtag_list_display_type = localStorage.getItem('hashtag_list_display_type');
        $(`input.display_type[type="radio"][value="${lstorage_hashtag_list_display_type}"]`).prop('checked', true);
      }

      lstorage_per_page_num = localStorage.getItem('per_page_num');

      lstorage_hashtag_initial_date = localStorage.getItem('hashtag_initial_date');

      if (localStorage.getItem('hashtag_end_date')) {
        lstorage_hashtag_end_date = localStorage.getItem('hashtag_end_date');
      }

      lstorage_hashtag_group = localStorage.getItem('hashtag_group');

      lstorage_search_condition = localStorage.getItem('search_condition');

      lstorage_excluded_words_list = localStorage.getItem('excluded_words_list');

      if (lstorage_excluded_words_list) {
        lstorage_excluded_words_list = JSON.parse(lstorage_excluded_words_list);
        lstorage_excluded_words_list = lstorage_excluded_words_list.join('\n');
      }

      // ugc urls をローカルストレージから取得する
      lstorage_ugc_urls_list = localStorage.getItem(`ugc_urls_list`);

      if (lstorage_ugc_urls_list) {
        lstorage_ugc_urls_list = JSON.parse(lstorage_ugc_urls_list);
        lstorage_ugc_urls_list = lstorage_ugc_urls_list.join('\n');
      }

      // ハッシュタグリストをローカルストレージから取得する
      lstorage_hashtag_list = localStorage.getItem('hashtag_list');

      if (lstorage_hashtag_list) {
        lstorage_hashtag_list = JSON.parse(lstorage_hashtag_list);
      }
      let all_tag_check_box = $('input.tag_info:checkbox');

      if (lstorage_hashtag_list && lstorage_hashtag_list.length > 0) {
        $.each(all_tag_check_box, function (index, el) {
          if (lstorage_hashtag_list.includes($(el).val())) {
            el.checked = true;
          }
        });
      } else if (!lstorage_hashtag_list) {
        let tag_info_list = [];

        $.each(all_tag_check_box, function (index, el) {
          tag_info_list.push(el.value);
          el.checked = true;
        });

        tag_info_list = JSON.stringify(tag_info_list);
        localStorage.setItem('hashtag_list', tag_info_list);
      }

      let allChecked = true;

      $.each(all_tag_check_box, function (index, el) {
        if (!el.checked) {
          allChecked = false;
        }
      });

      $('.toggle_all_tags').prop('checked', allChecked);

      // 以前使っていたlocalstorageのデータ項目。本番反映してしばらくは残しておく20240831
      localStorage.removeItem('popular_hashtag_group');
      localStorage.removeItem('recent_hashtag_group');
      localStorage.removeItem('popular_hashtag_initial_date');
      localStorage.removeItem('recent_hashtag_initial_date');
      localStorage.removeItem('popular_hashtag_end_date');
      localStorage.removeItem('recent_hashtag_end_date');
      localStorage.removeItem('popular_hashtag_list');
      localStorage.removeItem('recent_hashtag_list');
      localStorage.removeItem('popular_search_condition');
      localStorage.removeItem('recent_search_condition');
      localStorage.removeItem('popular_per_page_num');
      localStorage.removeItem('recent_per_page_num');
      localStorage.removeItem('popular_excluded_words_list');
      localStorage.removeItem('recent_excluded_words_list');
      localStorage.removeItem('popular_ugc_urls_list');
      localStorage.removeItem('recent_ugc_urls_list');
    }
  }

  // localStorageで取り出したものを画面に表示する
  // 投稿収集一覧で最近の投稿の場合 https://dev-manage-ssl.platta.jp/hashtag_list でクエリが何もないものも最近の投稿に含まれる
  if (current_url === url_hashtag_list_pro || current_url === url_hashtag_list_dev || current_url.includes('/hashtag_list?display_type=all')) {
    // 除外するハッシュタグ名をテキストエリアに自動入力する
    $('#excluded_words').text(lstorage_excluded_words_list);

    // ugc urlsテキストエリアを自動入力する
    $('#ugc_urls').text(lstorage_ugc_urls_list);
  }

  // localStorageで取り出したものを画面に表示する
  // 投稿収集一覧で人気の投稿の場合
  if (current_url.includes('/hashtag_list?display_type=0')) {
    // 除外するハッシュタグ名をテキストエリアに自動入力する
    $('#excluded_words').text(lstorage_excluded_words_list);

    // ugc urlsテキストエリアを自動入力する
    $('#ugc_urls').text(lstorage_ugc_urls_list);
  }

  // 投稿された期間の始まりをlocalStorageに保存
  $('#hashtag_initial_date').on('change', function () {
    localStorage.setItem('hashtag_initial_date', $('#hashtag_initial_date').val());
  });

  // 投稿された期間の終わりをlocalStorageに保存
  $('#hashtag_end_date').on('change', function () {
    localStorage.setItem('hashtag_end_date', $('#hashtag_end_date').val());
  });

  // ハッシュタググループをlocalStorageに保存
  $('#selected_hashtag_group').on('change', function () {
    localStorage.setItem('hashtag_group', $('#selected_hashtag_group option:selected').val());
  });

  // チェックのついたハッシュタグの一覧をlocalStorageに保存
  $('.tag_info').on('change', function () {
    let tag_info_list = [];
    let allChecked = true;
  
    $.each($('.tag_info:checkbox'), function (idk, tag) {
      if ($(tag).is(':checked')) {
        tag_info_list.push($(tag).val());
      } else {
        allChecked = false;
      }
    });

    $('.toggle_all_tags').prop('checked', allChecked);

    // 複数のデータ(配列)を保存したいためJSON形式のデータとして保存します。
    tag_info_list = JSON.stringify(tag_info_list);
    localStorage.setItem('hashtag_list', tag_info_list);
  });

  // 検索タイプをlocalStorageに保存
  $('#search_condition').on('change', function () {
    localStorage.setItem('search_condition', $('#search_condition option:selected').val());
  });

  // ページ内表示件数 localStorageに保存
  $('#per_page_num').on('change', function () {
    localStorage.setItem('per_page_num', $('#per_page_num option:selected').val());
  });

  // 除外するハッシュタグ名一覧をlocalStorageに保存
  $('#excluded_words').on('change', function () {
    let excluded_words_list = [];
    let excluded_list = $('#excluded_words').val().split('\n');

    $.each(excluded_list, function (idk, excluded_word) {
      //! NG if (tag.is(":checked")) {
      // 下記のように jquery オブジェクトにする必要あり
      if ($('#excluded_words').val() && $('#excluded_words').val()) {
        excluded_words_list.push(excluded_word);
      }
    });
    excluded_words_list = JSON.stringify(excluded_words_list);
    localStorage.setItem('excluded_words_list', excluded_words_list);
  });

  // UGCURLをlocalStorageに保存
  $('#ugc_urls').on('change', function () {
    let ugc_urls = $('#ugc_urls').val();
    // 余分な空白等含む可能性あり
    ugc_urls_list = ugc_urls.split('\n');

    // 要素についているかもしれない前後の空白除去及び 'https://~ ' や "https://~ "などの ' や "を削除"
    ugc_urls_list = $.map(ugc_urls_list, function (url, idx) {
      return url.replace(/'/g, '').replace(/"/g, '').replace(/,/g, '').trim();
    });

    let ugc_urls_list_str = JSON.stringify(ugc_urls_list);
    localStorage.setItem('ugc_urls_list', ugc_urls_list_str);
  });

  // 人気の投稿 - クリックしたらページ遷移させる
  // 投稿の表示タイプを変更した場合、すでに切り替わったあとなので 最新の投稿 と 人気の投稿が逆になるので、画面に表示するlocalStorageは最近と人気を逆にしなければならない
  $('.radio-003').on('change', function () {
    // location.hrefが発動するまで切り替えをできないようにする - アプリケーションの負荷を下げるため
    $('.radio-003').css('pointer-events', 'none');
    // 投稿の種類(最近の投稿 or 人気の投稿)を取得する
    let display_type = $('.display_type:checked').val();

    // localStorage 投稿の表示タイプを保存
    $('.display_type').each(function () {
      localStorage.setItem('hashtag_list_display_type', display_type);
    });

    // 投稿された期間
    lstorage_hashtag_initial_date = localStorage.getItem('hashtag_initial_date');

    lstorage_hashtag_end_date = localStorage.getItem('hashtag_end_date');

    // ハッシュタググループ
    lstorage_hashtag_group = localStorage.getItem('hashtag_group');

    // 検索タイプ
    lstorage_search_condition = localStorage.getItem('search_condition');

    // 1ページの表示数
    lstorage_per_page_num = localStorage.getItem('per_page_num');

    // 表示する期間
    let initial_date = '';
    let end_date = '';
    let search_condition = '';

    if (lstorage_hashtag_group) {
      hashtag_group = lstorage_hashtag_group;
    } else {
      hashtag_group = $('#selected_hashtag_group option:selected').val();
    }

    if (lstorage_search_condition) {
      search_condition = lstorage_search_condition;
    } else {
      search_condition = $('#search_condition option:selected').val();
    }

    if (lstorage_hashtag_end_date) {
      end_date = lstorage_hashtag_end_date;
    } else {
      end_date = $('#hashtag_end_date').val();
    }

    if (lstorage_hashtag_initial_date) {
      initial_date = lstorage_hashtag_initial_date;
    } else {
      initial_date = $('#hashtag_initial_date').val();
    }

    if (lstorage_hashtag_end_date) {
      end_date = lstorage_hashtag_end_date;
    } else {
      end_date = $('#hashtag_end_date').val();
    }

    if (lstorage_per_page_num) {
      per_page_num = lstorage_per_page_num;
    } else {
      per_page_num = $('#per_page_num option:selected').val();
    }

    // タググループのidを取得
    let tgg_id = $('#selected_hashtag_group option:selected').val();

    let url_query_path =
      `/hashtag_list?display_type=${display_type}` +
      `&initial_date=${initial_date}` +
      `&end_date=${end_date}` +
      `&tgg_id=${tgg_id}` +
      `&search_condition=${search_condition}` +
      `&per_page_num=${per_page_num}`;

    // チェックされたタグを取得
    let selected_tag_ids = [];
    $('.tag_info:checked').each(function () {
      selected_tag_ids.push($(this).val());
    });

    selected_tag_ids.forEach(function (tag_id, index) {
      url_query_path = url_query_path + `&tag_id_${index}=${tag_id}`;
    });

    location.href = url_query_path;
  });

  // タググループに紐付いた全てのタグをチェックする
  $('.toggle_all_tags').on('change', function () {
    // タググループに紐付いた全てのチェックボックスを全て取得
    let all_tag_check_box = $('.tag_info:checkbox');
    let tag_info_list = [];

    $.each(all_tag_check_box, function (index, el) {
      if ($('.toggle_all_tags').is(':checked')) {
        tag_info_list.push(el.value);
        el.checked = true;
      } else {
        el.checked = false;
      }
    });

    tag_info_list = JSON.stringify(tag_info_list);
    localStorage.setItem('hashtag_list', tag_info_list);
  });

  // タググループ選択 ハッシュタググループの情報を取得
  $('#selected_hashtag_group').on('change', function () {
    // 投稿の種類(最近の投稿 or 人気の投稿)を取得する
    let display_type = $('.display_type:checked').val();

    // 表示する期間
    let initial_date = $('#hashtag_initial_date').val();
    let end_date = $('#hashtag_end_date').val();

    // タググループのidを取得する
    let tgg_id = $('#selected_hashtag_group option:selected').val();

    // ハッシュタグリストをリセットする
    localStorage.removeItem('hashtag_list');

    // AND / OR 検索のidを取得する
    let search_condition = $('#search_condition option:selected').val();

    // ハッシュタグ収集一覧ページ内に表示する投稿の数を取得する
    let per_page_num = $('#per_page_num option:selected').val();

    // タググループ切り替え時は全てのタグで検索する（all_tag_check）
    let url_query_path =
      `/hashtag_list?display_type=${display_type}` +
      `&initial_date=${initial_date}` +
      `&end_date=${end_date}` +
      `&tgg_id=${tgg_id}` +
      `&search_condition=${search_condition}` +
      `&per_page_num=${per_page_num}` +
      `&all_tag_check=1`;
    
    if ($("#username_disp").is(':checked')) {
      url_query_path = url_query_path + "&username_disp=1"
    };

    location.href = url_query_path;
  });

  // 現在選ばれている絞り込みの状態を取得
  const get_all_filter_condition = function () {
    // 投稿の種類(最近の投稿 or 人気の投稿)を取得する
    let display_type = $('.display_type:checked').val();

    // 表示する期間
    let initial_date = $('#hashtag_initial_date').val();
    let end_date = $('#hashtag_end_date').val();

    // タググループのidとnameを取得する
    let tgg_id = $('#selected_hashtag_group option:selected').val();

    let selected_tag_ids = [];
    let selected_tag_names = [];

    // ハッシュタグのidを取得する
    $('.tag_info:checked').each(function () {
      selected_tag_ids.push($(this).val());
    });

    let tag_names = '';
    let tag_ids = '';
    let excluded_words_str = '';


    $.each(selected_tag_ids, function (index, tag_id) {
      tag_ids += `tag_id_${index}=${tag_id}&`;
    });
    tag_ids = tag_ids.slice(0, -1);

    // Not条件で検索結果家から除外するハッシュタグや言葉を取得
    excluded_words = $('#excluded_words').val().trim();

    // * 改行コードを含んだ文字列を配列にする
    let excluded_word_list = excluded_words.split(/\r\n|\r|\n/);

    // 配列の中の空要素を削除し、空要素のない配列を作る
    excluded_word_list = $.grep(excluded_word_list, function (value) {
      return value != '';
    });

    $.each(excluded_word_list, function (index, excluded_word) {
      excluded_words_str += `excluded_word_${index}=${excluded_word}&`;
    });
    excluded_words_str = excluded_words_str.slice(0, -1);

    // AND / OR 検索のidを取得する
    let search_condition = $('#search_condition option:selected').val();

    // ハッシュタグ収集一覧ページ内に表示する投稿の数を取得する
    let per_page_num = $('#per_page_num option:selected').val();

    result = {
      display_type: display_type,
      initial_date: initial_date,
      end_date: end_date,
      tgg_id: tgg_id,
      tag_ids: tag_ids,
      excluded_words: excluded_words_str,
      search_condition: search_condition,
      per_page_num: per_page_num,
    };

    return result;
  };

  // ボタンを押下したタイミングで複数の選択されたタグ名及び検索タイプを配列で取得する
  $('#submit, #own_submit').on('click', function (e) {
    $(this).addClass('pointer-events-none');
    let ugc_urls = $('#ugc_urls').val();
    // 余分な空白等含む可能性あり
    ugc_urls_list = ugc_urls.split('\n');

    // 要素についているかもしれない前後の空白除去及び 'https://~ ' や "https://~ "などの ' や "を削除"
    ugc_urls_list = $.map(ugc_urls_list, function (url, idx) {
      return url.replace(/'/g, '').replace(/"/g, '').replace(/,/g, '').trim();
    });

    ugc_urls_list_str = JSON.stringify(ugc_urls_list);
    localStorage.setItem('ugc_urls_list', ugc_urls_list_str);

    $.ajax({
      url: DOMAIN + '/filter_hashtag_ugc',
      type: 'GET',
      dataType: 'json',
      data: {
        ugc_urls_list: localStorage.getItem('ugc_urls_list'),
      },
    })
      .done(function (data_fr_ruby) {
        const filter_condition = get_all_filter_condition();

        let switch_url;
        if (current_url.includes('/hashtag_list')) {
          switch_url = '/hashtag_list';
        } else if (current_url.includes('/my_post_list')) {
          switch_url = '/my_post_list';
        } else if (current_url.includes('/all_post_type_display')) {
          switch_url = '/all_post_type_display';
        }

        url_query_path =
          `${switch_url}?display_type=${filter_condition['display_type']}` +
          `&initial_date=${filter_condition['initial_date']}` +
          `&end_date=${filter_condition['end_date']}` +
          `&tgg_id=${filter_condition['tgg_id']}` +
          `&${filter_condition['tag_names']}` +
          `&${filter_condition['tag_ids']}` +
          `&caption=${$("#search_caption").val()}` +
          `&product_name=${$("#search_product").val()}` +
          `&ugc_group=${$("#search_ugc_group").val()}` +
          `&username=${$("#search_username").val()}` +
          `&search_condition=${filter_condition['search_condition']}` +
          `&${filter_condition['excluded_words']}` +
          `&per_page_num=${filter_condition['per_page_num']}` +
          `&ugc_check=1`;

        if ($("#username_disp").is(':checked')) {
          url_query_path = url_query_path + "&username_disp=1"
        };

        lstorage_ugc_urls_list = localStorage.getItem('ugc_urls_list');

        if (lstorage_ugc_urls_list) {
          lstorage_ugc_urls_list = JSON.parse(lstorage_ugc_urls_list);
          lstorage_ugc_urls_list = lstorage_ugc_urls_list.join('\n');
        }

        location.href = url_query_path;
      })
      .fail(function (jqXHR, textStatus, errorThrown) {});

    // ugc検索をする場合はreturnし、あとの処理を走らせない
    if (ugc_urls_list.length > 0) {
      return;
    }

    // 投稿の種類(最近の投稿 or 人気の投稿)を取得する
    let display_type = $('.display_type:checked').val();

    // 表示する期間
    let initial_date = $('#hashtag_initial_date').val();
    let end_date = $('#hashtag_end_date').val();

    // タググループのidを取得する
    let tgg_id = $('#selected_hashtag_group option:selected').val();

    // AND / OR 検索のidを取得する
    let search_condition = $('#search_condition option:selected').val();

    // ハッシュタグ収集一覧ページ内に表示する投稿の数を取得する
    let per_page_num = $('#per_page_num option:selected').val();

    // ハッシュタグのidと名前を取得する
    $('.tag_info:checked').each(function () {
      selected_tag_ids.push($(this).val());
      selected_tag_names.push($(this).data('name'));
    });

    // Not条件で検索結果家から除外するハッシュタグや言葉を取得
    let excluded_words = $('#excluded_words').val().trim();

    // * 改行コードを含んだ文字列を配列にする
    let excluded_word_list = excluded_words.split(/\r\n|\r|\n/);

    // 配列の中の空要素を削除し、空要素のない配列を作る
    excluded_word_list = $.grep(excluded_word_list, function (value) {
      return value != '';
    });
    if (current_url.includes('/my_post_list?')) {
      let url_query_path = `/my_post_list?display_type=${display_type}&initial_date=${initial_date}&end_date=${end_date}&search_condition=${search_condition}&per_page_num=${per_page_num}`;
      if (excluded_word_list) {
        excluded_word_list.forEach(function (excluded_word, index) {
          url_query_path = url_query_path + `&excluded_word_${index}=${excluded_word}`;
        });
      }

      location.href = url_query_path;
    } else if (current_url.includes('/hashtag_list')) {
      // 投稿収集一覧用
      let url_query_path = 
        `/hashtag_list?display_type=${display_type}` +
        `&initial_date=${initial_date}` +
        `&end_date=${end_date}` +
        `&tgg_id=${tgg_id}` +
        `&search_condition=${search_condition}` +
        `&caption=${$("#search_caption").val()}` +
        `&product_name=${$("#search_product").val()}` +
        `&username=${$("#search_username").val()}` +
        `&ugc_group=${$("#search_ugc_group").val()}` +
        `&per_page_num=${per_page_num}`;

      selected_tag_ids.forEach(function (tag_id, index) {
        url_query_path = url_query_path + `&tag_id_${index}=${tag_id}`;
      });

      if (excluded_word_list) {
        excluded_word_list.forEach(function (excluded_word, index) {
          url_query_path = url_query_path + `&excluded_word_${index}=${excluded_word}`;
        });
      }
      location.href = url_query_path;
    }
  });

  //############################################################
  // MY投稿一覧 - 自社の投稿一覧を取得する
  //############################################################
  $('#get_my_sns_posts, #get_my_sns_posts_50').on('click', function () {
    let loader = $('.get_posts_loader-wrap');
    let current_url = window.location.href;
    let my_post_ger_restriction_hour = 4;

    // Get the ID of the clicked element
    let clickedElementId = $(this).attr('id');

    const confirm_yes = window.confirm(`実行すると本機能は${my_post_ger_restriction_hour}時間使用できなくなります。実行しますか ? \n\nTip: 毎日深夜に直近の貴社の投稿が50件取り込まれ、自動で本画面に反映されます。 `);

    if (confirm_yes) {
      loader.css('display', 'block');
      $('#get_my_sns_posts').css('pointer-events', 'none');

      alert('自社の投稿データの取得を開始します。\n自社の投稿が取り切れていなかった場合はお手数ですが、再度時間を置いてから「自社投稿データを取得」ボタンをクリックするようお願いいたします。');

      $.ajax({
        url: DOMAIN + '/get_my_posts',
        type: 'POST',
        data: {
          current_date_time: 'current_date_time',
          clickedElementId: clickedElementId,
        },
        dataType: 'json',
      })
        .done(function (data) {
          alert('取り込みが完了しました!!');
          loader.fadeOut();
          location.href = current_url;
        })
        // ! 自社投稿を取得するために必要な許可がない場合に起こるエラーをrails側からキャッチし
        // ! alertとして可視化している
        .fail(function (jqXHR, textStatus, errorThrown) {
          let errorResponse = JSON.parse(jqXHR.responseText);

          // 青木 ★要更新 - 20240404
          if (errorResponse.error.includes('Unsupported get request.')) {
            alert(errorResponse.error);
          }
          // ! # * エラーメッセージ全文: "message": "Unsupported get request. Object with ID 'media' does not exist, cannot be loaded due to missing permissions, or does not support this operation. Please read the Graph API documentation at https://developers.facebook.com/docs/graph-api"

          // 自社の投稿一覧で自社メディアをDBに保存処理中にalert(ERROR_MSG);が出ることがあるため alert()は出さないようにし、「自社投稿データを取得」ボタンクリック時にalert()を出すようにしている
          $('#get_my_sns_posts').css('pointer-events', 'auto');
          // alert('取り込みが中断されました(中断されるまでのデータは反映されております)。恐れ入りますが、再度時間を置いてからお試しください。');

          // console.log('jqXHR: ', jqXHR);
          // console.log('textStatus: ', textStatus);
          // console.log('errorThrown: ', errorThrown);

          location.reload();
        });
    }
  });

  //############################################################
  // ハッシュタグの収集 platta社員のみ - ハッシュタグの投稿を取得する
  //############################################################

  let currentTime = new Date().getTime();
  let recentButtonClickedTime = localStorage.getItem('recentButtonClickedTime');

  if (recentButtonClickedTime === null || currentTime - recentButtonClickedTime >= 3600000) {
    $('#platta_get_hashtag_posts_recent').css('pointer-events', 'auto');
  } else {
    $('#platta_get_hashtag_posts_recent').css('background', 'gray');
    $('#platta_get_hashtag_posts_recent').css('pointer-events', 'none');
  }

  let popularButtonClickedTime = localStorage.getItem('popularButtonClickedTime');

  if (popularButtonClickedTime === null || currentTime - popularButtonClickedTime >= 3600000) {
    $('#platta_get_hashtag_posts_top').css('pointer-events', 'auto');
  } else {
    $('#platta_get_hashtag_posts_top').css('background', 'gray');
    $('#platta_get_hashtag_posts_top').css('pointer-events', 'none');
  }

  const get_hashtag_related_posts = function (ajax_url_path, media_type) {
    let loader = $('.get_posts_loader-wrap');
    let current_url = window.location.href;

    const confirm_yes = window.confirm(`ハッシュタグの登録件数及び1週間の利用制限があるため、不要なタグは削除してから実行をお願い致します。 \n\n本プログラムは現在登録されているハッシュタグの最近の投稿及び人気の投稿を取得します。5~20分後、ハッシュタグが収集されているかご確認お願い致します。\n\n本ダイアログを閉じた後、取得は継続されるので別のページに移動しても問題ございません。`);

    if (confirm_yes) {
      let currentTime = new Date().getTime();

      if (media_type == '最近の投稿') {
        localStorage.setItem('recentButtonClickedTime', currentTime);

        $('#platta_get_hashtag_posts_recent').css('pointer-events', 'none');
        $('#platta_get_hashtag_posts_recent').css('background', 'gray');
        $('#platta_get_hashtag_posts_recent').text('最近の投稿: 1時間後に制限が解除されます。その後に再度お試しください。');
      }

      if (media_type == '人気の投稿') {
        localStorage.setItem('popularButtonClickedTime', currentTime);

        $('#platta_get_hashtag_posts_top').css('pointer-events', 'none');
        $('#platta_get_hashtag_posts_top').css('background', 'gray');
        $('#platta_get_hashtag_posts_top').text('人気の投稿: 1時間後に制限が解除されます。その後に再度お試しください。');
      }

      $.ajax({
        url: DOMAIN + ajax_url_path,
        type: 'POST',
        data: {
          yes: 'yes',
        },
        dataType: 'json',
      })
        .done(function (data) {
          alert(`${media_type}の取り込みが完了しました!!`);
          loader.fadeOut();
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          $('#get_my_sns_posts').css('pointer-events', 'auto');
        });
    }
  };

  // 最近の投稿を手動で取得する
  $('#platta_get_hashtag_posts_recent').on('click', function () {
    get_hashtag_related_posts('/get_hashtag_posts_recent', '最近の投稿');
  });

  // 人気の投稿を手動で取得する
  $('#platta_get_hashtag_posts_top').on('click', function () {
    get_hashtag_related_posts('/get_hashtag_posts_top', '人気の投稿');
  });

  // app review用 レビューの必要がなくなり次第削除
  $('#app_review_test_login').on('click', function () {
    $('a[href="/app_review_test_login"]').css('pointer-events', 'none');
  });

  //############################################################
  // AppReview用 - コメント機能 -
  //############################################################
  $('.t-send_comment').on('click', function () {
    $('.t-send_comment').css('pointer-events', 'none');

    $.ajax({
      url: DOMAIN + '/send_comment',
      type: 'POST',
      data: {
        comment: $('.post_card_content__comment').val(),
      },
      dataType: 'json',
    })
      .done(function (data) {
        alert('コメントを送信しました。');
        $('.post_card_content__comment').val('');
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        alert(`コメントの送信が失敗しました。再度お試しください。${errorThrown}`);
        $('#get_my_sns_posts').css('pointer-events', 'auto');
      });
  });

  // ###################################################
  // google review クチコミ
  // ###################################################
  $('#ggl_review__issue_token').on('click', function () {
    $.ajax({
      type: 'POST',
      url: DOMAIN + '/get_google_review_access_token',
      data: 'data',
      dataType: 'json',
      success: function (data) {
        alert('Success');
      },
      error: function (jqXHR, textStatus, errorThrown) {},
    });
  });

  // ###################################################
  // MY投稿一覧に移動したときにローカルストレージの保存内容を画面上に反映させる
  // ###################################################

  // MY投稿一覧に移動したときに自動でローカルストレージの内容を反映する
  if (current_url.includes('/my_post_list')) {
    lstorage_ugc_urls_list = localStorage.getItem('ugc_urls_list');

    if (lstorage_ugc_urls_list) {
      lstorage_ugc_urls_list = JSON.parse(lstorage_ugc_urls_list);
      lstorage_ugc_urls_list = lstorage_ugc_urls_list.join('\n');

      // 除外するハッシュタグ名をテキストエリアに自動入力する
      $('#excluded_words').text(lstorage_excluded_words_list);

      // ugc urlsテキストエリアを自動入力する
      $('#ugc_urls').text(lstorage_ugc_urls_list);
    }
  }
  if (current_url.includes('/to_communication_management?')) {
    $('.to_my_post_list').css('pointer-events', 'none');
  }

  // ハッシュタグ収集一覧画面のカレンダーにて今日の日付しか入力できないようにする
  if ($('#cmm_main_initial_date')) {
    let today = new Date().toISOString().split('T')[0];
    // $('input[type="date"]').attr('max', today);
  }

  let lstorage_cmm_sub_ugc_urls_list;

  // localStorageにアイテムが存在した場合、デフォルトのテキストを書き換える処理
  const get_local_storage_item_overwrite_value = function (id_name) {
    if (localStorage.getItem(id_name)) {
      $(`#${id_name}`).val(localStorage.getItem(id_name));
      return localStorage.getItem(id_name);
    } else {
      return undefined;
    }
  };

  // localStorageにアイテムが存在した場合、チェックをつける処理
  const get_local_storage_item_checked = function (id_name) {
    if (localStorage.getItem(id_name)) {
      $(`#${id_name}`).prop('checked', true);
      return localStorage.getItem(id_name);
    } else {
      return undefined;
    }
  };

  // localStorageにアイテムが存在した場合、optonタグにselected をつける処理
  const get_local_storage_item_selected = function (id_name) {
    const selectedValue = localStorage.getItem(id_name);
    if (selectedValue) {
      $(`#${id_name} option[value="${selectedValue}"]`).prop('selected', true);
      return selectedValue;
    } else {
      return undefined;
    }
  };

  $(function () {
    $('.to_communication_management').on('click', function (event) {
      $('.to_communication_management').css('pointer-events', 'none');
      event.preventDefault();

      // localStorageでメディアタイプの初期チェック状態を管理する
      let cmm_main_media_type_pic = get_local_storage_item_checked('cmm_main_media_type_pic');
      let cmm_main_media_type_carousel = get_local_storage_item_checked('cmm_main_media_type_carousel');
      let cmm_main_media_type_video = get_local_storage_item_checked('cmm_main_media_type_video');

      // localStorageでステータスの初期チェック状態を管理する
      let cmm_main_status_need_confirm = get_local_storage_item_checked('cmm_main_status_need_confirm');
      let cmm_main_status_ok_ugc = get_local_storage_item_checked('cmm_main_status_ok_ugc');
      let cmm_main_status_ng_ugc = get_local_storage_item_checked('cmm_main_status_ng_ugc');
      let cmm_main_status_done_ugc = get_local_storage_item_checked('cmm_main_status_done_ugc');
      // ugc連携を解除した状態
      let cmm_main_status_cancel_ugc = get_local_storage_item_checked('cmm_main_status_cancel_ugc');

      // 御礼送信済みの状態
      let cmm_main_status_thanked_ugc = get_local_storage_item_checked('cmm_main_status_thanked_ugc');

      // localStorageでinput要素のテキスト状態を管理する
      let cmm_main_username = get_local_storage_item_overwrite_value('cmm_main_username');
      let cmm_main_comment_keyword = get_local_storage_item_overwrite_value('cmm_main_comment_keyword');
      let cmm_main_initial_date = get_local_storage_item_overwrite_value('cmm_main_initial_date');
      let cmm_main_end_date = get_local_storage_item_overwrite_value('cmm_main_end_date');
      let cmm_main_per_page_num = get_local_storage_item_overwrite_value('cmm_main_per_page_num');

      // 初期値を設定 = 最新の返信順
      let cmm_main_display_order = get_local_storage_item_selected('cmm_main_display_order') || 'latest_replied_order';

      let cmm_main_ugc_urls_list = [];
      let cmm_sub_ugc_urls_list = [];

      // ugc_urlsをUGC検索欄にローカルストレージから自動で反映させる処理
      if (localStorage.getItem('cmm_main_ugc_urls_list')) {
        lstorage_cmm_main_ugc_urls_list = localStorage.getItem('cmm_main_ugc_urls_list');
        lstorage_cmm_main_ugc_urls_list = JSON.parse(lstorage_cmm_main_ugc_urls_list);
        cmm_main_ugc_urls_list = lstorage_cmm_main_ugc_urls_list;
        lstorage_cmm_main_ugc_urls_list_str = lstorage_cmm_main_ugc_urls_list.join('\n');
        $('#cmm_main_ugc_urls').text(lstorage_cmm_main_ugc_urls_list_str);
      }

      // localStorageでメディアタイプの初期チェック状態を管理する
      let cmm_sub_media_type_pic = get_local_storage_item_checked('cmm_sub_media_type_pic');
      let cmm_sub_media_type_carousel = get_local_storage_item_checked('cmm_sub_media_type_carousel');
      let cmm_sub_media_type_video = get_local_storage_item_checked('cmm_sub_media_type_video');

      // localStorageでステータスの初期チェック状態を管理する
      let cmm_sub_status_waiting_reply = get_local_storage_item_checked('cmm_sub_status_waiting_reply');
      let cmm_sub_status_waiting_seven_days = get_local_storage_item_checked('cmm_sub_status_waiting_seven_days');

      // localStorageでinput要素のテキスト状態を管理する
      // get_local_storage_item_overwrite_value('cmm_sub_username'); なし
      let cmm_sub_comment_keyword = get_local_storage_item_overwrite_value('cmm_sub_comment_keyword');
      let cmm_sub_initial_date = get_local_storage_item_overwrite_value('cmm_sub_initial_date');
      let cmm_sub_end_date = get_local_storage_item_overwrite_value('cmm_sub_end_date');
      let cmm_sub_per_page_num = get_local_storage_item_overwrite_value('cmm_sub_per_page_num');

      // 初期値を設定 = 最新の返信順
      let cmm_sub_display_order = get_local_storage_item_selected('cmm_sub_display_order') || 'latest_replied_order';

      // ugc_urlsをUGC検索欄にローカルストレージから自動で反映させる処理
      if (localStorage.getItem('cmm_sub_ugc_urls_list')) {
        lstorage_cmm_sub_ugc_urls_list = localStorage.getItem('cmm_sub_ugc_urls_list');
        lstorage_cmm_sub_ugc_urls_list = JSON.parse(lstorage_cmm_sub_ugc_urls_list);
        cmm_sub_ugc_urls_list = lstorage_cmm_sub_ugc_urls_list;
        lstorage_cmm_sub_ugc_urls_list_str = lstorage_cmm_sub_ugc_urls_list.join('\n');
        $('#cmm_sub_ugc_urls').text(lstorage_cmm_sub_ugc_urls_list_str);
      }

      let variable_list = [cmm_main_initial_date, cmm_main_end_date, cmm_main_media_type_pic, cmm_main_media_type_carousel, cmm_main_media_type_video, cmm_main_status_need_confirm, cmm_main_status_ok_ugc, cmm_main_status_ng_ugc, cmm_main_status_done_ugc, cmm_main_status_cancel_ugc, cmm_main_username, cmm_main_comment_keyword, cmm_main_per_page_num, cmm_sub_initial_date, cmm_sub_end_date, cmm_sub_status_waiting_reply, cmm_sub_status_waiting_seven_days, cmm_sub_media_type_pic, cmm_sub_media_type_carousel, cmm_sub_media_type_video, cmm_sub_comment_keyword, cmm_sub_per_page_num];

      // 一つでも undefinedがあればtrueを返す
      let isAnyUndefined = variable_list.some((v) => typeof v === 'undefined');

      let cmm_url_path;

      // #############################################################
      // 絞り込み条件を一つも入れていない状態(localStorageに何も保存されていなかった場合)、全てのチェックがついた状態で検索結果を表示させる
      // #############################################################

      // 全てが undefinedがあればtrueを返す
      // let isAllUndefined = variable_list.every((v) => typeof v === 'undefined');

      if (isAnyUndefined == true) {
        let today = new Date().toISOString().split('T')[0];
        let cmm_main_initial_date = cmm_main_initial_date ? cmm_main_initial_date : '2021-01-01';
        let cmm_sub_initial_date = cmm_sub_initial_date ? cmm_sub_initial_date : '2021-01-01';
        let cmm_main_end_date = cmm_main_end_date ? cmm_main_end_date : today;
        let cmm_sub_end_date = cmm_sub_end_date ? cmm_sub_end_date : today;
        let cmm_main_per_page_num = cmm_main_per_page_num ? cmm_main_per_page_num : '2021-01-01';
        let cmm_sub_per_page_num = cmm_sub_per_page_num ? cmm_sub_per_page_num : '2021-01-01';
        let media_type = 'exist';
        let status_type = 'exist';
        let input_value_empty = '';

        // alert('true...1');

        // -main-sub
        cmm_url_path = `/communication_management?&cmm_main_initial_date=${cmm_main_initial_date}&cmm_main_end_date=${cmm_main_end_date}&cmm_main_media_type_pic=${media_type}&cmm_main_media_type_carousel=${media_type}&cmm_main_media_type_video=${media_type}&cmm_main_status_need_confirm=${status_type}&cmm_main_status_ok_ugc=${status_type}&cmm_main_status_ng_ugc=${status_type}&cmm_main_status_done_ugc=${status_type}&cmm_main_status_cancel_ugc=${cmm_main_status_cancel_ugc}&cmm_main_status_thanked_ugc=${cmm_main_status_thanked_ugc}&cmm_main_username=${input_value_empty}&cmm_main_comment_keyword=${input_value_empty}&cmm_main_per_page_num=${cmm_main_per_page_num}&cmm_main_display_order=${cmm_main_display_order}&cmm_sub_initial_date=${cmm_sub_initial_date}&cmm_sub_end_date=${cmm_sub_end_date}&cmm_sub_status_waiting_reply=${status_type}&cmm_sub_status_waiting_seven_days=${status_type}&cmm_sub_media_type_pic=${media_type}&cmm_sub_media_type_carousel=${media_type}&cmm_sub_media_type_video=${media_type}&cmm_sub_comment_keyword=${input_value_empty}&cmm_sub_per_page_num=${cmm_sub_per_page_num}&cmm_sub_display_order=${cmm_sub_display_order}&initial_state=1`;
        // } else if (isAnyUndefined != true) {
      } else if (isAnyUndefined == false) {
        // alert('true...2');

        cmm_url_path = `/communication_management?&cmm_main_initial_date=${cmm_main_initial_date}&cmm_main_end_date=${cmm_main_end_date}&cmm_main_media_type_pic=${cmm_main_media_type_pic}&cmm_main_media_type_carousel=${cmm_main_media_type_carousel}&cmm_main_media_type_video=${cmm_main_media_type_video}&cmm_main_status_need_confirm=${cmm_main_status_need_confirm}&cmm_main_status_ok_ugc=${cmm_main_status_ok_ugc}&cmm_main_status_ng_ugc=${cmm_main_status_ng_ugc}&cmm_main_status_done_ugc=${cmm_main_status_done_ugc}&cmm_main_status_cancel_ugc=${cmm_main_status_cancel_ugc}&cmm_main_status_thanked_ugc=${cmm_main_status_thanked_ugc}&cmm_main_username=${cmm_main_username}&cmm_main_comment_keyword=${cmm_main_comment_keyword}&cmm_main_per_page_num=${cmm_main_per_page_num}&cmm_main_display_order=${cmm_main_display_order}&cmm_sub_initial_date=${cmm_sub_initial_date}&cmm_sub_end_date=${cmm_sub_end_date}&cmm_sub_status_waiting_reply=${cmm_sub_status_waiting_reply}&cmm_sub_status_waiting_seven_days=${cmm_sub_status_waiting_seven_days}&cmm_sub_media_type_pic=${cmm_sub_media_type_pic}&cmm_sub_media_type_carousel=${cmm_sub_media_type_carousel}&cmm_sub_media_type_video=${cmm_sub_media_type_video}&cmm_sub_comment_keyword=${cmm_sub_comment_keyword}&cmm_sub_per_page_num=${cmm_sub_per_page_num}&cmm_sub_display_order=${cmm_sub_display_order}&stop=1`;
      } else {
        // alert('true...3');

        let today = new Date().toISOString().split('T')[0];
        let cmm_main_initial_date = cmm_main_initial_date ? cmm_main_initial_date : '2022-01-01';
        let cmm_sub_initial_date = cmm_sub_initial_date ? cmm_sub_initial_date : '2022-01-01';
        let cmm_main_end_date = cmm_main_end_date ? cmm_main_end_date : today;
        let cmm_sub_end_date = cmm_sub_end_date ? cmm_sub_end_date : today;
        let cmm_main_per_page_num = cmm_main_per_page_num ? cmm_main_per_page_num : '2022-01-01';
        let cmm_sub_per_page_num = cmm_sub_per_page_num ? cmm_sub_per_page_num : '2022-01-01';
        let media_type = 'exist';
        let status_type = 'exist';
        let input_value_empty = '';

        cmm_url_path = `/communication_management?&cmm_main_initial_date=${cmm_main_initial_date}&cmm_main_end_date=${cmm_main_end_date}&cmm_main_media_type_pic=${media_type}&cmm_main_media_type_carousel=${media_type}&cmm_main_media_type_video=${media_type}&cmm_main_status_need_confirm=${status_type}&cmm_main_status_ok_ugc=${status_type}&cmm_main_status_ng_ugc=${status_type}&cmm_main_status_done_ugc=${status_type}&cmm_main_status_cancel_ugc=${cmm_main_status_cancel_ugc}&cmm_main_username=${input_value_empty}&cmm_main_comment_keyword=${input_value_empty}&cmm_main_per_page_num=${cmm_main_per_page_num}&cmm_sub_initial_date=${cmm_sub_initial_date}&cmm_sub_end_date=${cmm_sub_end_date}&cmm_sub_status_waiting_reply=${status_type}&cmm_sub_status_waiting_seven_days=${status_type}&cmm_sub_media_type_pic=${media_type}&cmm_sub_media_type_carousel=${media_type}&cmm_sub_media_type_video=${media_type}&cmm_sub_comment_keyword=${input_value_empty}&cmm_sub_per_page_num=${cmm_sub_per_page_num}&cmm_main_display_order=${cmm_main_display_order}&stop=1`;
      }

      location.href = cmm_url_path;
    });
  });

  // コミュニケーション管理でローカルストレージに何も情報がなかった場合、はじめから絞り込みのチェックを全て入れておく処理
  if (current_url.includes('initial_state=1')) {
    $('.cmm_main__filter input:not(#cmm_main_status_hidden)').prop('checked', true);
    $('.cmm_sub__filter input').prop('checked', true);
  }


  $('.open-modal').on('click', function (e) {
    $('.def-modal-background').fadeIn(360);
    $('.def-modal-form').fadeIn(360);
  });

  $('.close-modal').on('click', function (e) {
    $('.def-modal-background').fadeOut(160);
    $('.def-modal-form').fadeOut(160);
  });

  $('.download-comment').on('click', function (e) {
    let href = '/insight/download_comment';
    href += `?media_id=${$(this).data("val")}`;
    location.href = href;
  });

  $('.search-post-comment').on('click', function (e) {
    let href = '/insight/comment_downloads';
    href += `?caption=${$("#search_caption").val()}`;
    location.href = href;
  });

  // ---------------------------------------------------------------------------------
  // カスタマイズ
  // ---------------------------------------------------------------------------------
  // 10009向けカスタマイズ
  // excluded_wordsをページを移動しても保持
  if (current_url.includes('hashtag_list') && $('#account_id').val()=="10009") {
    $('#excluded_words').on('focusout', function() {
      let excluded_words = $(this).val();
      localStorage.setItem('hashtag_list_excluded_words', excluded_words);
    });
    $('#excluded_words').val(localStorage.getItem('hashtag_list_excluded_words'));
  } 
});

// ハッシュタグ一覧 投稿された期間のデフォルト値設定
function getDefaultHashtagDates() {
  const hashtagInitialDate = "2021-01-01" // 昔のデータも参照したい場合が多いため

  const todayEndOfDay = new Date();
  todayEndOfDay.setHours(23, 59, 59, 999); // 23:59:59.999に設定

  // 日付をYYYY-MM-DD形式の文字列にフォーマット
  const hashtagEndDate = todayEndOfDay.toISOString().split('T')[0];

  return { hashtagInitialDate, hashtagEndDate };
}

